(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bg.dW === region.bz.dW)
	{
		return 'on line ' + region.bg.dW;
	}
	return 'on lines ' + region.bg.dW + ' through ' + region.bz.dW;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dN,
		impl.e8,
		impl.eW,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		d$: func(record.d$),
		eU: record.eU,
		ey: record.ey
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.d$;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.eU;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ey) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dN,
		impl.e8,
		impl.eW,
		function(sendToApp, initialModel) {
			var view = impl.fb;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dN,
		impl.e8,
		impl.eW,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.be && impl.be(sendToApp)
			var view = impl.fb;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.cZ);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.e3) && (_VirtualDom_doc.title = title = doc.e3);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.en;
	var onUrlRequest = impl.eo;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		be: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.cq === next.cq
							&& curr.bK === next.bK
							&& curr.cn.a === next.cn.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		dN: function(flags)
		{
			return A3(impl.dN, flags, _Browser_getUrl(), key);
		},
		fb: impl.fb,
		e8: impl.e8,
		eW: impl.eW
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { dH: 'hidden', c3: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { dH: 'mozHidden', c3: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { dH: 'msHidden', c3: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { dH: 'webkitHidden', c3: 'webkitvisibilitychange' }
		: { dH: 'hidden', c3: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		cx: _Browser_getScene(),
		cR: {
			I: _Browser_window.pageXOffset,
			J: _Browser_window.pageYOffset,
			fc: _Browser_doc.documentElement.clientWidth,
			dG: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fc: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		dG: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			cx: {
				fc: node.scrollWidth,
				dG: node.scrollHeight
			},
			cR: {
				I: node.scrollLeft,
				J: node.scrollTop,
				fc: node.clientWidth,
				dG: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			cx: _Browser_getScene(),
			cR: {
				I: x,
				J: y,
				fc: _Browser_doc.documentElement.clientWidth,
				dG: _Browser_doc.documentElement.clientHeight
			},
			dq: {
				I: x + rect.left,
				J: y + rect.top,
				fc: rect.width,
				dG: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.d5) { flags += 'm'; }
	if (options.c2) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


/*
 * Copyright (c) 2010 Mozilla Corporation
 * Copyright (c) 2010 Vladimir Vukicevic
 * Copyright (c) 2013 John Mayer
 * Copyright (c) 2018 Andrey Kuzmin
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

// Vector2

var _MJS_v2 = F2(function(x, y) {
    return new Float64Array([x, y]);
});

var _MJS_v2getX = function(a) {
    return a[0];
};

var _MJS_v2getY = function(a) {
    return a[1];
};

var _MJS_v2setX = F2(function(x, a) {
    return new Float64Array([x, a[1]]);
});

var _MJS_v2setY = F2(function(y, a) {
    return new Float64Array([a[0], y]);
});

var _MJS_v2toRecord = function(a) {
    return { I: a[0], J: a[1] };
};

var _MJS_v2fromRecord = function(r) {
    return new Float64Array([r.I, r.J]);
};

var _MJS_v2add = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    return r;
});

var _MJS_v2sub = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    return r;
});

var _MJS_v2negate = function(a) {
    var r = new Float64Array(2);
    r[0] = -a[0];
    r[1] = -a[1];
    return r;
};

var _MJS_v2direction = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    var im = 1.0 / _MJS_v2lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    return r;
});

function _MJS_v2lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
var _MJS_v2length = _MJS_v2lengthLocal;

var _MJS_v2lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1];
};

var _MJS_v2distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return Math.sqrt(dx * dx + dy * dy);
});

var _MJS_v2distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return dx * dx + dy * dy;
});

var _MJS_v2normalize = function(a) {
    var r = new Float64Array(2);
    var im = 1.0 / _MJS_v2lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    return r;
};

var _MJS_v2scale = F2(function(k, a) {
    var r = new Float64Array(2);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    return r;
});

var _MJS_v2dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
});

// Vector3

var _MJS_v3temp1Local = new Float64Array(3);
var _MJS_v3temp2Local = new Float64Array(3);
var _MJS_v3temp3Local = new Float64Array(3);

var _MJS_v3 = F3(function(x, y, z) {
    return new Float64Array([x, y, z]);
});

var _MJS_v3getX = function(a) {
    return a[0];
};

var _MJS_v3getY = function(a) {
    return a[1];
};

var _MJS_v3getZ = function(a) {
    return a[2];
};

var _MJS_v3setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2]]);
});

var _MJS_v3setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2]]);
});

var _MJS_v3setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z]);
});

var _MJS_v3toRecord = function(a) {
    return { I: a[0], J: a[1], aT: a[2] };
};

var _MJS_v3fromRecord = function(r) {
    return new Float64Array([r.I, r.J, r.aT]);
};

var _MJS_v3add = F2(function(a, b) {
    var r = new Float64Array(3);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    return r;
});

function _MJS_v3subLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    return r;
}
var _MJS_v3sub = F2(_MJS_v3subLocal);

var _MJS_v3negate = function(a) {
    var r = new Float64Array(3);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    return r;
};

function _MJS_v3directionLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    return _MJS_v3normalizeLocal(_MJS_v3subLocal(a, b, r), r);
}
var _MJS_v3direction = F2(_MJS_v3directionLocal);

function _MJS_v3lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
}
var _MJS_v3length = _MJS_v3lengthLocal;

var _MJS_v3lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
};

var _MJS_v3distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
});

var _MJS_v3distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return dx * dx + dy * dy + dz * dz;
});

function _MJS_v3normalizeLocal(a, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    var im = 1.0 / _MJS_v3lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    return r;
}
var _MJS_v3normalize = _MJS_v3normalizeLocal;

var _MJS_v3scale = F2(function(k, a) {
    return new Float64Array([a[0] * k, a[1] * k, a[2] * k]);
});

var _MJS_v3dotLocal = function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};
var _MJS_v3dot = F2(_MJS_v3dotLocal);

function _MJS_v3crossLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[1] * b[2] - a[2] * b[1];
    r[1] = a[2] * b[0] - a[0] * b[2];
    r[2] = a[0] * b[1] - a[1] * b[0];
    return r;
}
var _MJS_v3cross = F2(_MJS_v3crossLocal);

var _MJS_v3mul4x4 = F2(function(m, v) {
    var w;
    var tmp = _MJS_v3temp1Local;
    var r = new Float64Array(3);

    tmp[0] = m[3];
    tmp[1] = m[7];
    tmp[2] = m[11];
    w = _MJS_v3dotLocal(v, tmp) + m[15];
    tmp[0] = m[0];
    tmp[1] = m[4];
    tmp[2] = m[8];
    r[0] = (_MJS_v3dotLocal(v, tmp) + m[12]) / w;
    tmp[0] = m[1];
    tmp[1] = m[5];
    tmp[2] = m[9];
    r[1] = (_MJS_v3dotLocal(v, tmp) + m[13]) / w;
    tmp[0] = m[2];
    tmp[1] = m[6];
    tmp[2] = m[10];
    r[2] = (_MJS_v3dotLocal(v, tmp) + m[14]) / w;
    return r;
});

// Vector4

var _MJS_v4 = F4(function(x, y, z, w) {
    return new Float64Array([x, y, z, w]);
});

var _MJS_v4getX = function(a) {
    return a[0];
};

var _MJS_v4getY = function(a) {
    return a[1];
};

var _MJS_v4getZ = function(a) {
    return a[2];
};

var _MJS_v4getW = function(a) {
    return a[3];
};

var _MJS_v4setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2], a[3]]);
});

var _MJS_v4setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2], a[3]]);
});

var _MJS_v4setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z, a[3]]);
});

var _MJS_v4setW = F2(function(w, a) {
    return new Float64Array([a[0], a[1], a[2], w]);
});

var _MJS_v4toRecord = function(a) {
    return { I: a[0], J: a[1], aT: a[2], cS: a[3] };
};

var _MJS_v4fromRecord = function(r) {
    return new Float64Array([r.I, r.J, r.aT, r.cS]);
};

var _MJS_v4add = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    r[3] = a[3] + b[3];
    return r;
});

var _MJS_v4sub = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    return r;
});

var _MJS_v4negate = function(a) {
    var r = new Float64Array(4);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    r[3] = -a[3];
    return r;
};

var _MJS_v4direction = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    var im = 1.0 / _MJS_v4lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    r[2] = r[2] * im;
    r[3] = r[3] * im;
    return r;
});

function _MJS_v4lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3]);
}
var _MJS_v4length = _MJS_v4lengthLocal;

var _MJS_v4lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3];
};

var _MJS_v4distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
});

var _MJS_v4distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return dx * dx + dy * dy + dz * dz + dw * dw;
});

var _MJS_v4normalize = function(a) {
    var r = new Float64Array(4);
    var im = 1.0 / _MJS_v4lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    r[3] = a[3] * im;
    return r;
};

var _MJS_v4scale = F2(function(k, a) {
    var r = new Float64Array(4);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    r[2] = a[2] * k;
    r[3] = a[3] * k;
    return r;
});

var _MJS_v4dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
});

// Matrix4

var _MJS_m4x4temp1Local = new Float64Array(16);
var _MJS_m4x4temp2Local = new Float64Array(16);

var _MJS_m4x4identity = new Float64Array([
    1.0, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    0.0, 0.0, 0.0, 1.0
]);

var _MJS_m4x4fromRecord = function(r) {
    var m = new Float64Array(16);
    m[0] = r.bT;
    m[1] = r.bX;
    m[2] = r.b$;
    m[3] = r.b3;
    m[4] = r.bU;
    m[5] = r.bY;
    m[6] = r.b0;
    m[7] = r.b4;
    m[8] = r.bV;
    m[9] = r.bZ;
    m[10] = r.b1;
    m[11] = r.b5;
    m[12] = r.bW;
    m[13] = r.b_;
    m[14] = r.b2;
    m[15] = r.b6;
    return m;
};

var _MJS_m4x4toRecord = function(m) {
    return {
        bT: m[0], bX: m[1], b$: m[2], b3: m[3],
        bU: m[4], bY: m[5], b0: m[6], b4: m[7],
        bV: m[8], bZ: m[9], b1: m[10], b5: m[11],
        bW: m[12], b_: m[13], b2: m[14], b6: m[15]
    };
};

var _MJS_m4x4inverse = function(m) {
    var r = new Float64Array(16);

    r[0] = m[5] * m[10] * m[15] - m[5] * m[11] * m[14] - m[9] * m[6] * m[15] +
        m[9] * m[7] * m[14] + m[13] * m[6] * m[11] - m[13] * m[7] * m[10];
    r[4] = -m[4] * m[10] * m[15] + m[4] * m[11] * m[14] + m[8] * m[6] * m[15] -
        m[8] * m[7] * m[14] - m[12] * m[6] * m[11] + m[12] * m[7] * m[10];
    r[8] = m[4] * m[9] * m[15] - m[4] * m[11] * m[13] - m[8] * m[5] * m[15] +
        m[8] * m[7] * m[13] + m[12] * m[5] * m[11] - m[12] * m[7] * m[9];
    r[12] = -m[4] * m[9] * m[14] + m[4] * m[10] * m[13] + m[8] * m[5] * m[14] -
        m[8] * m[6] * m[13] - m[12] * m[5] * m[10] + m[12] * m[6] * m[9];
    r[1] = -m[1] * m[10] * m[15] + m[1] * m[11] * m[14] + m[9] * m[2] * m[15] -
        m[9] * m[3] * m[14] - m[13] * m[2] * m[11] + m[13] * m[3] * m[10];
    r[5] = m[0] * m[10] * m[15] - m[0] * m[11] * m[14] - m[8] * m[2] * m[15] +
        m[8] * m[3] * m[14] + m[12] * m[2] * m[11] - m[12] * m[3] * m[10];
    r[9] = -m[0] * m[9] * m[15] + m[0] * m[11] * m[13] + m[8] * m[1] * m[15] -
        m[8] * m[3] * m[13] - m[12] * m[1] * m[11] + m[12] * m[3] * m[9];
    r[13] = m[0] * m[9] * m[14] - m[0] * m[10] * m[13] - m[8] * m[1] * m[14] +
        m[8] * m[2] * m[13] + m[12] * m[1] * m[10] - m[12] * m[2] * m[9];
    r[2] = m[1] * m[6] * m[15] - m[1] * m[7] * m[14] - m[5] * m[2] * m[15] +
        m[5] * m[3] * m[14] + m[13] * m[2] * m[7] - m[13] * m[3] * m[6];
    r[6] = -m[0] * m[6] * m[15] + m[0] * m[7] * m[14] + m[4] * m[2] * m[15] -
        m[4] * m[3] * m[14] - m[12] * m[2] * m[7] + m[12] * m[3] * m[6];
    r[10] = m[0] * m[5] * m[15] - m[0] * m[7] * m[13] - m[4] * m[1] * m[15] +
        m[4] * m[3] * m[13] + m[12] * m[1] * m[7] - m[12] * m[3] * m[5];
    r[14] = -m[0] * m[5] * m[14] + m[0] * m[6] * m[13] + m[4] * m[1] * m[14] -
        m[4] * m[2] * m[13] - m[12] * m[1] * m[6] + m[12] * m[2] * m[5];
    r[3] = -m[1] * m[6] * m[11] + m[1] * m[7] * m[10] + m[5] * m[2] * m[11] -
        m[5] * m[3] * m[10] - m[9] * m[2] * m[7] + m[9] * m[3] * m[6];
    r[7] = m[0] * m[6] * m[11] - m[0] * m[7] * m[10] - m[4] * m[2] * m[11] +
        m[4] * m[3] * m[10] + m[8] * m[2] * m[7] - m[8] * m[3] * m[6];
    r[11] = -m[0] * m[5] * m[11] + m[0] * m[7] * m[9] + m[4] * m[1] * m[11] -
        m[4] * m[3] * m[9] - m[8] * m[1] * m[7] + m[8] * m[3] * m[5];
    r[15] = m[0] * m[5] * m[10] - m[0] * m[6] * m[9] - m[4] * m[1] * m[10] +
        m[4] * m[2] * m[9] + m[8] * m[1] * m[6] - m[8] * m[2] * m[5];

    var det = m[0] * r[0] + m[1] * r[4] + m[2] * r[8] + m[3] * r[12];

    if (det === 0) {
        return $elm$core$Maybe$Nothing;
    }

    det = 1.0 / det;

    for (var i = 0; i < 16; i = i + 1) {
        r[i] = r[i] * det;
    }

    return $elm$core$Maybe$Just(r);
};

var _MJS_m4x4inverseOrthonormal = function(m) {
    var r = _MJS_m4x4transposeLocal(m);
    var t = [m[12], m[13], m[14]];
    r[3] = r[7] = r[11] = 0;
    r[12] = -_MJS_v3dotLocal([r[0], r[4], r[8]], t);
    r[13] = -_MJS_v3dotLocal([r[1], r[5], r[9]], t);
    r[14] = -_MJS_v3dotLocal([r[2], r[6], r[10]], t);
    return r;
};

function _MJS_m4x4makeFrustumLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 * znear / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 * znear / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = (right + left) / (right - left);
    r[9] = (top + bottom) / (top - bottom);
    r[10] = -(zfar + znear) / (zfar - znear);
    r[11] = -1;
    r[12] = 0;
    r[13] = 0;
    r[14] = -2 * zfar * znear / (zfar - znear);
    r[15] = 0;

    return r;
}
var _MJS_m4x4makeFrustum = F6(_MJS_m4x4makeFrustumLocal);

var _MJS_m4x4makePerspective = F4(function(fovy, aspect, znear, zfar) {
    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
    var ymin = -ymax;
    var xmin = ymin * aspect;
    var xmax = ymax * aspect;

    return _MJS_m4x4makeFrustumLocal(xmin, xmax, ymin, ymax, znear, zfar);
});

function _MJS_m4x4makeOrthoLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = -2 / (zfar - znear);
    r[11] = 0;
    r[12] = -(right + left) / (right - left);
    r[13] = -(top + bottom) / (top - bottom);
    r[14] = -(zfar + znear) / (zfar - znear);
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeOrtho = F6(_MJS_m4x4makeOrthoLocal);

var _MJS_m4x4makeOrtho2D = F4(function(left, right, bottom, top) {
    return _MJS_m4x4makeOrthoLocal(left, right, bottom, top, -1, 1);
});

function _MJS_m4x4mulLocal(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a41 = a[3];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a42 = a[7];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a43 = a[11];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];
    var a44 = a[15];
    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b41 = b[3];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b42 = b[7];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b43 = b[11];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];
    var b44 = b[15];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    r[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    r[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    r[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    r[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

    return r;
}
var _MJS_m4x4mul = F2(_MJS_m4x4mulLocal);

var _MJS_m4x4mulAffine = F2(function(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];

    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31;
    r[3] = 0;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32;
    r[7] = 0;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33;
    r[11] = 0;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34;
    r[15] = 1;

    return r;
});

var _MJS_m4x4makeRotate = F2(function(angle, axis) {
    var r = new Float64Array(16);
    axis = _MJS_v3normalizeLocal(axis, _MJS_v3temp1Local);
    var x = axis[0];
    var y = axis[1];
    var z = axis[2];
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);

    r[0] = x * x * c1 + c;
    r[1] = y * x * c1 + z * s;
    r[2] = z * x * c1 - y * s;
    r[3] = 0;
    r[4] = x * y * c1 - z * s;
    r[5] = y * y * c1 + c;
    r[6] = y * z * c1 + x * s;
    r[7] = 0;
    r[8] = x * z * c1 + y * s;
    r[9] = y * z * c1 - x * s;
    r[10] = z * z * c1 + c;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});

var _MJS_m4x4rotate = F3(function(angle, axis, m) {
    var r = new Float64Array(16);
    var im = 1.0 / _MJS_v3lengthLocal(axis);
    var x = axis[0] * im;
    var y = axis[1] * im;
    var z = axis[2] * im;
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);
    var xs = x * s;
    var ys = y * s;
    var zs = z * s;
    var xyc1 = x * y * c1;
    var xzc1 = x * z * c1;
    var yzc1 = y * z * c1;
    var t11 = x * x * c1 + c;
    var t21 = xyc1 + zs;
    var t31 = xzc1 - ys;
    var t12 = xyc1 - zs;
    var t22 = y * y * c1 + c;
    var t32 = yzc1 + xs;
    var t13 = xzc1 + ys;
    var t23 = yzc1 - xs;
    var t33 = z * z * c1 + c;
    var m11 = m[0], m21 = m[1], m31 = m[2], m41 = m[3];
    var m12 = m[4], m22 = m[5], m32 = m[6], m42 = m[7];
    var m13 = m[8], m23 = m[9], m33 = m[10], m43 = m[11];
    var m14 = m[12], m24 = m[13], m34 = m[14], m44 = m[15];

    r[0] = m11 * t11 + m12 * t21 + m13 * t31;
    r[1] = m21 * t11 + m22 * t21 + m23 * t31;
    r[2] = m31 * t11 + m32 * t21 + m33 * t31;
    r[3] = m41 * t11 + m42 * t21 + m43 * t31;
    r[4] = m11 * t12 + m12 * t22 + m13 * t32;
    r[5] = m21 * t12 + m22 * t22 + m23 * t32;
    r[6] = m31 * t12 + m32 * t22 + m33 * t32;
    r[7] = m41 * t12 + m42 * t22 + m43 * t32;
    r[8] = m11 * t13 + m12 * t23 + m13 * t33;
    r[9] = m21 * t13 + m22 * t23 + m23 * t33;
    r[10] = m31 * t13 + m32 * t23 + m33 * t33;
    r[11] = m41 * t13 + m42 * t23 + m43 * t33;
    r[12] = m14,
    r[13] = m24;
    r[14] = m34;
    r[15] = m44;

    return r;
});

function _MJS_m4x4makeScale3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = x;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = y;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = z;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeScale3 = F3(_MJS_m4x4makeScale3Local);

var _MJS_m4x4makeScale = function(v) {
    return _MJS_m4x4makeScale3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4scale3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

var _MJS_m4x4scale = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

function _MJS_m4x4makeTranslate3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = 1;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 1;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = 1;
    r[11] = 0;
    r[12] = x;
    r[13] = y;
    r[14] = z;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeTranslate3 = F3(_MJS_m4x4makeTranslate3Local);

var _MJS_m4x4makeTranslate = function(v) {
    return _MJS_m4x4makeTranslate3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4translate3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4translate = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4makeLookAt = F3(function(eye, center, up) {
    var z = _MJS_v3directionLocal(eye, center, _MJS_v3temp1Local);
    var x = _MJS_v3normalizeLocal(_MJS_v3crossLocal(up, z, _MJS_v3temp2Local), _MJS_v3temp2Local);
    var y = _MJS_v3normalizeLocal(_MJS_v3crossLocal(z, x, _MJS_v3temp3Local), _MJS_v3temp3Local);
    var tm1 = _MJS_m4x4temp1Local;
    var tm2 = _MJS_m4x4temp2Local;

    tm1[0] = x[0];
    tm1[1] = y[0];
    tm1[2] = z[0];
    tm1[3] = 0;
    tm1[4] = x[1];
    tm1[5] = y[1];
    tm1[6] = z[1];
    tm1[7] = 0;
    tm1[8] = x[2];
    tm1[9] = y[2];
    tm1[10] = z[2];
    tm1[11] = 0;
    tm1[12] = 0;
    tm1[13] = 0;
    tm1[14] = 0;
    tm1[15] = 1;

    tm2[0] = 1; tm2[1] = 0; tm2[2] = 0; tm2[3] = 0;
    tm2[4] = 0; tm2[5] = 1; tm2[6] = 0; tm2[7] = 0;
    tm2[8] = 0; tm2[9] = 0; tm2[10] = 1; tm2[11] = 0;
    tm2[12] = -eye[0]; tm2[13] = -eye[1]; tm2[14] = -eye[2]; tm2[15] = 1;

    return _MJS_m4x4mulLocal(tm1, tm2);
});


function _MJS_m4x4transposeLocal(m) {
    var r = new Float64Array(16);

    r[0] = m[0]; r[1] = m[4]; r[2] = m[8]; r[3] = m[12];
    r[4] = m[1]; r[5] = m[5]; r[6] = m[9]; r[7] = m[13];
    r[8] = m[2]; r[9] = m[6]; r[10] = m[10]; r[11] = m[14];
    r[12] = m[3]; r[13] = m[7]; r[14] = m[11]; r[15] = m[15];

    return r;
}
var _MJS_m4x4transpose = _MJS_m4x4transposeLocal;

var _MJS_m4x4makeBasis = F3(function(vx, vy, vz) {
    var r = new Float64Array(16);

    r[0] = vx[0];
    r[1] = vx[1];
    r[2] = vx[2];
    r[3] = 0;
    r[4] = vy[0];
    r[5] = vy[1];
    r[6] = vy[2];
    r[7] = 0;
    r[8] = vz[0];
    r[9] = vz[1];
    r[10] = vz[2];
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.bx))
		{
			lang = options.bx.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.dE.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.eX,
		breaks: gfm && gfm.c_,
		sanitize: options.eI,
		smartypants: options.eO
	};
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $author$project$Model$NavLocation = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$NavRequest = function (a) {
	return {$: 8, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.g) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.j),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.j);
		} else {
			var treeLen = builder.g * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.k) : builder.k;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.g);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.j) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.j);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{k: nodeList, g: (len / $elm$core$Array$branchFactor) | 0, j: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bD: fragment, bK: host, a7: path, cn: port_, cq: protocol, aJ: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Model$GraphError = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$GameData$graphMaxY = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.V;
	},
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.J;
		},
		$elm$core$Tuple$second));
var $author$project$GameData$graphMinY = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.V;
	},
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.J;
		},
		$elm$core$Tuple$first));
var $author$project$GameData$graphHeight = function (g) {
	return $author$project$GameData$graphMaxY(g) - $author$project$GameData$graphMinY(g);
};
var $author$project$GameData$graphMaxX = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.V;
	},
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.I;
		},
		$elm$core$Tuple$second));
var $author$project$GameData$graphMinX = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.V;
	},
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.I;
		},
		$elm$core$Tuple$first));
var $author$project$GameData$graphWidth = function (g) {
	return $author$project$GameData$graphMaxX(g) - $author$project$GameData$graphMinX(g);
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Model$nodeIconSize = 50;
var $author$project$Model$clampZoom = F2(
	function (window, graph) {
		var minZoom = A2(
			$elm$core$Basics$min,
			0.5,
			A2(
				$elm$core$Basics$min,
				window.fc / ($author$project$GameData$graphWidth(graph) + ($author$project$Model$nodeIconSize * 4)),
				window.dG / ($author$project$GameData$graphHeight(graph) + ($author$project$Model$nodeIconSize * 4))));
		return A2($elm$core$Basics$clamp, minZoom, 3);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$GameData$GameData = F2(
	function (versionList, byVersion) {
		return {bs: byVersion, cQ: versionList};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$GameData$GameVersionData = F3(
	function (versionSlug, stats, heroes) {
		return {bI: heroes, O: stats, fa: versionSlug};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$GameData$Stats$Stats = F3(
	function (rules, statValueFunctions, characters) {
		return {c6: characters, eG: rules, cE: statValueFunctions};
	});
var $author$project$GameData$Stats$Character = F2(
	function (stats, transcensionPerks) {
		return {O: stats, e6: transcensionPerks};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$GameData$Stats$BigClicks_damage = 36;
var $author$project$GameData$Stats$BigClicks_stacks = 35;
var $author$project$GameData$Stats$COLD_FRONT_ACTIVATION_CHANCE_PER_RANK = 89;
var $author$project$GameData$Stats$COLD_FRONT_DAMAGE_TRAIT = 90;
var $author$project$GameData$Stats$COLD_FRONT_DURATION_TRAIT = 91;
var $author$project$GameData$Stats$Clickstorm_cooldown = 39;
var $author$project$GameData$Stats$Energize_cooldown = 40;
var $author$project$GameData$Stats$Energize_duration = 42;
var $author$project$GameData$Stats$Energize_manaCost = 41;
var $author$project$GameData$Stats$FIRE_ADDITIONAL_PERCENT_DAMAGE = 57;
var $author$project$GameData$Stats$FIRE_BURN_PERCENT_DAMAGE_INCREASE = 56;
var $author$project$GameData$Stats$FIRE_COMBUSTION_CHANCE_PERCENT = 72;
var $author$project$GameData$Stats$FIRE_COMBUSTION_DURATION_SECONDS = 73;
var $author$project$GameData$Stats$FIRE_CORROSION_PERCENT_DAMAGE_INCREASE = 55;
var $author$project$GameData$Stats$FIRE_COST_REDUCTION_PERCENT_PER_LEVEL = 82;
var $author$project$GameData$Stats$FIRE_CRIT_DAMAGE_PERCENT = 63;
var $author$project$GameData$Stats$FIRE_EXPLOSION_DAMAGE_PERCENT = 76;
var $author$project$GameData$Stats$FIRE_INCENDIARY_COMBUSTION_CHANCE_PERCENT = 74;
var $author$project$GameData$Stats$FIRE_LIGHTNING_SYMBIOSIS = 93;
var $author$project$GameData$Stats$FIRE_SEETHING_COMBUSTION_DURATION_SECONDS = 75;
var $author$project$GameData$Stats$FIRE_ZAP_PERCENT_DAMAGE = 60;
var $author$project$GameData$Stats$HEAT_BURST_ACTIVATION_CHANCE_PER_RANK = 86;
var $author$project$GameData$Stats$HEAT_BURST_DAMAGE_TRAIT = 87;
var $author$project$GameData$Stats$HEAT_BURST_DURATION_TRAIT = 88;
var $author$project$GameData$Stats$HugeClick_damage = 37;
var $author$project$GameData$Stats$ICE_ADDITIONAL_PERCENT_DAMAGE = 51;
var $author$project$GameData$Stats$ICE_CHAIN_CHANCE_PERCENT = 59;
var $author$project$GameData$Stats$ICE_CHILLY_COOL_CRITICALS_CRIT_CHANCE_PERCENT = 66;
var $author$project$GameData$Stats$ICE_COLD_COOL_CRITICALS_DURATION_SECONDS = 67;
var $author$project$GameData$Stats$ICE_COOL_CRITICALS_CRIT_CHANCE_PERCENT = 64;
var $author$project$GameData$Stats$ICE_COOL_CRITICALS_DURATION_SECONDS = 65;
var $author$project$GameData$Stats$ICE_CORROSION_PERCENT_DAMAGE_INCREASE = 62;
var $author$project$GameData$Stats$ICE_COST_REDUCTION_PERCENT_PER_LEVEL = 80;
var $author$project$GameData$Stats$ICE_CRIT_DAMAGE_PERCENT = 50;
var $author$project$GameData$Stats$ICE_CRIT_PERCENT_CHANCE = 49;
var $author$project$GameData$Stats$ICE_FIRE_SYMBIOSIS = 94;
var $author$project$GameData$Stats$ICE_LIGHTNING_SYMBIOSIS = 92;
var $author$project$GameData$Stats$LIGHTNING_ADDITIONAL_PERCENT_DAMAGE = 54;
var $author$project$GameData$Stats$LIGHTNING_BURN_PERCENT_DAMAGE_INCREASE = 61;
var $author$project$GameData$Stats$LIGHTNING_CHAIN_PERCENT = 53;
var $author$project$GameData$Stats$LIGHTNING_CIRCUIT_DAMAGE_PERCENT = 77;
var $author$project$GameData$Stats$LIGHTNING_COST_REDUCTION_PERCENT_PER_LEVEL = 81;
var $author$project$GameData$Stats$LIGHTNING_CRIT_PERCENT_CHANCE = 58;
var $author$project$GameData$Stats$LIGHTNING_FLASHIER_FLASH_HASTE_PERCENT = 70;
var $author$project$GameData$Stats$LIGHTNING_FLASH_NUM_SPELLS = 69;
var $author$project$GameData$Stats$LIGHTNING_FLASH_SPEED_INCREASE_PERCENT = 68;
var $author$project$GameData$Stats$LIGHTNING_LINGERING_FLASH_NUM_SPELLS = 71;
var $author$project$GameData$Stats$LIGHTNING_ZAP_PERCENT_DAMAGE = 52;
var $author$project$GameData$Stats$ManaCrit_damage = 38;
var $author$project$GameData$Stats$MultiClick_energyCost = 34;
var $author$project$GameData$Stats$MultiClick_stacks = 33;
var $author$project$GameData$Stats$Powersurge_cooldown = 43;
var $author$project$GameData$Stats$Powersurge_damage = 46;
var $author$project$GameData$Stats$Powersurge_duration = 45;
var $author$project$GameData$Stats$Powersurge_manaCost = 44;
var $author$project$GameData$Stats$Reload_cooldown = 48;
var $author$project$GameData$Stats$Reload_effect = 47;
var $author$project$GameData$Stats$SHATTER_DAMAGE_PERCENT = 78;
var $author$project$GameData$Stats$SHATTER_NUM_MONSTERS = 79;
var $author$project$GameData$Stats$STAT_AUTOATTACK_DAMAGE = 32;
var $author$project$GameData$Stats$STAT_AUTOMATOR_SPEED = 31;
var $author$project$GameData$Stats$STAT_BONUS_GOLD_CHANCE = 7;
var $author$project$GameData$Stats$STAT_BOSS_GOLD = 18;
var $author$project$GameData$Stats$STAT_CLICKABLE_CHANCE = 19;
var $author$project$GameData$Stats$STAT_CLICKABLE_GOLD = 14;
var $author$project$GameData$Stats$STAT_CLICK_DAMAGE = 9;
var $author$project$GameData$Stats$STAT_CRIT_CHANCE = 4;
var $author$project$GameData$Stats$STAT_CRIT_DAMAGE = 3;
var $author$project$GameData$Stats$STAT_DAMAGE = 21;
var $author$project$GameData$Stats$STAT_ENERGY_COST_REDUCTION = 22;
var $author$project$GameData$Stats$STAT_ENERGY_REGEN = 20;
var $author$project$GameData$Stats$STAT_GOLD = 2;
var $author$project$GameData$Stats$STAT_HASTE = 1;
var $author$project$GameData$Stats$STAT_IDLE_DAMAGE = 10;
var $author$project$GameData$Stats$STAT_IDLE_GOLD = 0;
var $author$project$GameData$Stats$STAT_ITEM_BACK_DAMAGE = 30;
var $author$project$GameData$Stats$STAT_ITEM_CHEST_DAMAGE = 25;
var $author$project$GameData$Stats$STAT_ITEM_COST_REDUCTION = 8;
var $author$project$GameData$Stats$STAT_ITEM_FEET_DAMAGE = 29;
var $author$project$GameData$Stats$STAT_ITEM_HANDS_DAMAGE = 28;
var $author$project$GameData$Stats$STAT_ITEM_HEAD_DAMAGE = 24;
var $author$project$GameData$Stats$STAT_ITEM_LEGS_DAMAGE = 27;
var $author$project$GameData$Stats$STAT_ITEM_RING_DAMAGE = 26;
var $author$project$GameData$Stats$STAT_ITEM_WEAPON_DAMAGE = 23;
var $author$project$GameData$Stats$STAT_MANA_REGEN = 13;
var $author$project$GameData$Stats$STAT_MONSTER_GOLD = 17;
var $author$project$GameData$Stats$STAT_MOVEMENT_SPEED = 11;
var $author$project$GameData$Stats$STAT_PIERCE_CHANCE = 12;
var $author$project$GameData$Stats$STAT_TOTAL_ENERGY = 5;
var $author$project$GameData$Stats$STAT_TOTAL_MANA = 6;
var $author$project$GameData$Stats$STAT_TREASURE_CHEST_CHANCE = 15;
var $author$project$GameData$Stats$STAT_TREASURE_CHEST_GOLD = 16;
var $author$project$GameData$Stats$THUNDERSTORM_ACTIVATION_CHANCE_PER_RANK = 83;
var $author$project$GameData$Stats$THUNDERSTORM_DAMAGE_TRAIT = 84;
var $author$project$GameData$Stats$THUNDERSTORM_DURATION_TRAIT = 85;
var $author$project$GameData$Stats$statList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94]);
var $author$project$GameData$Stats$statToString = function (stat) {
	switch (stat) {
		case 0:
			return 'STAT_IDLE_GOLD';
		case 1:
			return 'STAT_HASTE';
		case 2:
			return 'STAT_GOLD';
		case 3:
			return 'STAT_CRIT_DAMAGE';
		case 4:
			return 'STAT_CRIT_CHANCE';
		case 5:
			return 'STAT_TOTAL_ENERGY';
		case 6:
			return 'STAT_TOTAL_MANA';
		case 7:
			return 'STAT_BONUS_GOLD_CHANCE';
		case 8:
			return 'STAT_ITEM_COST_REDUCTION';
		case 9:
			return 'STAT_CLICK_DAMAGE';
		case 10:
			return 'STAT_IDLE_DAMAGE';
		case 11:
			return 'STAT_MOVEMENT_SPEED';
		case 12:
			return 'STAT_PIERCE_CHANCE';
		case 13:
			return 'STAT_MANA_REGEN';
		case 14:
			return 'STAT_CLICKABLE_GOLD';
		case 15:
			return 'STAT_TREASURE_CHEST_CHANCE';
		case 16:
			return 'STAT_TREASURE_CHEST_GOLD';
		case 17:
			return 'STAT_MONSTER_GOLD';
		case 18:
			return 'STAT_BOSS_GOLD';
		case 19:
			return 'STAT_CLICKABLE_CHANCE';
		case 20:
			return 'STAT_ENERGY_REGEN';
		case 21:
			return 'STAT_DAMAGE';
		case 22:
			return 'STAT_ENERGY_COST_REDUCTION';
		case 23:
			return 'STAT_ITEM_WEAPON_DAMAGE';
		case 24:
			return 'STAT_ITEM_HEAD_DAMAGE';
		case 25:
			return 'STAT_ITEM_CHEST_DAMAGE';
		case 26:
			return 'STAT_ITEM_RING_DAMAGE';
		case 27:
			return 'STAT_ITEM_LEGS_DAMAGE';
		case 28:
			return 'STAT_ITEM_HANDS_DAMAGE';
		case 29:
			return 'STAT_ITEM_FEET_DAMAGE';
		case 30:
			return 'STAT_ITEM_BACK_DAMAGE';
		case 31:
			return 'STAT_AUTOMATOR_SPEED';
		case 32:
			return 'STAT_AUTOATTACK_DAMAGE';
		case 33:
			return 'MultiClick_stacks';
		case 34:
			return 'MultiClick_energyCost';
		case 35:
			return 'BigClicks_stacks';
		case 36:
			return 'BigClicks_damage';
		case 37:
			return 'HugeClick_damage';
		case 38:
			return 'ManaCrit_damage';
		case 39:
			return 'Clickstorm_cooldown';
		case 40:
			return 'Energize_cooldown';
		case 41:
			return 'Energize_manaCost';
		case 42:
			return 'Energize_duration';
		case 43:
			return 'Powersurge_cooldown';
		case 44:
			return 'Powersurge_manaCost';
		case 45:
			return 'Powersurge_duration';
		case 46:
			return 'Powersurge_damage';
		case 47:
			return 'Reload_effect';
		case 48:
			return 'Reload_cooldown';
		case 49:
			return 'ICE_CRIT_PERCENT_CHANCE';
		case 50:
			return 'ICE_CRIT_DAMAGE_PERCENT';
		case 51:
			return 'ICE_ADDITIONAL_PERCENT_DAMAGE';
		case 52:
			return 'LIGHTNING_ZAP_PERCENT_DAMAGE';
		case 53:
			return 'LIGHTNING_CHAIN_PERCENT';
		case 54:
			return 'LIGHTNING_ADDITIONAL_PERCENT_DAMAGE';
		case 55:
			return 'FIRE_CORROSION_PERCENT_DAMAGE_INCREASE';
		case 56:
			return 'FIRE_BURN_PERCENT_DAMAGE_INCREASE';
		case 57:
			return 'FIRE_ADDITIONAL_PERCENT_DAMAGE';
		case 58:
			return 'LIGHTNING_CRIT_PERCENT_CHANCE';
		case 59:
			return 'ICE_CHAIN_CHANCE_PERCENT';
		case 60:
			return 'FIRE_ZAP_PERCENT_DAMAGE';
		case 61:
			return 'LIGHTNING_BURN_PERCENT_DAMAGE_INCREASE';
		case 62:
			return 'ICE_CORROSION_PERCENT_DAMAGE_INCREASE';
		case 63:
			return 'FIRE_CRIT_DAMAGE_PERCENT';
		case 64:
			return 'ICE_COOL_CRITICALS_CRIT_CHANCE_PERCENT';
		case 65:
			return 'ICE_COOL_CRITICALS_DURATION_SECONDS';
		case 66:
			return 'ICE_CHILLY_COOL_CRITICALS_CRIT_CHANCE_PERCENT';
		case 67:
			return 'ICE_COLD_COOL_CRITICALS_DURATION_SECONDS';
		case 68:
			return 'LIGHTNING_FLASH_SPEED_INCREASE_PERCENT';
		case 69:
			return 'LIGHTNING_FLASH_NUM_SPELLS';
		case 70:
			return 'LIGHTNING_FLASHIER_FLASH_HASTE_PERCENT';
		case 71:
			return 'LIGHTNING_LINGERING_FLASH_NUM_SPELLS';
		case 72:
			return 'FIRE_COMBUSTION_CHANCE_PERCENT';
		case 73:
			return 'FIRE_COMBUSTION_DURATION_SECONDS';
		case 74:
			return 'FIRE_INCENDIARY_COMBUSTION_CHANCE_PERCENT';
		case 75:
			return 'FIRE_SEETHING_COMBUSTION_DURATION_SECONDS';
		case 76:
			return 'FIRE_EXPLOSION_DAMAGE_PERCENT';
		case 77:
			return 'LIGHTNING_CIRCUIT_DAMAGE_PERCENT';
		case 78:
			return 'SHATTER_DAMAGE_PERCENT';
		case 79:
			return 'SHATTER_NUM_MONSTERS';
		case 80:
			return 'ICE_COST_REDUCTION_PERCENT_PER_LEVEL';
		case 81:
			return 'LIGHTNING_COST_REDUCTION_PERCENT_PER_LEVEL';
		case 82:
			return 'FIRE_COST_REDUCTION_PERCENT_PER_LEVEL';
		case 83:
			return 'THUNDERSTORM_ACTIVATION_CHANCE_PER_RANK';
		case 84:
			return 'THUNDERSTORM_DAMAGE_TRAIT';
		case 85:
			return 'THUNDERSTORM_DURATION_TRAIT';
		case 86:
			return 'HEAT_BURST_ACTIVATION_CHANCE_PER_RANK';
		case 87:
			return 'HEAT_BURST_DAMAGE_TRAIT';
		case 88:
			return 'HEAT_BURST_DURATION_TRAIT';
		case 89:
			return 'COLD_FRONT_ACTIVATION_CHANCE_PER_RANK';
		case 90:
			return 'COLD_FRONT_DAMAGE_TRAIT';
		case 91:
			return 'COLD_FRONT_DURATION_TRAIT';
		case 92:
			return 'ICE_LIGHTNING_SYMBIOSIS';
		case 93:
			return 'FIRE_LIGHTNING_SYMBIOSIS';
		default:
			return 'ICE_FIRE_SYMBIOSIS';
	}
};
var $author$project$GameData$Stats$statDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (s) {
			return _Utils_Tuple2(
				$author$project$GameData$Stats$statToString(s),
				s);
		},
		$author$project$GameData$Stats$statList));
var $author$project$GameData$Stats$getStat = function (name) {
	return A2($elm$core$Dict$get, name, $author$project$GameData$Stats$statDict);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			list);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$GameData$Stats$charStatsByNodeType = A2(
	$elm$core$Basics$composeR,
	$elm$core$Dict$toList,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concatMap(
			function (_v0) {
				var statName = _v0.a;
				var nodes = _v0.b;
				return $elm_community$maybe_extra$Maybe$Extra$values(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var node = _v1.a;
							var levels = _v1.b;
							return A2(
								$elm$core$Maybe$map,
								function (stat) {
									return _Utils_Tuple2(
										node,
										_Utils_Tuple2(stat, levels));
								},
								$author$project$GameData$Stats$getStat(statName));
						},
						nodes));
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm_community$dict_extra$Dict$Extra$groupBy($elm$core$Tuple$first),
			$elm$core$Dict$map(
				$elm$core$Basics$always(
					$elm$core$List$map($elm$core$Tuple$second))))));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$GameData$Stats$charStatsDecoder = $elm$json$Json$Decode$dict(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int))),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$concat,
				$elm$json$Json$Decode$list(
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (prefix, _v0, level) {
								var start = _v0.a;
								var end = _v0.b;
								return A2(
									$elm$core$List$map,
									function (i) {
										return _Utils_Tuple2(
											_Utils_ap(
												prefix,
												$elm$core$String$fromInt(i)),
											level);
									},
									A2($elm$core$List$range, start, end));
							}),
						A2($elm$json$Json$Decode$field, 'prefix', $elm$json$Json$Decode$string),
						A2(
							$elm$json$Json$Decode$field,
							'range',
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int),
								A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int))),
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault(1),
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$int))))))
			])));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$GameData$Stats$TranscensionPerk = F2(
	function (costFunction, trait) {
		return {dd: costFunction, e5: trait};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$GameData$Stats$Constant = 7;
var $author$project$GameData$Stats$ExponentialMultiplier = 1;
var $author$project$GameData$Stats$Linear = 2;
var $author$project$GameData$Stats$LinearExponential = 6;
var $author$project$GameData$Stats$LinearReciprocal = 3;
var $author$project$GameData$Stats$LinearReciprocalComplement = 4;
var $author$project$GameData$Stats$Noop = 0;
var $author$project$GameData$Stats$OnePlusLinearReciprocalComplement = 5;
var $author$project$GameData$Stats$growthDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'noop':
				return $elm$json$Json$Decode$succeed(0);
			case 'exponentialMultiplier':
				return $elm$json$Json$Decode$succeed(1);
			case 'linear':
				return $elm$json$Json$Decode$succeed(2);
			case 'linearReciprocal':
				return $elm$json$Json$Decode$succeed(3);
			case 'linearReciprocalComplement':
				return $elm$json$Json$Decode$succeed(4);
			case 'onePlusLinearReciprocalComplement':
				return $elm$json$Json$Decode$succeed(5);
			case 'linearExponential':
				return $elm$json$Json$Decode$succeed(6);
			case 'constant':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('unknown stat growth function: ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$GameData$Stats$transcensionPerkDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'trait',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'costFunction',
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(
				$elm$json$Json$Decode$index,
				1,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$float)),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2($elm$json$Json$Decode$index, 0, $author$project$GameData$Stats$growthDecoder),
				$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))),
		$elm$json$Json$Decode$succeed($author$project$GameData$Stats$TranscensionPerk)));
var $author$project$GameData$Stats$charDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'transcensionPerks',
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(
				function (_v0) {
					var k = _v0.a;
					var v = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (ki) {
							return _Utils_Tuple2(ki, v);
						},
						$elm$core$String$toInt(k));
				}),
			$elm$core$Dict$fromList),
		$elm$json$Json$Decode$keyValuePairs($author$project$GameData$Stats$transcensionPerkDecoder)),
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stats',
		A2($elm$json$Json$Decode$map, $author$project$GameData$Stats$charStatsByNodeType, $author$project$GameData$Stats$charStatsDecoder),
		$elm$json$Json$Decode$succeed($author$project$GameData$Stats$Character)));
var $author$project$GameData$Stats$rules0 = {a$: false};
var $author$project$GameData$Stats$Rules = function (hasteAffectsDuration) {
	return {a$: hasteAffectsDuration};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$GameData$Stats$rulesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'hasteAffectsDuration',
	$elm$json$Json$Decode$bool,
	$author$project$GameData$Stats$rules0.a$,
	$elm$json$Json$Decode$succeed($author$project$GameData$Stats$Rules));
var $author$project$GameData$Stats$StatValue = F3(
	function (base, growth, args) {
		return {s: args, aU: base, bF: growth};
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$GameData$Stats$statValueDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$elm$json$Json$Decode$index,
		2,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $elm$json$Json$Decode$float)
				]))),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		A2($elm$json$Json$Decode$index, 1, $author$project$GameData$Stats$growthDecoder),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$float),
			$elm$json$Json$Decode$succeed($author$project$GameData$Stats$StatValue))));
var $author$project$GameData$Stats$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'characters',
	$elm$json$Json$Decode$dict($author$project$GameData$Stats$charDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'statValueFunctions',
		$elm$json$Json$Decode$dict($author$project$GameData$Stats$statValueDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'rules',
			$author$project$GameData$Stats$rulesDecoder,
			$author$project$GameData$Stats$rules0,
			$elm$json$Json$Decode$succeed($author$project$GameData$Stats$Stats))));
var $author$project$GameData$Character = F9(
	function (name, flavorName, flavorClass, flavor, nodeTypes, graph, skills, spells, transcensionPerks) {
		return {dy: flavor, dz: flavorClass, dA: flavorName, dF: graph, aA: name, ef: nodeTypes, eM: skills, cD: spells, e6: transcensionPerks};
	});
var $author$project$GameData$Node = F5(
	function (id, typeId, x, y, val) {
		return {z: id, cN: typeId, a: val, I: x, J: y};
	});
var $author$project$GameData$calcBounds = function (nodes) {
	return {
		I: _Utils_Tuple2(
			A3(
				$elm$core$List$foldr,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.I;
					},
					$elm$core$Basics$min),
				0,
				nodes),
			A3(
				$elm$core$List$foldr,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.I;
					},
					$elm$core$Basics$max),
				0,
				nodes)),
		J: _Utils_Tuple2(
			A3(
				$elm$core$List$foldr,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.J;
					},
					$elm$core$Basics$min),
				0,
				nodes),
			A3(
				$elm$core$List$foldr,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.J;
					},
					$elm$core$Basics$max),
				0,
				nodes))
	};
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $author$project$GameData$calcNeighbors = function () {
	var update = function (n2) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault($elm$core$Set$empty),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Set$insert(n2),
				$elm$core$Maybe$Just));
	};
	var fold = function (_v0) {
		var n1 = _v0.a;
		var n2 = _v0.b;
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Dict$update,
				n1.z,
				update(n2.z)),
			A2(
				$elm$core$Dict$update,
				n2.z,
				update(n1.z)));
	};
	return A2($elm$core$List$foldr, fold, $elm$core$Dict$empty);
}();
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $author$project$GameData$combineDict = function () {
	var fold = F2(
		function (k, rv) {
			return $elm$core$Result$andThen(
				function () {
					if (!rv.$) {
						var v = rv.a;
						return A2(
							$elm$core$Basics$composeR,
							A2($elm$core$Dict$insert, k, v),
							$elm$core$Result$Ok);
					} else {
						var err = rv.a;
						return $elm$core$Basics$always(
							$elm$core$Result$Err(
								_Utils_Tuple2(k, err)));
					}
				}());
		});
	return A2(
		$elm$core$Dict$foldl,
		fold,
		$elm$core$Result$Ok($elm$core$Dict$empty));
}();
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$GameData$graphDecoder = F2(
	function (nodeTypes, graphSpec) {
		var getNode = F2(
			function (id, n) {
				return A2(
					$elm$core$Result$fromMaybe,
					'no such node: ' + $elm$core$String$fromInt(id),
					A2(
						$elm$core$Maybe$map,
						A4($author$project$GameData$Node, id, n.a, n.I, n.J),
						A2($elm$core$Dict$get, n.a, nodeTypes)));
			});
		var _v0 = $author$project$GameData$combineDict(
			A2($elm$core$Dict$map, getNode, graphSpec.aj));
		if (_v0.$ === 1) {
			var _v1 = _v0.a;
			var k = _v1.a;
			var err = _v1.b;
			return $elm$json$Json$Decode$fail(
				$elm$core$String$fromInt(k) + (': ' + err));
		} else {
			var nodes = _v0.a;
			var getEdge = F2(
				function (_v5, _v6) {
					var a = _v6.a;
					var b = _v6.b;
					var _v4 = _Utils_Tuple2(
						A2($elm$core$Dict$get, a, nodes),
						A2($elm$core$Dict$get, b, nodes));
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var aa = _v4.a.a;
						var bb = _v4.b.a;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(aa, bb));
					} else {
						return $elm$core$Result$Err(
							'no such edge: (' + ($elm$core$String$fromInt(a) + (', ' + ($elm$core$String$fromInt(b) + ')'))));
					}
				});
			var _v2 = $author$project$GameData$combineDict(
				A2($elm$core$Dict$map, getEdge, graphSpec.at));
			if (_v2.$ === 1) {
				var _v3 = _v2.a;
				var k = _v3.a;
				var err = _v3.b;
				return $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(k) + (': ' + err));
			} else {
				var edges = _v2.a;
				return $elm$json$Json$Decode$succeed(
					{
						V: $author$project$GameData$calcBounds(
							$elm$core$Dict$values(nodes)),
						at: edges,
						a4: $author$project$GameData$calcNeighbors(
							$elm$core$Dict$values(edges)),
						aj: nodes,
						cd: A2(
							$elm$core$Dict$map,
							$elm$core$Basics$always(
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										function ($) {
											return $.z;
										}),
									$elm$core$Set$fromList)),
							A2(
								$elm_community$dict_extra$Dict$Extra$groupBy,
								function ($) {
									return $.cN;
								},
								$elm$core$Dict$values(nodes)))
					});
			}
		}
	});
var $author$project$GameData$GraphSpec = F2(
	function (edges, nodes) {
		return {at: edges, aj: nodes};
	});
var $author$project$GameData$decodeDictKeyInt = F2(
	function (name, _v0) {
		var key0 = _v0.a;
		var val = _v0.b;
		var _v1 = $elm$core$String$toInt(key0);
		if (!_v1.$) {
			var key = _v1.a;
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(key, val));
		} else {
			return $elm$json$Json$Decode$fail('couldn\'t decode ' + (name + ' dict key'));
		}
	});
var $author$project$GameData$edgeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		if ((list.b && list.b.b) && (!list.b.b.b)) {
			var a = list.a;
			var _v1 = list.b;
			var b = _v1.a;
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(a, b));
		} else {
			return $elm$json$Json$Decode$fail('couldn\'t decode levelGraphObject edge value');
		}
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int));
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GameData$NodeSpec = F3(
	function (val, x, y) {
		return {a: val, I: x, J: y};
	});
var $author$project$GameData$nodeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'y',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'x',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'val',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$GameData$NodeSpec))));
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$GameData$levelGraphObjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nodes',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$andThen,
				$author$project$GameData$decodeDictKeyInt('levelGraphObject node'),
				A2(
					$elm$json$Json$Decode$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Dict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							A2(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Decode$fail('couldn\'t decode levelGraphObject node dict'),
								$elm$json$Json$Decode$succeed))),
					$elm$json$Json$Decode$dict($author$project$GameData$nodeDecoder))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'edges',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Dict$fromList,
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$andThen,
					$author$project$GameData$decodeDictKeyInt('levelGraphObject edge'),
					A2(
						$elm$json$Json$Decode$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Dict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$head,
								A2(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$json$Json$Decode$fail('couldn\'t decode levelGraphObject edge dict'),
									$elm$json$Json$Decode$succeed))),
						$elm$json$Json$Decode$dict($author$project$GameData$edgeDecoder))))),
		$elm$json$Json$Decode$succeed($author$project$GameData$GraphSpec)));
var $author$project$GameData$dictKeyDecoder = function (decoder_) {
	var decode = F2(
		function (key, val) {
			var _v1 = A2(
				$elm$json$Json$Decode$decodeValue,
				decoder_(key),
				val);
			if (!_v1.$) {
				var ok = _v1.a;
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(key, ok));
			} else {
				var err = _v1.a;
				return $elm$json$Json$Decode$fail(
					$elm$json$Json$Decode$errorToString(err));
			}
		});
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$List$foldr,
				$elm$json$Json$Decode$map2($elm$core$List$cons),
				$elm$json$Json$Decode$succeed(_List_Nil)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return A2(decode, a, b);
					}),
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))));
};
var $author$project$GameData$NodeType = function (key) {
	return function (name) {
		return function (icon) {
			return function (newTooltip) {
				return function (oldTooltip) {
					return function (flavorText) {
						return function (alwaysAvailable) {
							return function (flammable) {
								return function (stats) {
									return function (quality) {
										return {bn: alwaysAvailable, dx: flammable, dB: flavorText, bL: icon, bP: key, aA: name, cb: newTooltip, cf: oldTooltip, eA: quality, O: stats};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$GameData$nodeTypeDecoder = F2(
	function (stats, key) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$succeed(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.O;
							},
							$elm$core$Dict$get(key)),
						stats))),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'flammable',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'alwaysAvailable',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'flavorText',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'tooltip',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'__ch2plan_tooltip',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'icon',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$elm$json$Json$Decode$succeed(key),
											$elm$json$Json$Decode$succeed($author$project$GameData$NodeType))))))))));
	});
var $author$project$GameData$Keystone = 2;
var $author$project$GameData$Notable = 1;
var $author$project$GameData$Plain = 0;
var $author$project$GameData$parseNodeQuality = function (id) {
	return A2($elm$core$String$startsWith, 'q', id) ? 1 : (A2($elm$core$String$startsWith, 'Q', id) ? 2 : 0);
};
var $author$project$GameData$nodeTypesDecoder = function (stats) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$map(
			function (k) {
				return function (v) {
					return v(
						$author$project$GameData$parseNodeQuality(k));
				};
			}),
		$author$project$GameData$dictKeyDecoder(
			$author$project$GameData$nodeTypeDecoder(stats)));
};
var $author$project$GameData$Spell = function (id) {
	return function (rank) {
		return function (types) {
			return function (runeCombination) {
				return function (spellRings) {
					return function (damageMultiplier) {
						return function (costMultiplier) {
							return function (msecsPerRune) {
								return function (spellPanelIcon) {
									return function (displayName) {
										return function (description) {
											return function (tier) {
												return function (manaCost) {
													return {de: costMultiplier, dh: damageMultiplier, by: description, $7: displayName, z: id, b7: manaCost, d4: msecsPerRune, ba: rank, eH: runeCombination, eP: spellPanelIcon, eQ: spellRings, e$: tier, cO: types};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$GameData$spellDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'manaCost',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tier',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'displayName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'spellPanelIcon',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'msecsPerRune',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'costMultiplier',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'damageMultiplier',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'spellRings',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'runeCombination',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'types',
											A2(
												$elm$json$Json$Decode$map,
												$elm$core$Set$fromList,
												$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'rank',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$GameData$Spell))))))))))))));
var $author$project$GameData$TranscensionPerk = F4(
	function (name, maxLevel, icon, description) {
		return {by: description, bL: icon, d_: maxLevel, aA: name};
	});
var $author$project$GameData$transcensionPerkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'icon',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'maxLevel',
			A2(
				$elm$json$Json$Decode$map,
				function (i) {
					return (i < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
				},
				$elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$GameData$TranscensionPerk)))));
var $author$project$GameData$characterDecoder = F2(
	function (skills, stats) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'transcensionPerks',
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filterMap(
						function (_v0) {
							var k = _v0.a;
							var v = _v0.b;
							return A2(
								$elm$core$Maybe$map,
								function (ki) {
									return _Utils_Tuple2(ki, v);
								},
								$elm$core$String$toInt(k));
						}),
					$elm$core$Dict$fromList),
				$elm$json$Json$Decode$keyValuePairs($author$project$GameData$transcensionPerkDecoder)),
			$elm$core$Dict$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'spells',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(_List_Nil),
					$elm$json$Json$Decode$nullable(
						$elm$json$Json$Decode$list($author$project$GameData$spellDecoder))),
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$elm$json$Json$Decode$succeed(skills),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2(
							$elm$json$Json$Decode$andThen,
							$elm$core$Basics$identity,
							A3(
								$elm$json$Json$Decode$map2,
								$author$project$GameData$graphDecoder,
								A2(
									$elm$json$Json$Decode$field,
									'levelGraphNodeTypes',
									$author$project$GameData$nodeTypesDecoder(stats)),
								A2($elm$json$Json$Decode$field, 'levelGraphObject', $author$project$GameData$levelGraphObjectDecoder))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'levelGraphNodeTypes',
							$author$project$GameData$nodeTypesDecoder(stats),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'flavor',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'flavorClass',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'flavorName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$GameData$Character))))))))));
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$GameData$heroesDecoder = F2(
	function (stats, skills) {
		return $author$project$GameData$dictKeyDecoder(
			function (name) {
				return A2(
					$author$project$GameData$characterDecoder,
					A2(
						$elm$core$Dict$filter,
						F2(
							function (k, v) {
								return _Utils_eq(v.bu, name);
							}),
						skills),
					A2($elm$core$Dict$get, name, stats.c6));
			});
	});
var $author$project$GameData$Skill = F7(
	function (id, name, iconId, _char, manaCost, energyCost, cooldown) {
		return {bu: _char, dc: cooldown, dr: energyCost, dI: iconId, z: id, b7: manaCost, aA: name};
	});
var $author$project$GameData$nonzeroIntDecoder = A2(
	$elm$json$Json$Decode$map,
	function (i) {
		return (!i) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(i);
	},
	$elm$json$Json$Decode$int);
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {dL: index, dZ: match, eg: number, eV: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{c2: false, d5: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$GameData$skillNameToId = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\\W+')),
	$elm$core$Basics$always(''));
var $author$project$GameData$skillDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cooldown',
	$author$project$GameData$nonzeroIntDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'energyCost',
		$author$project$GameData$nonzeroIntDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'manaCost',
			$author$project$GameData$nonzeroIntDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'char',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'iconId',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							A2($elm$json$Json$Decode$map, $author$project$GameData$skillNameToId, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$GameData$Skill))))))));
var $author$project$GameData$gameVersionDecoder = function () {
	var decoder_ = function (_v0) {
		var stats = _v0.a;
		var skills = _v0.b;
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'heroes',
			A2($author$project$GameData$heroesDecoder, stats, skills),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$elm$json$Json$Decode$succeed(stats),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'versionSlug',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$GameData$GameVersionData))));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decoder_,
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			A2($elm$json$Json$Decode$field, 'stats', $author$project$GameData$Stats$decoder),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault($elm$core$Dict$empty),
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$field,
						'skills',
						$elm$json$Json$Decode$dict($author$project$GameData$skillDecoder))))));
}();
var $author$project$GameData$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'byVersion',
	$elm$json$Json$Decode$dict($author$project$GameData$gameVersionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'versionList',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$GameData$GameData)));
var $author$project$Model$Runecorder$example1 = '/* Resource-neutral ice1 spam */\nloop 14 {\n    // First recording: maintain energon cube stacks, then start blasting\n    energon cube;\n    loop 9 {\n        ice1;\n    };\n    // Theoretically you could fit 10 `ice1`s in your recording.\n    // Realistically, a human needs some breathing room between casts.\n    // (Or maybe you\'re faster than me!)\n    wait 2300;\n};\nloop 3 {\n    // Second recording: drop energon, wait for mana to regen, and buy a few items while we wait.\n    // You could run the first recording longer if you rest longer here too.\n    // Too short, and we won\'t stack enough energon to be fatigue- and energy-neutral. \n    // Too long, and we\'ll lose when this rest cycle starts during a boss fight.\n    // Try out different numbers!\n    buyRandomCatalogItem;\n    buyRandomCatalogItem;\n    buyRandomCatalogItem;\n    wait 7000;\n};';
var $zaboco$elm_draggable$Internal$NotDragging = {$: 0};
var $zaboco$elm_draggable$Draggable$State = $elm$core$Basics$identity;
var $zaboco$elm_draggable$Draggable$init = $zaboco$elm_draggable$Internal$NotDragging;
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Route$params = function (route) {
	switch (route.$) {
		case 1:
			var args = route.a;
			return $elm$core$Maybe$Just(args);
		case 2:
			var args = route.a;
			return $elm$core$Maybe$Just(args);
		case 3:
			var args = route.a;
			return $elm$core$Maybe$Just(args);
		case 4:
			var args = route.a;
			return $elm$core$Maybe$Just(args);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$hashUrl = function (url) {
	var _v0 = A2(
		$elm$core$String$split,
		'?',
		A2($elm$core$Maybe$withDefault, '', url.bD));
	if (_v0.b) {
		var path = _v0.a;
		var queries = _v0.b;
		var urlQuery = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (s) {
				return s + '&';
			},
			url.aJ);
		var query = A2($elm$core$String$join, '?', queries);
		return _Utils_update(
			url,
			{
				a7: path,
				aJ: $elm$core$Maybe$Just(
					_Utils_ap(urlQuery, query))
			});
	} else {
		return _Utils_update(
			url,
			{a7: '', aJ: url.aJ});
	}
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {S: frag, cl: params, Q: unvisited, cP: value, U: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.Q;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.cP);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.cP);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.a7),
					$elm$url$Url$Parser$prepareQuery(url.aJ),
					url.bD,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Changelog = {$: 6};
var $author$project$Route$Debug = {$: 8};
var $author$project$Route$DebugTooltip = {$: 9};
var $author$project$Route$EthItems = {$: 5};
var $author$project$Route$Home = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$HomeParams = F4(
	function (version, hero, build, search) {
		return {ap: build, bH: hero, aM: search, e9: version};
	});
var $author$project$Route$Redirect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Runecorder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Stats = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$StatsTSV = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Transcend = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$defaultHero = 'helpfulAdventurer';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.U;
			var unvisited = _v0.Q;
			var params = _v0.cl;
			var frag = _v0.S;
			var value = _v0.cP;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $author$project$Route$encodedString = A2(
	$elm$url$Url$Parser$custom,
	'ENCODED_STRING',
	function (s) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				s,
				$elm$url$Url$percentDecode(s)));
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.U;
		var unvisited = _v1.Q;
		var params = _v1.cl;
		var frag = _v1.S;
		var value = _v1.cP;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$homeQS = function (path) {
	return A2(
		$elm$url$Url$Parser$questionMark,
		path,
		$elm$url$Url$Parser$Query$string('q'));
};
var $author$project$Route$legacyVersion = '0.052-beta';
var $author$project$Route$liveVersion = '0.15.0-r536';
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.U;
		var unvisited = _v0.Q;
		var params = _v0.cl;
		var frag = _v0.S;
		var value = _v0.cP;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.U;
			var unvisited = _v1.Q;
			var params = _v1.cl;
			var frag = _v1.S;
			var value = _v1.cP;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Route$maybeString = A2(
	$elm$url$Url$Parser$map,
	function (s) {
		return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
	},
	$elm$url$Url$Parser$string);
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.U;
		var unvisited = _v0.Q;
		var params = _v0.cl;
		var frag = _v0.S;
		var value = _v0.cP;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					A3($author$project$Route$HomeParams, $author$project$Route$liveVersion, $author$project$Route$defaultHero, $elm$core$Maybe$Nothing),
					$author$project$Route$homeQS($elm$url$Url$Parser$top)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					A2($author$project$Route$HomeParams, $author$project$Route$legacyVersion, $author$project$Route$defaultHero),
					$author$project$Route$homeQS(
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('b'),
							$author$project$Route$maybeString))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					function (h) {
						return A3($author$project$Route$HomeParams, $author$project$Route$legacyVersion, h, $elm$core$Maybe$Nothing);
					},
					$author$project$Route$homeQS(
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('h'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Route$HomeParams($author$project$Route$legacyVersion),
					$author$project$Route$homeQS(
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('h'),
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Route$maybeString)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					function (v) {
						return A3($author$project$Route$HomeParams, v, $author$project$Route$defaultHero, $elm$core$Maybe$Nothing);
					},
					$author$project$Route$homeQS(
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('g'),
							$author$project$Route$encodedString))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Home,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (v, h) {
						return A3($author$project$Route$HomeParams, v, h, $elm$core$Maybe$Nothing);
					}),
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('g'),
						A2($elm$url$Url$Parser$slash, $author$project$Route$encodedString, $elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Home,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$HomeParams,
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('g'),
						A2(
							$elm$url$Url$Parser$slash,
							$author$project$Route$encodedString,
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Route$maybeString)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Stats,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$HomeParams,
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('s'),
						A2(
							$elm$url$Url$Parser$slash,
							$author$project$Route$encodedString,
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Route$maybeString)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Stats,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (v, h) {
						return A3($author$project$Route$HomeParams, v, h, $elm$core$Maybe$Nothing);
					}),
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('s'),
						A2($elm$url$Url$Parser$slash, $author$project$Route$encodedString, $elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StatsTSV,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$HomeParams,
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('tsv'),
						A2(
							$elm$url$Url$Parser$slash,
							$author$project$Route$encodedString,
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Route$maybeString)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StatsTSV,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (v, h) {
						return A3($author$project$Route$HomeParams, v, h, $elm$core$Maybe$Nothing);
					}),
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('tsv'),
						A2($elm$url$Url$Parser$slash, $author$project$Route$encodedString, $elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Transcend,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (v, h) {
						return A2($author$project$Route$HomeParams, v, h);
					}),
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('transcend'),
						A2(
							$elm$url$Url$Parser$slash,
							$author$project$Route$encodedString,
							A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Route$maybeString)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Transcend,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (v, h) {
						return A3($author$project$Route$HomeParams, v, h, $elm$core$Maybe$Nothing);
					}),
				$author$project$Route$homeQS(
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('transcend'),
						A2($elm$url$Url$Parser$slash, $author$project$Route$encodedString, $elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$EthItems,
			$elm$url$Url$Parser$s('ethitems')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Changelog,
			$elm$url$Url$Parser$s('changelog')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Runecorder,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('runecorder'),
				$elm$url$Url$Parser$Query$string('body'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Debug,
			$elm$url$Url$Parser$s('debug')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$DebugTooltip,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('debug'),
				$elm$url$Url$Parser$s('tooltip')))
		]));
var $author$project$Route$parse = A2(
	$elm$core$Basics$composeR,
	$author$project$Route$hashUrl,
	$elm$url$Url$Parser$parse($author$project$Route$parser));
var $author$project$Route$features0 = {P: false};
var $author$project$Route$Features = function (transcendNodes) {
	return {P: transcendNodes};
};
var $author$project$Route$falseBools = $elm$core$Set$fromList(
	_List_fromArray(
		['', '0', 'no', 'n', 'false']));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Route$flagParam = F2(
	function (name, _default) {
		var parseFlag = function (strs) {
			if (!strs.b) {
				return _default;
			} else {
				var str = strs.a;
				return !A2(
					$elm$core$Set$member,
					$elm$core$String$toLower(str),
					$author$project$Route$falseBools);
			}
		};
		return A2($elm$url$Url$Parser$Query$custom, name, parseFlag);
	});
var $author$project$Route$featuresParser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$Features,
	A2(
		$elm$url$Url$Parser$questionMark,
		$elm$url$Url$Parser$top,
		A2($author$project$Route$flagParam, 'enableTranscendNodes', $author$project$Route$features0.P)));
var $author$project$Route$parseFeatures = A2(
	$elm$core$Basics$composeR,
	$author$project$Route$hashUrl,
	A2(
		$elm$core$Basics$composeR,
		function (url) {
			return _Utils_update(
				url,
				{bD: $elm$core$Maybe$Nothing, a7: ''});
		},
		A2(
			$elm$core$Basics$composeR,
			$elm$url$Url$Parser$parse($author$project$Route$featuresParser),
			$elm$core$Maybe$withDefault($author$project$Route$features0))));
var $author$project$Model$BuildNodesError = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Set$foldr = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldr,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $author$project$GameData$neighbors = F2(
	function (id, g) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Set$empty,
			A2($elm$core$Dict$get, id, g.a4));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$GameData$startNodes = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.aj;
	},
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$values,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.bn;
					})),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function ($) {
						return $.z;
					}),
				$elm$core$Set$fromList))));
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$Model$Graph$reachableNodes = F2(
	function (graph, selected) {
		var startReachable = A2(
			$elm$core$Set$intersect,
			selected,
			$author$project$GameData$startNodes(graph));
		var loop = F2(
			function (id, res) {
				if (A2($elm$core$Set$member, id, res.aS)) {
					return res;
				} else {
					var nextIds = A2(
						$elm$core$Set$intersect,
						selected,
						A2($author$project$GameData$neighbors, id, graph));
					return A3(
						$elm$core$Set$foldr,
						loop,
						{
							aK: A2($elm$core$Set$union, res.aK, nextIds),
							aS: A2($elm$core$Set$insert, id, res.aS)
						},
						nextIds);
				}
			});
		return A3(
			$elm$core$Set$foldr,
			loop,
			{aK: startReachable, aS: $elm$core$Set$empty},
			startReachable).aK;
	});
var $author$project$Model$Graph$allSelectableNodes = function (graph) {
	return A2(
		$author$project$Model$Graph$reachableNodes,
		graph,
		$elm$core$Set$fromList(
			$elm$core$Dict$keys(graph.aj)));
};
var $author$project$Model$Graph$isValidSelection = F2(
	function (graph, selected) {
		return _Utils_eq(
			A2($author$project$Model$Graph$reachableNodes, graph, selected),
			selected);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Model$Graph$buildToNodes = F2(
	function (graph, build) {
		var strList = A2(
			$elm$core$String$split,
			'&',
			A2($elm$core$Maybe$withDefault, '', build));
		var idList = $elm_community$maybe_extra$Maybe$Extra$values(
			A2($elm$core$List$map, $elm$core$String$toInt, strList));
		var ids = $elm$core$Set$fromList(idList);
		return _Utils_eq(
			strList,
			_List_fromArray(
				['all'])) ? $elm$core$Result$Ok(
			$elm$core$Set$toList(
				$author$project$Model$Graph$allSelectableNodes(graph))) : ((!_Utils_eq(
			$elm$core$List$length(idList),
			$elm$core$Set$size(ids))) ? $elm$core$Result$Err('can\'t select a node twice') : ((!A2($author$project$Model$Graph$isValidSelection, graph, ids)) ? $elm$core$Result$Err('some nodes in this build aren\'t connected to the start location') : $elm$core$Result$Ok(idList)));
	});
var $author$project$Model$Graph$Selected = F3(
	function (list, set, indexById) {
		return {dM: indexById, dX: list, aO: set};
	});
var $author$project$Model$Graph$createSelected = function (nodes) {
	return A3(
		$author$project$Model$Graph$Selected,
		nodes,
		$elm$core$Set$fromList(nodes),
		$elm$core$Dict$fromList(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (o, n) {
						return _Utils_Tuple2(n, o);
					}),
				nodes)));
};
var $author$project$Lazy$Lazy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lazy$lazy = $author$project$Lazy$Lazy;
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $author$project$Model$Graph$neighborNodes = F2(
	function (graph, selected) {
		return function (res) {
			return A2($elm$core$Set$diff, res, selected);
		}(
			A3(
				$elm$core$Set$foldr,
				F2(
					function (id, res) {
						return A2(
							$elm$core$Set$union,
							res,
							A2($author$project$GameData$neighbors, id, graph));
					}),
				$author$project$GameData$startNodes(graph),
				selected));
	});
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Model$Dijkstra$terminatingMinimumBy = F3(
	function (terminateAt, fn, items0) {
		var loop = F3(
			function (items, minIn, minOut) {
				loop:
				while (true) {
					if (!items.b) {
						return minIn;
					} else {
						var headIn = items.a;
						var tail = items.b;
						var headOut = fn(headIn);
						if (_Utils_cmp(headOut, terminateAt) < 1) {
							return headIn;
						} else {
							if (_Utils_cmp(headOut, minOut) < 1) {
								var $temp$items = tail,
									$temp$minIn = headIn,
									$temp$minOut = headOut;
								items = $temp$items;
								minIn = $temp$minIn;
								minOut = $temp$minOut;
								continue loop;
							} else {
								var $temp$items = tail,
									$temp$minIn = minIn,
									$temp$minOut = minOut;
								items = $temp$items;
								minIn = $temp$minIn;
								minOut = $temp$minOut;
								continue loop;
							}
						}
					}
				}
			});
		if (!items0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var headIn = items0.a;
			var tail = items0.b;
			return $elm$core$Maybe$Just(
				function () {
					var headOut = fn(headIn);
					return (_Utils_cmp(headOut, terminateAt) < 1) ? headIn : A3(loop, tail, headIn, headOut);
				}());
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Model$Dijkstra$infinity = $elm$core$Basics$floor(1 / 0);
var $author$project$Model$Dijkstra$visitNeighbors = F5(
	function (startOrSelected, dp, prevNode, prevDist, neighbors) {
		visitNeighbors:
		while (true) {
			var _v0 = $elm$core$List$head(neighbors);
			if (_v0.$ === 1) {
				return dp;
			} else {
				var nextNode = _v0.a;
				var d = ((!prevDist) && A2($elm$core$Set$member, nextNode, startOrSelected)) ? 0 : (prevDist + 1);
				var _v1 = dp;
				var distances = _v1.D;
				var prevs = _v1.N;
				var isShorter = _Utils_cmp(
					d,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Model$Dijkstra$infinity,
						A2($elm$core$Dict$get, nextNode, distances))) < 0;
				var dp1 = isShorter ? {
					D: A3($elm$core$Dict$insert, nextNode, d, distances),
					N: A3($elm$core$Dict$insert, nextNode, prevNode, prevs)
				} : dp;
				var $temp$startOrSelected = startOrSelected,
					$temp$dp = dp1,
					$temp$prevNode = prevNode,
					$temp$prevDist = prevDist,
					$temp$neighbors = A2($elm$core$List$drop, 1, neighbors);
				startOrSelected = $temp$startOrSelected;
				dp = $temp$dp;
				prevNode = $temp$prevNode;
				prevDist = $temp$prevDist;
				neighbors = $temp$neighbors;
				continue visitNeighbors;
			}
		}
	});
var $author$project$Model$Dijkstra$visitNode = F6(
	function (lastDistance, startOrSelected, graph, unvisited, target, dp0) {
		visitNode:
		while (true) {
			var _v0 = A3(
				$author$project$Model$Dijkstra$terminatingMinimumBy,
				lastDistance,
				$elm$core$Tuple$second,
				A3(
					$elm$core$Set$foldl,
					F2(
						function (id, list) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								list,
								function (d) {
									return A2(
										$elm$core$List$cons,
										_Utils_Tuple2(id, d),
										list);
								},
								A2($elm$core$Dict$get, id, dp0.D));
						}),
					_List_Nil,
					unvisited));
			if (_v0.$ === 1) {
				return dp0;
			} else {
				var _v1 = _v0.a;
				var node = _v1.a;
				if (_Utils_eq(
					$elm$core$Maybe$Just(node),
					target)) {
					return dp0;
				} else {
					var unvisitedNeighbors = $elm$core$Set$toList(
						A2(
							$elm$core$Set$intersect,
							unvisited,
							A2($author$project$GameData$neighbors, node, graph)));
					var d = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Basics$floor(1 / 0),
						A2($elm$core$Dict$get, node, dp0.D));
					var dp = A5(
						$author$project$Model$Dijkstra$visitNeighbors,
						startOrSelected,
						{D: dp0.D, N: dp0.N},
						node,
						d,
						unvisitedNeighbors);
					var $temp$lastDistance = d,
						$temp$startOrSelected = startOrSelected,
						$temp$graph = graph,
						$temp$unvisited = A2($elm$core$Set$remove, node, unvisited),
						$temp$target = target,
						$temp$dp0 = dp;
					lastDistance = $temp$lastDistance;
					startOrSelected = $temp$startOrSelected;
					graph = $temp$graph;
					unvisited = $temp$unvisited;
					target = $temp$target;
					dp0 = $temp$dp0;
					continue visitNode;
				}
			}
		}
	});
var $author$project$Model$Dijkstra$dijkstra = F3(
	function (graph, selected0, target) {
		var startOrSelected = A2(
			$elm$core$Set$union,
			$author$project$GameData$startNodes(graph),
			selected0);
		var distances0 = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (id) {
					return _Utils_Tuple2(id, 0);
				},
				$elm$core$Set$toList(
					$author$project$GameData$startNodes(graph))));
		var allNodes = $elm$core$Dict$keys(graph.aj);
		return A6(
			$author$project$Model$Dijkstra$visitNode,
			0,
			startOrSelected,
			graph,
			$elm$core$Set$fromList(allNodes),
			target,
			{D: distances0, N: $elm$core$Dict$empty});
	});
var $author$project$Model$Graph$runDijkstra = F2(
	function (graph, selected) {
		return A3($author$project$Model$Dijkstra$dijkstra, graph, selected, $elm$core$Maybe$Nothing);
	});
var $author$project$Model$Graph$create = F3(
	function (game, _char, selectedList) {
		var selected = $author$project$Model$Graph$createSelected(selectedList);
		return {
			bu: _char,
			aW: $author$project$Lazy$lazy(
				function (_v0) {
					return A2($author$project$Model$Graph$runDijkstra, _char.dF, selected.aO);
				}),
			ah: game,
			a4: A2($author$project$Model$Graph$neighborNodes, _char.dF, selected.aO),
			aM: $elm$core$Maybe$Nothing,
			G: selected
		};
	});
var $author$project$Model$Graph$parse = F2(
	function (gameData, q) {
		var _v0 = A2($elm$core$Dict$get, q.e9, gameData.bs);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err('no such game-version: ' + q.e9);
		} else {
			var game = _v0.a;
			var _v1 = A2($elm$core$Dict$get, q.bH, game.bI);
			if (_v1.$ === 1) {
				return $elm$core$Result$Err('no such hero: ' + q.bH);
			} else {
				var _char = _v1.a;
				var _v2 = function () {
					var _v3 = A2($author$project$Model$Graph$buildToNodes, _char.dF, q.ap);
					if (!_v3.$) {
						var selected_ = _v3.a;
						return _Utils_Tuple2(selected_, $elm$core$Maybe$Nothing);
					} else {
						var err = _v3.a;
						return _Utils_Tuple2(
							_List_Nil,
							$elm$core$Maybe$Just(err));
					}
				}();
				var selected = _v2.a;
				var error = _v2.b;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						A3($author$project$Model$Graph$create, game, _char, selected),
						error));
			}
		}
	});
var $author$project$Model$parseGraph = F2(
	function (gameData, route) {
		var graphResult = A2(
			$elm$core$Result$andThen,
			$author$project$Model$Graph$parse(gameData),
			A2(
				$elm$core$Result$fromMaybe,
				'cannot graph this url',
				A2($elm$core$Maybe$andThen, $author$project$Route$params, route)));
		if (graphResult.$ === 1) {
			var err = graphResult.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(
					$author$project$Model$GraphError(err)));
		} else {
			if (!graphResult.a.b.$) {
				var _v1 = graphResult.a;
				var g = _v1.a;
				var err = _v1.b.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(g),
					$elm$core$Maybe$Just(
						$author$project$Model$BuildNodesError(err)));
			} else {
				var _v2 = graphResult.a;
				var g = _v2.a;
				var _v3 = _v2.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(g),
					$elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Model$Preprocess = {$: 10};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Model$preprocessCmd = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$identity,
	A2(
		$elm$core$Task$andThen,
		$elm$core$Basics$always(
			$elm$core$Task$succeed($author$project$Model$Preprocess)),
		$elm$core$Process$sleep(1)));
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Model$redirectRoute = function (route) {
	if (!route.$) {
		var r = route.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				r,
				$author$project$Model$redirectRoute(r)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Route$encode = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '(', '%28'),
		A2($elm$core$String$replace, ')', '%29')));
var $author$project$Route$stringifyHomePath = function (_v0) {
	var version = _v0.e9;
	var hero = _v0.bH;
	var build = _v0.ap;
	var search = _v0.aM;
	var qs = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		A2(
			$elm$core$Basics$composeR,
			$author$project$Route$encode,
			$elm$core$Basics$append('?q=')),
		search);
	return '/' + ($author$project$Route$encode(version) + function () {
		var _v1 = _Utils_Tuple2(hero, build);
		if (_v1.b.$ === 1) {
			var _v2 = _v1.b;
			return '/' + (hero + qs);
		} else {
			var b = _v1.b.a;
			return '/' + (hero + ('/' + (b + qs)));
		}
	}());
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Route$stringify = function (route) {
	stringify:
	while (true) {
		switch (route.$) {
			case 0:
				var r = route.a;
				var $temp$route = r;
				route = $temp$route;
				continue stringify;
			case 1:
				var args = route.a;
				return '#/g' + $author$project$Route$stringifyHomePath(args);
			case 2:
				var args = route.a;
				return '#/s' + $author$project$Route$stringifyHomePath(args);
			case 3:
				var args = route.a;
				return '#/tsv' + $author$project$Route$stringifyHomePath(args);
			case 4:
				var args = route.a;
				return '#/transcend' + $author$project$Route$stringifyHomePath(args);
			case 6:
				return '#/changelog';
			case 5:
				return '#/ethitems';
			case 7:
				var body = route.a;
				return '#/runecorder' + $elm$url$Url$Builder$toQuery(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('body'),
								body)
							])));
			case 8:
				return '#/debug';
			default:
				return '#/debug/tooltip';
		}
	}
};
var $author$project$Model$redirectCmd = F2(
	function (urlKey, route) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Model$redirectRoute, route);
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var r = _v0.a;
			return A2(
				$elm$browser$Browser$Navigation$replaceUrl,
				urlKey,
				$author$project$Route$stringify(r));
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {c9: col, db: contextStack, ez: problem, cv: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.cv, s.c9, x, s.d));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Nestable = 1;
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{c9: col, d: s0.d, e: s0.e, c: offset, cv: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.cv, s.c9, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $author$project$Model$Runecorder$ifProgress = F2(
	function (parser_, offset) {
		return A2(
			$elm$parser$Parser$map,
			function (newOffset) {
				return _Utils_eq(offset, newOffset) ? $elm$parser$Parser$Done(0) : $elm$parser$Parser$Loop(newOffset);
			},
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					parser_),
				$elm$parser$Parser$getOffset));
	});
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.cv, s.c9, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.d)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{c9: newCol, d: s.d, e: s.e, c: newOffset, cv: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c9: 1, d: s.d, e: s.e, c: s.c + 1, cv: s.cv + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c9: s.c9 + 1, d: s.d, e: s.e, c: newOffset, cv: s.cv, b: s.b}));
		};
	});
var $elm$parser$Parser$Advanced$isChar = function (_char) {
	return true;
};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$nestableHelp = F5(
	function (isNotRelevant, open, close, expectingClose, nestLevel) {
		return A2(
			$elm$parser$Parser$Advanced$skip,
			$elm$parser$Parser$Advanced$chompWhile(isNotRelevant),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						(nestLevel === 1) ? close : A2(
						$elm$parser$Parser$Advanced$andThen,
						function (_v0) {
							return A5($elm$parser$Parser$Advanced$nestableHelp, isNotRelevant, open, close, expectingClose, nestLevel - 1);
						},
						close),
						A2(
						$elm$parser$Parser$Advanced$andThen,
						function (_v1) {
							return A5($elm$parser$Parser$Advanced$nestableHelp, isNotRelevant, open, close, expectingClose, nestLevel + 1);
						},
						open),
						A2(
						$elm$parser$Parser$Advanced$andThen,
						function (_v2) {
							return A5($elm$parser$Parser$Advanced$nestableHelp, isNotRelevant, open, close, expectingClose, nestLevel);
						},
						A2($elm$parser$Parser$Advanced$chompIf, $elm$parser$Parser$Advanced$isChar, expectingClose))
					])));
	});
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.cv, s.c9, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c9: newCol, d: s.d, e: s.e, c: newOffset, cv: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Advanced$nestableComment = F2(
	function (open, close) {
		var oStr = open.a;
		var oX = open.b;
		var cStr = close.a;
		var cX = close.b;
		var _v0 = $elm$core$String$uncons(oStr);
		if (_v0.$ === 1) {
			return $elm$parser$Parser$Advanced$problem(oX);
		} else {
			var _v1 = _v0.a;
			var openChar = _v1.a;
			var _v2 = $elm$core$String$uncons(cStr);
			if (_v2.$ === 1) {
				return $elm$parser$Parser$Advanced$problem(cX);
			} else {
				var _v3 = _v2.a;
				var closeChar = _v3.a;
				var isNotRelevant = function (_char) {
					return (!_Utils_eq(_char, openChar)) && (!_Utils_eq(_char, closeChar));
				};
				var chompOpen = $elm$parser$Parser$Advanced$token(open);
				return A2(
					$elm$parser$Parser$Advanced$ignorer,
					chompOpen,
					A5(
						$elm$parser$Parser$Advanced$nestableHelp,
						isNotRelevant,
						chompOpen,
						$elm$parser$Parser$Advanced$token(close),
						cX,
						1));
			}
		}
	});
var $elm$parser$Parser$Advanced$multiComment = F3(
	function (open, close, nestable) {
		if (!nestable) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$token(open),
				$elm$parser$Parser$Advanced$chompUntil(close));
		} else {
			return A2($elm$parser$Parser$Advanced$nestableComment, open, close);
		}
	});
var $elm$parser$Parser$Advanced$Nestable = 1;
var $elm$parser$Parser$Advanced$NotNestable = 0;
var $elm$parser$Parser$toAdvancedNestable = function (nestable) {
	if (!nestable) {
		return 0;
	} else {
		return 1;
	}
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$multiComment = F3(
	function (open, close, nestable) {
		return A3(
			$elm$parser$Parser$Advanced$multiComment,
			$elm$parser$Parser$toToken(open),
			$elm$parser$Parser$toToken(close),
			$elm$parser$Parser$toAdvancedNestable(nestable));
	});
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$Model$Runecorder$spaces = A2(
	$elm$parser$Parser$loop,
	0,
	$author$project$Model$Runecorder$ifProgress(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$symbol('//')),
					$elm$parser$Parser$chompWhile(
						function (c) {
							return c !== '\n';
						})),
					A3($elm$parser$Parser$multiComment, '/*', '*/', 1),
					$elm$parser$Parser$chompWhile(
					function (c) {
						return (c === ' ') || ((c === '\n') || ((c === '\u000D') || (c === '\t')));
					})
				]))));
var $author$project$Model$Runecorder$ActionStatement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Runecorder$LoopStatement = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Runecorder$ClickAction = {$: 1};
var $author$project$Model$Runecorder$SpellAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Runecorder$WaitAction = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {c9: s.c9 + (newOffset - s.c), d: s.d, e: s.e, c: newOffset, cv: s.cv, b: s.b};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.b);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.cv, s.c9 - (floatOffset + s.c), invalid, s.d));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.b));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.b)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dP,
				c.bJ,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dP,
				c.ce,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dP,
				c.bp,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.b),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.dP,
				c.bB,
				c.bM,
				c.bC,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.dP,
				c.bB,
				c.bM,
				c.bC,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.b),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				bp: $elm$core$Result$Err(invalid),
				bB: expecting,
				bC: $elm$core$Result$Err(invalid),
				bJ: $elm$core$Result$Err(invalid),
				bM: $elm$core$Result$Ok($elm$core$Basics$identity),
				dP: invalid,
				ce: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.c, s.cv, s.c9, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.b))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c9: newCol, d: s.d, e: s.e, c: newOffset, cv: newRow, b: s.b});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $author$project$Model$Runecorder$reserved = $elm$core$Set$fromList(
	_List_fromArray(
		['wait', 'click', 'loop']));
var $elm$core$String$trim = _String_trim;
var $elm$parser$Parser$ExpectingVariable = {$: 7};
var $elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {c9: col, d: context, e: indent, c: offset, cv: row, b: src};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$variable = function (i) {
	return function (s) {
		var firstOffset = A3($elm$parser$Parser$Advanced$isSubChar, i.bg, s.c, s.b);
		if (_Utils_eq(firstOffset, -1)) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.bB));
		} else {
			var s1 = _Utils_eq(firstOffset, -2) ? A7($elm$parser$Parser$Advanced$varHelp, i.dO, s.c + 1, s.cv + 1, 1, s.b, s.e, s.d) : A7($elm$parser$Parser$Advanced$varHelp, i.dO, firstOffset, s.cv, s.c9 + 1, s.b, s.e, s.d);
			var name = A3($elm$core$String$slice, s.c, s1.c, s.b);
			return A2($elm$core$Set$member, name, i.eE) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.bB)) : A3($elm$parser$Parser$Advanced$Good, true, name, s1);
		}
	};
};
var $elm$parser$Parser$variable = function (i) {
	return $elm$parser$Parser$Advanced$variable(
		{bB: $elm$parser$Parser$ExpectingVariable, dO: i.dO, eE: i.eE, bg: i.bg});
};
var $author$project$Model$Runecorder$actionParser = function (spells) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($author$project$Model$Runecorder$WaitAction),
						$elm$parser$Parser$keyword('wait')),
					$author$project$Model$Runecorder$spaces),
				$elm$parser$Parser$int),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($author$project$Model$Runecorder$ClickAction),
				$elm$parser$Parser$keyword('click')),
				A2(
				$elm$parser$Parser$andThen,
				function (name) {
					var _v0 = A2(
						$elm$core$Dict$get,
						$elm$core$String$trim(
							$elm$core$String$toLower(name)),
						spells);
					if (_v0.$ === 1) {
						return $elm$parser$Parser$problem('no such spell: ' + name);
					} else {
						var a = _v0.a;
						return $elm$parser$Parser$succeed(
							$author$project$Model$Runecorder$SpellAction(a));
					}
				},
				A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$variable(
						{
							dO: function (c) {
								return $elm$core$Char$isAlpha(c) || ($elm$core$Char$isDigit(c) || (c === ' '));
							},
							eE: $author$project$Model$Runecorder$reserved,
							bg: $elm$core$Char$isAlpha
						})))
			]));
};
var $author$project$Model$Runecorder$statementParser = function (spells) {
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($author$project$Model$Runecorder$LoopStatement),
										$elm$parser$Parser$keyword('loop')),
									$author$project$Model$Runecorder$spaces),
								A2(
									$elm$parser$Parser$ignorer,
									A2(
										$elm$parser$Parser$ignorer,
										A2(
											$elm$parser$Parser$ignorer,
											A2(
												$elm$parser$Parser$andThen,
												function (n) {
													return (n <= 0) ? $elm$parser$Parser$problem('loop minimum: 1') : ((n > 20) ? $elm$parser$Parser$problem('loop maximum: 20') : $elm$parser$Parser$succeed(n));
												},
												$elm$parser$Parser$int),
											$author$project$Model$Runecorder$spaces),
										$elm$parser$Parser$symbol('{')),
									$author$project$Model$Runecorder$spaces)),
							A2(
								$elm$parser$Parser$ignorer,
								A2(
									$elm$parser$Parser$ignorer,
									$author$project$Model$Runecorder$statementsParser(spells),
									$author$project$Model$Runecorder$spaces),
								$elm$parser$Parser$symbol('}'))),
							A2(
							$elm$parser$Parser$map,
							$author$project$Model$Runecorder$ActionStatement,
							$author$project$Model$Runecorder$actionParser(spells))
						])),
				$author$project$Model$Runecorder$spaces),
			$elm$parser$Parser$symbol(';')));
};
var $author$project$Model$Runecorder$statementsParser = function (spells) {
	var loop = function (stmts) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed(
						function (s) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, s, stmts));
						}),
					A2(
						$elm$parser$Parser$ignorer,
						$author$project$Model$Runecorder$statementParser(spells),
						$author$project$Model$Runecorder$spaces)),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							$elm$core$List$reverse(stmts));
					},
					$elm$parser$Parser$succeed(0))
				]));
	};
	return A2($elm$parser$Parser$loop, _List_Nil, loop);
};
var $author$project$Model$Runecorder$parser = function (spells) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$author$project$Model$Runecorder$spaces),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Model$Runecorder$statementsParser(spells),
				$author$project$Model$Runecorder$spaces),
			$elm$parser$Parser$end));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {c9: col, ez: problem, cv: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.cv, p.c9, p.ez);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{c9: 1, d: _List_Nil, e: 1, c: 0, cv: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $author$project$Model$Runecorder$parseStatements = F2(
	function (spells, source) {
		return $elm$core$Basics$identity(
			A2(
				$elm$parser$Parser$run,
				$author$project$Model$Runecorder$parser(spells),
				source));
	});
function $author$project$Model$Runecorder$cyclic$unrollStatements() {
	return $elm$core$List$concatMap(
		function (statement) {
			if (!statement.$) {
				var act = statement.a;
				return _List_fromArray(
					[act]);
			} else {
				var n = statement.a;
				var sts = statement.b;
				return $author$project$Model$Runecorder$cyclic$unrollStatements()(
					A2(
						$elm$core$List$concatMap,
						$elm$core$Basics$always(sts),
						A2($elm$core$List$range, 1, n)));
			}
		});
}
var $author$project$Model$Runecorder$unrollStatements = $author$project$Model$Runecorder$cyclic$unrollStatements();
$author$project$Model$Runecorder$cyclic$unrollStatements = function () {
	return $author$project$Model$Runecorder$unrollStatements;
};
var $author$project$Model$Runecorder$parse = function (spells) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Runecorder$parseStatements(spells),
		$elm$core$Result$map($author$project$Model$Runecorder$unrollStatements));
};
var $author$project$Model$Runecorder$ActionCompleted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Runecorder$duration = function (s) {
	return ($elm$core$List$length(s.eH) - 1) * s.d4;
};
var $author$project$Model$Runecorder$actionDuration = function (act) {
	switch (act.$) {
		case 0:
			var millis = act.a;
			return millis;
		case 1:
			return 0;
		default:
			var s = act.a;
			return $author$project$Model$Runecorder$duration(s);
	}
};
var $author$project$Scheduler$Scheduler = $elm$core$Basics$identity;
var $author$project$Scheduler$empty = function (t) {
	return {x: _List_Nil, aC: t};
};
var $author$project$Model$Runecorder$emptySim = {R: $elm$core$Dict$empty, au: 0, af: 0, ag: 0, p: $elm$core$Dict$empty, Y: 0, ai: 0, aC: 0};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Scheduler$unwrap = function (_v0) {
	var s = _v0;
	return s;
};
var $author$project$Scheduler$now = A2(
	$elm$core$Basics$composeR,
	$author$project$Scheduler$unwrap,
	function ($) {
		return $.aC;
	});
var $author$project$Scheduler$pop = function (sched) {
	var s = sched;
	var loop = F5(
		function (wnode, wleft, wright, left, right) {
			loop:
			while (true) {
				if (!right.b) {
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(wnode),
						_Utils_update(
							s,
							{
								x: function () {
									var _v1 = wnode.ax;
									if (_v1.$ === 1) {
										return _Utils_ap(
											$elm$core$List$reverse(wleft),
											wright);
									} else {
										var dur = _v1.a;
										return _Utils_ap(
											$elm$core$List$reverse(wleft),
											A2(
												$elm$core$List$cons,
												_Utils_update(
													wnode,
													{cY: wnode.cY + dur}),
												wright));
									}
								}(),
								aC: A2($elm$core$Basics$max, s.aC, wnode.cY)
							}));
				} else {
					var head = right.a;
					var tail = right.b;
					if (_Utils_cmp(head.cY, wnode.cY) < 0) {
						var $temp$wnode = head,
							$temp$wleft = left,
							$temp$wright = tail,
							$temp$left = A2($elm$core$List$cons, head, left),
							$temp$right = tail;
						wnode = $temp$wnode;
						wleft = $temp$wleft;
						wright = $temp$wright;
						left = $temp$left;
						right = $temp$right;
						continue loop;
					} else {
						var $temp$wnode = wnode,
							$temp$wleft = wleft,
							$temp$wright = wright,
							$temp$left = A2($elm$core$List$cons, head, left),
							$temp$right = tail;
						wnode = $temp$wnode;
						wleft = $temp$wleft;
						wright = $temp$wright;
						left = $temp$left;
						right = $temp$right;
						continue loop;
					}
				}
			}
		});
	var _v2 = s.x;
	if (!_v2.b) {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, sched);
	} else {
		var head = _v2.a;
		var tail = _v2.b;
		return A5(
			loop,
			head,
			_List_Nil,
			tail,
			_List_fromArray(
				[head]),
			tail);
	}
};
var $author$project$Scheduler$popUntil = F2(
	function (until, sched0) {
		var s0 = sched0;
		var _v0 = $author$project$Scheduler$pop(sched0);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			var s = _v0.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				_Utils_update(
					s,
					{
						aC: A2($elm$core$Basics$max, s.aC, until)
					}));
		} else {
			var res = _v0;
			var event = res.a.a;
			var sched = res.b;
			return (_Utils_cmp(
				$author$project$Scheduler$now(sched),
				until) > 0) ? _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				_Utils_update(
					s0,
					{
						aC: A2($elm$core$Basics$max, s0.aC, until)
					})) : res;
		}
	});
var $author$project$Scheduler$runTimelineUntil = F2(
	function (time, updater) {
		var loop = F2(
			function (timelineEntries, _v0) {
				loop:
				while (true) {
					var state0 = _v0.a;
					var sched0 = _v0.b;
					var _v1 = A2($author$project$Scheduler$popUntil, time, sched0);
					if (_v1.a.$ === 1) {
						var _v2 = _v1.a;
						var sched1 = _v1.b;
						return _Utils_Tuple2(
							$elm$core$List$reverse(timelineEntries),
							sched1);
					} else {
						var event = _v1.a.a;
						var sched1 = _v1.b;
						var _v3 = A2(
							updater,
							event,
							_Utils_Tuple2(state0, sched1));
						var state2 = _v3.a;
						var sched2 = _v3.b;
						var $temp$timelineEntries = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(event, state2),
							timelineEntries),
							$temp$_v0 = _Utils_Tuple2(state2, sched2);
						timelineEntries = $temp$timelineEntries;
						_v0 = $temp$_v0;
						continue loop;
					}
				}
			});
		return loop(_List_Nil);
	});
var $author$project$Scheduler$insert = F2(
	function (event, s) {
		return _Utils_update(
			s,
			{
				x: A2($elm$core$List$cons, event, s.x)
			});
	});
var $author$project$Scheduler$setTimeout = F3(
	function (dur, payload, _v0) {
		var s = _v0;
		return A2(
			$author$project$Scheduler$insert,
			{cY: s.aC + dur, ax: $elm$core$Maybe$Nothing, a8: payload},
			s);
	});
var $author$project$Model$Runecorder$FatigueExpires = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Runecorder$energonPerFatigue = 5;
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Model$Runecorder$normalizeEnergonStacks = function (snapshot) {
	var stacks = snapshot.i - ((snapshot.E / $author$project$Model$Runecorder$energonPerFatigue) | 0);
	var energonStacks = A2($elm$core$Basics$modBy, $author$project$Model$Runecorder$energonPerFatigue, snapshot.E);
	return (_Utils_eq(stacks, snapshot.i) && _Utils_eq(energonStacks, snapshot.E)) ? $elm$core$Maybe$Just(snapshot) : ((stacks <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		_Utils_update(
			snapshot,
			{E: energonStacks, i: stacks})));
};
var $author$project$Model$Runecorder$addFatigueEnergonStack = F2(
	function (enstacks, snapshot) {
		return $author$project$Model$Runecorder$normalizeEnergonStacks(
			_Utils_update(
				snapshot,
				{E: snapshot.E + enstacks}));
	});
var $elm_community$dict_extra$Dict$Extra$filterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Model$Runecorder$applyBuffTick = F3(
	function (time, buff, sim) {
		var _v0 = buff.z;
		if (_v0 === 'buff:energon') {
			var _v1 = A2($elm$core$Dict$get, buff.z, sim.R);
			if (_v1.$ === 1) {
				return sim;
			} else {
				var stacks = _v1.a.i;
				return _Utils_update(
					sim,
					{
						af: sim.af + stacks,
						p: A2(
							$elm_community$dict_extra$Dict$Extra$filterMap,
							function (_v2) {
								return $author$project$Model$Runecorder$addFatigueEnergonStack(stacks);
							},
							sim.p)
					});
			}
		} else {
			return sim;
		}
	});
var $author$project$Model$Runecorder$addFatigueStack = F4(
	function (time, fat, stacks, msnapshot) {
		if (msnapshot.$ === 1) {
			return {E: 0, p: fat, i: stacks, ab: time};
		} else {
			var snapshot = msnapshot.a;
			return _Utils_update(
				snapshot,
				{i: snapshot.i + stacks});
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Scheduler$any = function (pred) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Scheduler$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.x;
			},
			$elm$core$List$any(pred)));
};
var $author$project$GameData$Fatigue = F3(
	function (id, label, ord) {
		return {z: id, dV: label, cj: ord};
	});
var $author$project$GameData$fatigue = function (f) {
	switch (f) {
		case 0:
			return A3($author$project$GameData$Fatigue, f, 'Fire', 1);
		case 1:
			return A3($author$project$GameData$Fatigue, f, 'Ice', 2);
		default:
			return A3($author$project$GameData$Fatigue, f, 'Lit', 3);
	}
};
var $author$project$GameData$Fire = 0;
var $author$project$GameData$Ice = 1;
var $author$project$GameData$Lit = 2;
var $author$project$GameData$fatigueIds = _List_fromArray(
	[0, 1, 2]);
var $author$project$GameData$fatigues = A2($elm$core$List$map, $author$project$GameData$fatigue, $author$project$GameData$fatigueIds);
var $author$project$GameData$spellFatigue = function (s) {
	return (s.ba <= 0) ? _List_Nil : A2(
		$elm$core$List$map,
		function (f) {
			return _Utils_Tuple2(f, s.ba);
		},
		A2(
			$elm$core$List$filter,
			function (f) {
				return A2($elm$core$Set$member, f.cj, s.cO);
			},
			$author$project$GameData$fatigues));
};
var $author$project$Model$Runecorder$applySpellFatigue = F3(
	function (time, spell, state0) {
		var applyFatigue = F2(
			function (_v0, _v1) {
				var fat = _v0.a;
				var stacks = _v0.b;
				var sim = _v1.a;
				var sched = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						sim,
						{
							p: A3(
								$elm$core$Dict$update,
								fat.dV,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$Model$Runecorder$addFatigueStack, time, fat, stacks),
									$elm$core$Maybe$Just),
								sim.p)
						}),
					A2(
						$author$project$Scheduler$any,
						function (e) {
							return _Utils_eq(
								e.a8,
								$author$project$Model$Runecorder$FatigueExpires(fat));
						},
						sched) ? sched : A3(
						$author$project$Scheduler$setTimeout,
						8000,
						$author$project$Model$Runecorder$FatigueExpires(fat),
						sched));
			});
		return A3(
			$elm$core$List$foldl,
			applyFatigue,
			state0,
			$author$project$GameData$spellFatigue(spell));
	});
var $author$project$Model$Runecorder$expireFatigue = F3(
	function (time, fat, snapshot) {
		var stacks = snapshot.i - 1;
		return (stacks <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_update(
				snapshot,
				{i: stacks, ab: time}));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Model$Runecorder$energyCostPerFatigueStack = 0.04;
var $author$project$Model$Runecorder$fatigueStacks = function (s) {
	return s.i - (s.E / $author$project$Model$Runecorder$energonPerFatigue);
};
var $elm$core$Basics$round = _Basics_round;
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Model$Runecorder$paySpellCosts = F2(
	function (spell, sim) {
		var stacks = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$author$project$Model$Runecorder$fatigueStacks,
				A2(
					$elm$core$List$filterMap,
					function (fat) {
						return A2($elm$core$Dict$get, fat.dV, sim.p);
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$author$project$GameData$spellFatigue(spell)))));
		var baseCost = $elm$core$Basics$round(
			($elm$core$List$length(spell.eH) * spell.de) * 5);
		var cost = (1 + (stacks * $author$project$Model$Runecorder$energyCostPerFatigueStack)) * baseCost;
		return _Utils_update(
			sim,
			{ag: sim.ag + cost, ai: sim.ai + spell.b7});
	});
var $author$project$Model$Runecorder$BuffExpires = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Runecorder$BuffTicks = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Runecorder$addBuffStack = F3(
	function (time, buff, msnapshot) {
		if (msnapshot.$ === 1) {
			return {br: buff, i: 1, ab: time};
		} else {
			var snapshot = msnapshot.a;
			return _Utils_update(
				snapshot,
				{
					i: function () {
						var _v1 = buff.b8;
						if (_v1.$ === 1) {
							return snapshot.i + 1;
						} else {
							var cap = _v1.a;
							return A2($elm$core$Basics$min, cap, snapshot.i + 1);
						}
					}(),
					ab: time
				});
		}
	});
var $author$project$Model$Runecorder$Buff = F5(
	function (id, spell, duration, ticksMillis, maxStacks) {
		return {aY: duration, z: id, b8: maxStacks, cC: spell, cJ: ticksMillis};
	});
var $author$project$Model$Runecorder$buffDarkRitual = A5(
	$author$project$Model$Runecorder$Buff,
	'buff:dark-ritual',
	'iceFireDarkRitual',
	60000,
	_List_Nil,
	$elm$core$Maybe$Just(20));
var $author$project$Model$Runecorder$buffEnergon = A5(
	$author$project$Model$Runecorder$Buff,
	'buff:energon',
	'energon cube',
	18000,
	_List_fromArray(
		[3000, 6000, 9000, 12000, 15000]),
	$elm$core$Maybe$Nothing);
var $author$project$Model$Runecorder$bufflist = _List_fromArray(
	[$author$project$Model$Runecorder$buffEnergon, $author$project$Model$Runecorder$buffDarkRitual]);
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$Model$Runecorder$buffsBySpell = A2(
	$elm_community$dict_extra$Dict$Extra$fromListBy,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cC;
		},
		$elm$core$String$toLower),
	$author$project$Model$Runecorder$bufflist);
var $author$project$Scheduler$filter = F2(
	function (pred, _v0) {
		var s = _v0;
		return _Utils_update(
			s,
			{
				x: A2($elm$core$List$filter, pred, s.x)
			});
	});
var $author$project$Model$Runecorder$removeBuffEvents = function (buffId) {
	return $author$project$Scheduler$filter(
		function (event) {
			var _v0 = event.a8;
			switch (_v0.$) {
				case 1:
					var expires = _v0.a;
					return !_Utils_eq(buffId, expires.z);
				case 2:
					var expires = _v0.a;
					return !_Utils_eq(buffId, expires.z);
				default:
					return true;
			}
		});
};
var $author$project$Model$Runecorder$refreshSpellBuff = F3(
	function (time, spell, _v0) {
		var sim = _v0.a;
		var sched = _v0.b;
		var _v1 = A2(
			$elm$core$Dict$get,
			$elm$core$String$toLower(spell.z),
			$author$project$Model$Runecorder$buffsBySpell);
		if (!_v1.$) {
			var buff = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					sim,
					{
						R: A3(
							$elm$core$Dict$update,
							buff.z,
							A2(
								$elm$core$Basics$composeR,
								A2($author$project$Model$Runecorder$addBuffStack, time, buff),
								$elm$core$Maybe$Just),
							sim.R)
					}),
				function (s) {
					return A3(
						$elm$core$List$foldl,
						function (d) {
							return A2(
								$author$project$Scheduler$setTimeout,
								d,
								$author$project$Model$Runecorder$BuffTicks(buff));
						},
						s,
						buff.cJ);
				}(
					A3(
						$author$project$Scheduler$setTimeout,
						buff.aY,
						$author$project$Model$Runecorder$BuffExpires(buff),
						A2($author$project$Model$Runecorder$removeBuffEvents, buff.z, sched))));
		} else {
			return _Utils_Tuple2(sim, sched);
		}
	});
var $author$project$Model$Runecorder$energyMax = 300;
var $author$project$Model$Runecorder$energyPerEnergonTick = 0.025 * $author$project$Model$Runecorder$energyMax;
var $author$project$Model$Runecorder$energyRegen = 1;
var $author$project$Model$Runecorder$manaRegen = 1.25;
var $author$project$Model$Runecorder$simTimestep = F2(
	function (time, sim) {
		return _Utils_update(
			sim,
			{au: ((($author$project$Model$Runecorder$energyRegen * time) / 1000) + ($author$project$Model$Runecorder$energyPerEnergonTick * sim.af)) - sim.ag, Y: ((time / 1000) * $author$project$Model$Runecorder$manaRegen) - sim.ai, aC: time});
	});
var $author$project$Model$Runecorder$simStep = F2(
	function (simevent, _v0) {
		var sim = _v0.a;
		var sched = _v0.b;
		var time = simevent.cY;
		var event = simevent.a8;
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Model$Runecorder$simTimestep(time),
			function () {
				switch (event.$) {
					case 0:
						if (event.a.$ === 2) {
							var spell = event.a.a;
							return A3(
								$author$project$Model$Runecorder$applySpellFatigue,
								time,
								spell,
								A3(
									$author$project$Model$Runecorder$refreshSpellBuff,
									time,
									spell,
									_Utils_Tuple2(
										A2($author$project$Model$Runecorder$paySpellCosts, spell, sim),
										sched)));
						} else {
							return _Utils_Tuple2(sim, sched);
						}
					case 1:
						var buff = event.a;
						return _Utils_Tuple2(
							function (s) {
								return _Utils_update(
									s,
									{
										R: A2($elm$core$Dict$remove, buff.z, sim.R)
									});
							}(
								A3($author$project$Model$Runecorder$applyBuffTick, time, buff, sim)),
							sched);
					case 2:
						var buff = event.a;
						return _Utils_Tuple2(
							A3($author$project$Model$Runecorder$applyBuffTick, time, buff, sim),
							sched);
					default:
						var fat = event.a;
						var sim1 = _Utils_update(
							sim,
							{
								p: A3(
									$elm$core$Dict$update,
									fat.dV,
									$elm$core$Maybe$andThen(
										A2($author$project$Model$Runecorder$expireFatigue, time, fat)),
									sim.p)
							});
						return _Utils_Tuple2(
							sim1,
							function () {
								var _v2 = A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.i;
									},
									A2($elm$core$Dict$get, fat.dV, sim1.p));
								if (_v2.$ === 1) {
									return sched;
								} else {
									return A3(
										$author$project$Scheduler$setTimeout,
										8000,
										$author$project$Model$Runecorder$FatigueExpires(fat),
										sched);
								}
							}());
				}
			}());
	});
var $author$project$Model$Runecorder$run = function (acts) {
	var foldScheduler = F2(
		function (act, _v0) {
			var now0 = _v0.a;
			var sched = _v0.b;
			var now = now0 + $author$project$Model$Runecorder$actionDuration(act);
			return _Utils_Tuple2(
				now,
				A3(
					$author$project$Scheduler$setTimeout,
					now,
					$author$project$Model$Runecorder$ActionCompleted(act),
					sched));
		});
	var scheduler = A3(
		$elm$core$List$foldl,
		foldScheduler,
		_Utils_Tuple2(
			0,
			$author$project$Scheduler$empty(0)),
		acts).b;
	var dur = $elm$core$List$sum(
		A2($elm$core$List$map, $author$project$Model$Runecorder$actionDuration, acts));
	var timeline = A3(
		$author$project$Scheduler$runTimelineUntil,
		dur,
		$author$project$Model$Runecorder$simStep,
		_Utils_Tuple2($author$project$Model$Runecorder$emptySim, scheduler)).a;
	return {
		bz: A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Model$Runecorder$emptySim,
			$elm$core$Tuple$second,
			$elm_community$list_extra$List$Extra$last(timeline)),
		bg: $author$project$Model$Runecorder$emptySim,
		cK: timeline
	};
};
var $author$project$Model$Runecorder$parseAndRun = function (spells) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Runecorder$parse(spells),
		$elm$core$Result$map($author$project$Model$Runecorder$run));
};
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$GameData$latestVersionId = function (g) {
	return $elm$core$List$head(
		$elm$core$List$reverse(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$regex$Regex$contains(
						A2(
							$elm$core$Maybe$withDefault,
							$elm$regex$Regex$never,
							$elm$regex$Regex$fromString('PTR|\\(e\\)'))),
					$elm$core$Basics$not),
				g.cQ)));
};
var $author$project$GameData$latestVersion = function (g) {
	return A2(
		$elm$core$Maybe$andThen,
		function (v) {
			return A2($elm$core$Dict$get, v, g.bs);
		},
		$author$project$GameData$latestVersionId(g));
};
var $author$project$GameData$characterByName = function (_char) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$GameData$latestVersion,
		$elm$core$Maybe$andThen(
			function (version) {
				return A2($elm$core$Dict$get, _char, version.bI);
			}));
};
var $author$project$GameData$spells = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.cD;
	},
	$elm_community$dict_extra$Dict$Extra$fromListBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.z;
			},
			$elm$core$String$toLower)));
var $author$project$GameData$wizardSpells = function (gameData) {
	return A2(
		$elm$core$Maybe$map,
		function (_char) {
			return _Utils_Tuple2(
				_char,
				$author$project$GameData$spells(_char));
		},
		A2($author$project$GameData$characterByName, 'wizard', gameData));
};
var $author$project$Model$runecorderRun = F2(
	function (gameData, model) {
		return _Utils_update(
			model,
			{
				bc: _Utils_Tuple2(
					model.C,
					function () {
						var _v0 = $author$project$GameData$wizardSpells(gameData);
						if (_v0.$ === 1) {
							return $elm$core$Result$Err(_List_Nil);
						} else {
							var _v1 = _v0.a;
							var _char = _v1.a;
							var spells = _v1.b;
							return A2($author$project$Model$Runecorder$parseAndRun, spells, model.C);
						}
					}())
			});
	});
var $elm_explorations$linear_algebra$Math$Vector2$vec2 = _MJS_v2;
var $author$project$Model$init = F3(
	function (flags, loc, urlKey) {
		var route = $author$project$Route$parse(loc);
		var search = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.aM;
			},
			A2($elm$core$Maybe$andThen, $author$project$Route$params, route));
		var src = function () {
			if (((!route.$) && (route.a.$ === 7)) && (!route.a.a.$)) {
				var source = route.a.a.a;
				return source;
			} else {
				return $author$project$Model$Runecorder$example1;
			}
		}();
		var gameData = A2($elm$json$Json$Decode$decodeValue, $author$project$GameData$decoder, flags.dC);
		var _v0 = function () {
			if (gameData.$ === 1) {
				var err = gameData.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						$author$project$Model$GraphError('no graph without gamedata')));
			} else {
				var gd = gameData.a;
				return A2($author$project$Model$parseGraph, gd, route);
			}
		}();
		var graph = _v0.a;
		var error = _v0.b;
		return _Utils_Tuple2(
			function () {
				if (!gameData.$) {
					var gd = gameData.a;
					return $author$project$Model$runecorderRun(gd);
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				{
					ae: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, 0, 0),
					c5: flags.c5,
					aX: $zaboco$elm_draggable$Draggable$init,
					L: error,
					X: $elm$core$Maybe$Nothing,
					av: $author$project$Route$parseFeatures(loc),
					dC: gameData,
					dF: graph,
					Z: route,
					bb: $elm$core$Maybe$Nothing,
					bc: _Utils_Tuple2(
						src,
						$elm$core$Result$Err(_List_Nil)),
					C: src,
					bd: false,
					aN: search,
					cy: $elm$core$Maybe$Just($elm$regex$Regex$never),
					_: search,
					aP: true,
					m: $elm$core$Maybe$Nothing,
					P: $elm$core$Dict$empty,
					aR: $elm$core$Dict$empty,
					H: urlKey,
					fd: flags.fd,
					K: A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						1,
						function (_v2) {
							var _char = _v2.bu;
							var selected = _v2.G;
							return A3(
								$author$project$Model$clampZoom,
								flags.fd,
								_char.dF,
								$elm$core$Set$isEmpty(selected.aO) ? 1 : 0);
						},
						graph)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Model$preprocessCmd,
						A2($author$project$Model$redirectCmd, urlKey, route)
					])));
	});
var $author$project$Model$DragMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Resize = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$SaveFileImport = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$WindowSize = F2(
	function (width, height) {
		return {dG: height, fc: width};
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {cm: pids, cH: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {bA: event, bP: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.cm,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.bP;
		var event = _v0.bA;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.cH);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$saveFileContentRead = _Platform_incomingPort('saveFileContentRead', $elm$json$Json$Decode$value);
var $zaboco$elm_draggable$Internal$DragAt = function (a) {
	return {$: 1, a: a};
};
var $zaboco$elm_draggable$Draggable$Msg = $elm$core$Basics$identity;
var $zaboco$elm_draggable$Internal$StopDragging = {$: 2};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $zaboco$elm_draggable$Internal$Position = F2(
	function (x, y) {
		return {I: x, J: y};
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $zaboco$elm_draggable$Draggable$positionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$zaboco$elm_draggable$Internal$Position,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$truncate,
		A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$truncate,
		A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float)));
var $zaboco$elm_draggable$Draggable$subscriptions = F2(
	function (envelope, _v0) {
		var drag = _v0;
		if (!drag.$) {
			return $elm$core$Platform$Sub$none;
		} else {
			return A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, envelope, $elm$core$Basics$identity),
				$elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2($elm$json$Json$Decode$map, $zaboco$elm_draggable$Internal$DragAt, $zaboco$elm_draggable$Draggable$positionDecoder)),
							$elm$browser$Browser$Events$onMouseUp(
							$elm$json$Json$Decode$succeed($zaboco$elm_draggable$Internal$StopDragging))
						])));
		}
	});
var $author$project$Model$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onResize(
				F2(
					function (w, h) {
						return $author$project$Model$Resize(
							A2($author$project$Model$WindowSize, w, h));
					})),
				A2($zaboco$elm_draggable$Draggable$subscriptions, $author$project$Model$DragMsg, model.aX),
				$author$project$Ports$saveFileContentRead($author$project$Model$SaveFileImport)
			]));
};
var $author$project$Model$CtrlClicking = 3;
var $author$project$Model$Hovering = 0;
var $author$project$Model$Longpressing = 2;
var $author$project$Model$NodeLongPress = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$SaveImportError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$SearchNav = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$SearchRegexError = {$: 0};
var $author$project$Model$Shortpressing = 1;
var $elm_explorations$linear_algebra$Math$Vector2$add = _MJS_v2add;
var $author$project$SaveFile$SaveFile = F3(
	function (hero, build, etherealItemInventory) {
		return {ap: build, X: etherealItemInventory, bH: hero};
	});
var $author$project$SaveFile$EtherealItem = F6(
	function (rarity, iconId, slot, mainStat, uniqueStat, id) {
		return {dI: iconId, z: id, dY: mainStat, eB: rarity, eN: slot, e7: uniqueStat};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$SaveFile$EtherealStat = F5(
	function (calculatedExchangeRate, calculatedValue, gild, id, key) {
		return {c0: calculatedExchangeRate, c1: calculatedValue, dD: gild, z: id, bP: key};
	});
var $author$project$SaveFile$statDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$SaveFile$EtherealStat,
	A2($elm$json$Json$Decode$field, 'calculatedExchangeRate', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'calculatedValue', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'gild', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$SaveFile$itemDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$SaveFile$EtherealItem,
	A2($elm$json$Json$Decode$field, 'rarity', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'iconId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'slot', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['stats', '0']),
		$author$project$SaveFile$statDecoder),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['stats', '1']),
			$author$project$SaveFile$statDecoder)));
var $author$project$SaveFile$inventoryDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$map(
		F2(
			function (k, v) {
				return v(k);
			})),
	$elm$json$Json$Decode$dict($author$project$SaveFile$itemDecoder));
var $author$project$SaveFile$successDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$SaveFile$SaveFile,
	A2($elm$json$Json$Decode$field, 'hero', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'build',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($elm$core$Dict$empty),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'etherealItemInventory', $author$project$SaveFile$inventoryDecoder))));
var $author$project$SaveFile$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		if (status === 'success') {
			return $author$project$SaveFile$successDecoder;
		} else {
			return A2(
				$elm$json$Json$Decode$andThen,
				$elm$json$Json$Decode$fail,
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$Model$OnDragBy = function (a) {
	return {$: 11, a: a};
};
var $zaboco$elm_draggable$Draggable$Config = $elm$core$Basics$identity;
var $zaboco$elm_draggable$Internal$defaultConfig = {
	ei: function (_v0) {
		return $elm$core$Maybe$Nothing;
	},
	ej: function (_v1) {
		return $elm$core$Maybe$Nothing;
	},
	ek: $elm$core$Maybe$Nothing,
	el: function (_v2) {
		return $elm$core$Maybe$Nothing;
	},
	em: function (_v3) {
		return $elm$core$Maybe$Nothing;
	}
};
var $zaboco$elm_draggable$Draggable$basicConfig = function (onDragByListener) {
	var defaultConfig = $zaboco$elm_draggable$Internal$defaultConfig;
	return _Utils_update(
		defaultConfig,
		{
			ej: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, onDragByListener)
		});
};
var $author$project$Model$dragConfig = $zaboco$elm_draggable$Draggable$basicConfig(
	function (_v0) {
		var x = _v0.a;
		var y = _v0.b;
		return $author$project$Model$OnDragBy(
			A2($elm_explorations$linear_algebra$Math$Vector2$vec2, x, y));
	});
var $author$project$Lazy$Evaluated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lazy$evaluate = function (lazyVal) {
	if (!lazyVal.$) {
		var thunk = lazyVal.a;
		return $author$project$Lazy$Evaluated(
			thunk(0));
	} else {
		return lazyVal;
	}
};
var $elm_community$dict_extra$Dict$Extra$find = F2(
	function (predicate, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					if (!acc.$) {
						return acc;
					} else {
						return A2(predicate, k, v) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(k, v)) : $elm$core$Maybe$Nothing;
					}
				}),
			$elm$core$Maybe$Nothing,
			dict);
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$saveFileSelected = _Platform_outgoingPort('saveFileSelected', $elm$json$Json$Encode$string);
var $elm_explorations$linear_algebra$Math$Vector2$scale = _MJS_v2scale;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.cq;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.bD,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.aJ,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.cn,
					_Utils_ap(http, url.bK)),
				url.a7)));
};
var $author$project$Model$transcendNodeIncr = F2(
	function (nodeId, val) {
		return A2(
			$elm$core$Dict$update,
			nodeId,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(1),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$add(val),
					function (v) {
						return (v <= 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(v);
					})));
	});
var $author$project$Model$transcendPerkInput = F2(
	function (id, input) {
		if (input === '') {
			return $elm$core$Dict$remove(id);
		} else {
			var _v0 = $elm$core$String$toInt(input);
			if (_v0.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var val = _v0.a;
				return A2(
					$elm$core$Dict$insert,
					id,
					A2($elm$core$Basics$max, 0, val));
			}
		}
	});
var $zaboco$elm_draggable$Cmd$Extra$message = function (x) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(x));
};
var $zaboco$elm_draggable$Cmd$Extra$optionalMessage = function (msgMaybe) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2($elm$core$Maybe$map, $zaboco$elm_draggable$Cmd$Extra$message, msgMaybe));
};
var $zaboco$elm_draggable$Internal$Dragging = function (a) {
	return {$: 2, a: a};
};
var $zaboco$elm_draggable$Internal$DraggingTentative = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $zaboco$elm_draggable$Internal$distanceTo = F2(
	function (end, start) {
		return _Utils_Tuple2(end.I - start.I, end.J - start.J);
	});
var $zaboco$elm_draggable$Internal$updateAndEmit = F3(
	function (config, msg, drag) {
		var _v0 = _Utils_Tuple2(drag, msg);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var key = _v2.a;
						var initialPosition = _v2.b;
						return _Utils_Tuple2(
							A2($zaboco$elm_draggable$Internal$DraggingTentative, key, initialPosition),
							config.em(key));
					} else {
						break _v0$5;
					}
				case 1:
					switch (_v0.b.$) {
						case 1:
							var _v3 = _v0.a;
							var key = _v3.a;
							var oldPosition = _v3.b;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$Dragging(oldPosition),
								config.el(key));
						case 2:
							var _v4 = _v0.a;
							var key = _v4.a;
							var _v5 = _v0.b;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$NotDragging,
								config.ei(key));
						default:
							break _v0$5;
					}
				default:
					switch (_v0.b.$) {
						case 1:
							var oldPosition = _v0.a.a;
							var newPosition = _v0.b.a;
							return _Utils_Tuple2(
								$zaboco$elm_draggable$Internal$Dragging(newPosition),
								config.ej(
									A2($zaboco$elm_draggable$Internal$distanceTo, newPosition, oldPosition)));
						case 2:
							var _v6 = _v0.b;
							return _Utils_Tuple2($zaboco$elm_draggable$Internal$NotDragging, config.ek);
						default:
							break _v0$5;
					}
			}
		}
		return _Utils_Tuple2(drag, $elm$core$Maybe$Nothing);
	});
var $zaboco$elm_draggable$Draggable$updateDraggable = F3(
	function (_v0, _v1, _v2) {
		var config = _v0;
		var msg = _v1;
		var drag = _v2;
		var _v3 = A3($zaboco$elm_draggable$Internal$updateAndEmit, config, msg, drag);
		var newDrag = _v3.a;
		var newMsgMaybe = _v3.b;
		return _Utils_Tuple2(
			newDrag,
			$zaboco$elm_draggable$Cmd$Extra$optionalMessage(newMsgMaybe));
	});
var $zaboco$elm_draggable$Draggable$update = F3(
	function (config, msg, model) {
		var _v0 = A3($zaboco$elm_draggable$Draggable$updateDraggable, config, msg, model.aX);
		var dragState = _v0.a;
		var dragCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aX: dragState}),
			dragCmd);
	});
var $author$project$Lazy$force = function (lazyVal) {
	if (lazyVal.$ === 1) {
		var val = lazyVal.a;
		return val;
	} else {
		var thunk = lazyVal.a;
		return thunk(0);
	}
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Model$Graph$nodesToBuild = function (graph) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.dX;
		},
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($elm$core$String$fromInt),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$join('&'),
				function (s) {
					return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
				})));
};
var $author$project$Model$Graph$reachableSelectedNodes = F2(
	function (graph, selected) {
		var reachable = A2($author$project$Model$Graph$reachableNodes, graph, selected.aO);
		return $author$project$Model$Graph$createSelected(
			A2(
				$elm$core$List$filter,
				function (n) {
					return A2($elm$core$Set$member, n, reachable);
				},
				selected.dX));
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Model$Graph$removeSelected = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.dX;
		},
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$remove(id),
			$author$project$Model$Graph$createSelected));
};
var $author$project$Model$Dijkstra$selectPathToNode = function (_v0) {
	var prevs = _v0.N;
	var loop = F2(
		function (path, first) {
			loop:
			while (true) {
				var _v1 = A2($elm$core$Dict$get, first, prevs);
				if (_v1.$ === 1) {
					return A2($elm$core$List$cons, first, path);
				} else {
					var next = _v1.a;
					var $temp$path = A2($elm$core$List$cons, first, path),
						$temp$first = next;
					path = $temp$path;
					first = $temp$first;
					continue loop;
				}
			}
		});
	return loop(_List_Nil);
};
var $author$project$Model$updateNode = F2(
	function (id, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (graph, params) {
						var selected = A2($elm$core$Set$member, id, graph.G.aO) ? A2(
							$author$project$Model$Graph$reachableSelectedNodes,
							graph.bu.dF,
							A2($author$project$Model$Graph$removeSelected, id, graph.G)) : $author$project$Model$Graph$createSelected(
							_Utils_ap(
								graph.G.dX,
								A2(
									$elm$core$List$filter,
									function (n) {
										return !A2($elm$core$Set$member, n, graph.G.aO);
									},
									A2(
										$author$project$Model$Dijkstra$selectPathToNode,
										$author$project$Lazy$force(graph.aW),
										id))));
						var route = $author$project$Route$Home(
							_Utils_update(
								params,
								{
									ap: A2($author$project$Model$Graph$nodesToBuild, graph.bu.dF, selected)
								}));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{L: $elm$core$Maybe$Nothing}),
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.H,
								$author$project$Route$stringify(route)));
					}),
				model.dF,
				A2($elm$core$Maybe$andThen, $author$project$Route$params, model.Z)));
	});
var $author$project$Model$Graph$updateOnChange = F2(
	function (_new, old) {
		return _Utils_eq(
			_Utils_Tuple3(_new.ah, _new.bu, _new.G),
			_Utils_Tuple3(old.ah, old.bu, old.G)) ? old : _Utils_update(
			_new,
			{aM: old.aM});
	});
var $author$project$Model$update = F2(
	function (msg, model) {
		var _v0 = model.dC;
		if (_v0.$ === 1) {
			var err = _v0.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var gameData = _v0.a;
			switch (msg.$) {
				case 2:
					var open = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bd: open}),
						$elm$core$Platform$Cmd$none);
				case 0:
					var search0 = msg.a;
					var search = (search0 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(search0);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aN: model._, _: search}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2($author$project$Model$SearchNav, model._, search)),
							$elm$core$Process$sleep(300)));
				case 1:
					var from = msg.a;
					var to = msg.b;
					if (_Utils_eq(model.aN, from)) {
						var _v2 = model.Z;
						if ((!_v2.$) && (_v2.a.$ === 1)) {
							var params = _v2.a.a;
							var searchRegex = A2(
								$elm$core$Maybe$andThen,
								$elm$regex$Regex$fromStringWith(
									{c2: true, d5: true}),
								to);
							var error = function () {
								var _v3 = _Utils_Tuple2(to, searchRegex);
								if (_v3.a.$ === 1) {
									var _v4 = _v3.a;
									return $elm$core$Maybe$Nothing;
								} else {
									if (!_v3.b.$) {
										return $elm$core$Maybe$Nothing;
									} else {
										var _v5 = _v3.b;
										return $elm$core$Maybe$Just($author$project$Model$SearchRegexError);
									}
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										L: error,
										dF: A2(
											$elm$core$Maybe$map,
											function (g) {
												return _Utils_update(
													g,
													{aM: searchRegex});
											},
											model.dF)
									}),
								A2(
									$elm$browser$Browser$Navigation$replaceUrl,
									model.H,
									$author$project$Route$stringify(
										$author$project$Route$Home(
											_Utils_update(
												params,
												{aM: to})))));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 5:
					var id = msg.a;
					return _Utils_eq(
						model.m,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(id, 3))) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								m: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, 0))
							}),
						$elm$core$Platform$Cmd$none);
				case 6:
					var id = msg.a;
					return _Utils_eq(
						model.m,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(id, 3))) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{m: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var id = msg.a;
					var ctrlKey = msg.b;
					var _v6 = model.m;
					if (_v6.$ === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									m: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, 1))
								}),
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									$author$project$Model$NodeLongPress(id)),
								$elm$core$Process$sleep(500)));
					} else {
						var _v7 = _v6.a;
						var tid = _v7.a;
						var state = _v7.b;
						if (!_Utils_eq(id, tid)) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										m: $elm$core$Maybe$Just(
											_Utils_Tuple2(id, 1))
									}),
								A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										$author$project$Model$NodeLongPress(id)),
									$elm$core$Process$sleep(500)));
						} else {
							if (!state) {
								return (model.av.P && ctrlKey) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{
											m: $elm$core$Maybe$Just(
												_Utils_Tuple2(id, 3))
										}),
									$elm$core$Platform$Cmd$none) : A2($author$project$Model$updateNode, id, model);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					}
				case 7:
					var id = msg.a;
					var _v9 = model.m;
					if ((!_v9.$) && (_v9.a.b === 1)) {
						var _v10 = _v9.a;
						var tid = _v10.a;
						var _v11 = _v10.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									m: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, 2))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 4:
					var id = msg.a;
					var _v12 = model.m;
					if (_v12.$ === 1) {
						return A2($author$project$Model$updateNode, id, model);
					} else {
						var _v13 = _v12.a;
						var tid = _v13.a;
						var state = _v13.b;
						if (!_Utils_eq(id, tid)) {
							return A2($author$project$Model$updateNode, id, model);
						} else {
							switch (state) {
								case 0:
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								case 1:
									return A2(
										$author$project$Model$updateNode,
										id,
										_Utils_update(
											model,
											{m: $elm$core$Maybe$Nothing}));
								case 2:
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{m: $elm$core$Maybe$Nothing}),
										$elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					}
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dF: A2(
									$elm$core$Maybe$map,
									function (g) {
										return _Utils_update(
											g,
											{
												aW: $author$project$Lazy$evaluate(g.aW)
											});
									},
									model.dF)
							}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var rawDelta = msg.a;
					var delta = A2($elm_explorations$linear_algebra$Math$Vector2$scale, (-1) / model.K, rawDelta);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ae: A2($elm_explorations$linear_algebra$Math$Vector2$add, delta, model.ae)
							}),
						$elm$core$Platform$Cmd$none);
				case 13:
					var factor = msg.a;
					var newZoom = A2(
						$elm$core$Maybe$withDefault,
						model.K,
						A2(
							$elm$core$Maybe$map,
							function (_v15) {
								var _char = _v15.bu;
								return A3($author$project$Model$clampZoom, model.fd, _char.dF, ((-factor) * 0.01) + model.K);
							},
							model.dF));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{K: newZoom}),
						$elm$core$Platform$Cmd$none);
				case 12:
					var dragMsg = msg.a;
					return A3($zaboco$elm_draggable$Draggable$update, $author$project$Model$dragConfig, dragMsg, model);
				case 15:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aP: !model.aP}),
						$elm$core$Platform$Cmd$none);
				case 18:
					var str = msg.a;
					var cmd = function () {
						var _v16 = model.Z;
						if ((!_v16.$) && (_v16.a.$ === 1)) {
							var params = _v16.a.a;
							return A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.H,
								$author$project$Route$stringify(
									$author$project$Route$Home(
										_Utils_update(
											params,
											{
												ap: $elm$core$Maybe$Just(str)
											}))));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(model, cmd);
				case 16:
					var elemId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$saveFileSelected(elemId));
				case 17:
					var json = msg.a;
					var _v17 = A2($elm$json$Json$Decode$decodeValue, $author$project$SaveFile$decoder, json);
					if (_v17.$ === 1) {
						var err = _v17.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: $elm$core$Maybe$Just(
										$author$project$Model$SaveImportError(
											$elm$json$Json$Decode$errorToString(err))),
									X: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var data = _v17.a;
						var _v18 = A2(
							$elm_community$maybe_extra$Maybe$Extra$orElse,
							$author$project$GameData$latestVersion(gameData),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ah;
								},
								model.dF));
						if (_v18.$ === 1) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										L: $elm$core$Maybe$Just(
											$author$project$Model$SaveImportError('unknown saved game version')),
										X: $elm$core$Maybe$Nothing
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var game = _v18.a;
							var saveHero = A2(
								$elm_community$dict_extra$Dict$Extra$find,
								F2(
									function (k, v) {
										return _Utils_eq(v.aA, data.bH);
									}),
								game.bI);
							var saveBuild = A2($elm$core$String$join, '&', data.ap);
							var cmd = function () {
								if (!saveHero.$) {
									var hero = saveHero.a;
									return A2(
										$elm$browser$Browser$Navigation$pushUrl,
										model.H,
										$author$project$Route$stringify(
											$author$project$Route$Home(
												{
													ap: $elm$core$Maybe$Just(saveBuild),
													bH: hero.a,
													aM: model._,
													e9: game.fa
												})));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										L: $elm$core$Maybe$Nothing,
										X: $elm$core$Maybe$Just(data.X)
									}),
								cmd);
						}
					}
				case 19:
					var line = msg.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Model$runecorderRun,
							gameData,
							_Utils_update(
								model,
								{
									C: (model.C === '') ? line : (model.C + ('\n' + line))
								})),
						$elm$core$Platform$Cmd$none);
				case 20:
					var input = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{C: input}),
						$elm$core$Platform$Cmd$none);
				case 21:
					var val = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bb: val}),
						$elm$core$Platform$Cmd$none);
				case 22:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.H,
							$author$project$Route$stringify(
								$author$project$Route$Runecorder(
									$elm$core$Maybe$Just(model.C)))));
				case 8:
					var req = msg.a;
					if (!req.$) {
						var url = req.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.H,
								$elm$url$Url$toString(url)));
					} else {
						var url = req.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(url));
					}
				case 9:
					var loc = msg.a;
					var route = $author$project$Route$parse(loc);
					var src = function () {
						if (((!route.$) && (route.a.$ === 7)) && (!route.a.a.$)) {
							var source = route.a.a.a;
							return source;
						} else {
							return '';
						}
					}();
					var _v21 = A2($author$project$Model$parseGraph, gameData, route);
					var graph = _v21.a;
					var error = _v21.b;
					return _Utils_Tuple2(
						A2(
							$author$project$Model$runecorderRun,
							gameData,
							_Utils_update(
								model,
								{
									L: error,
									av: $author$project$Route$parseFeatures(loc),
									dF: function () {
										var _v22 = _Utils_Tuple2(graph, model.dF);
										if (!_v22.a.$) {
											if (!_v22.b.$) {
												var _new = _v22.a.a;
												var old = _v22.b.a;
												return $elm$core$Maybe$Just(
													A2($author$project$Model$Graph$updateOnChange, _new, old));
											} else {
												var _new = _v22.a.a;
												var _v23 = _v22.b;
												return $elm$core$Maybe$Just(_new);
											}
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}(),
									Z: route,
									C: src
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Model$preprocessCmd,
									A2($author$project$Model$redirectCmd, model.H, route)
								])));
				case 14:
					var windowSize = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fd: windowSize}),
						$elm$core$Platform$Cmd$none);
				case 23:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: A3($author$project$Model$transcendNodeIncr, id, 1, model.P)
							}),
						$elm$core$Platform$Cmd$none);
				case 24:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								P: A3($author$project$Model$transcendNodeIncr, id, -1, model.P)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					var id = msg.a;
					var str = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aR: A3($author$project$Model$transcendPerkInput, id, str, model.aR)
							}),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$View$gameVersion = F2(
	function (model, gameData) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			$author$project$GameData$latestVersion(gameData),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ah;
				},
				model.dF));
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm_explorations$markdown$Markdown$defaultOptions = {
	bx: $elm$core$Maybe$Nothing,
	dE: $elm$core$Maybe$Just(
		{c_: false, eX: false}),
	eI: true,
	eO: false
};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$View$Changelog$view = $elm_explorations$markdown$Markdown$toHtml(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('changelog')
		]));
var $author$project$View$Debug$view = F2(
	function (model, gameData) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('debug')
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$table = _VirtualDom_node('table');
var $author$project$GameData$tooltip_ = function (node) {
	return A2(
		$elm$core$Maybe$withDefault,
		node.cf,
		A2($elm$core$Maybe$map, $elm$core$Maybe$Just, node.cb));
};
var $author$project$GameData$tooltip = F2(
	function (node, _default) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			$author$project$GameData$tooltip_(node));
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$GameData$Stats$listAt = function (n) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$drop(n),
		$elm$core$List$head);
};
var $author$project$GameData$Stats$listAtDefault = F2(
	function (n, _default) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$GameData$Stats$listAt(n),
			$elm$core$Maybe$withDefault(_default));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$GameData$Stats$calcStat = F3(
	function (stats, stat, intlevel) {
		var level = intlevel;
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$GameData$Stats$statToString(stat),
			stats.cE);
		if (_v0.$ === 1) {
			return 0;
		} else {
			var statValue = _v0.a;
			var _v1 = statValue.bF;
			switch (_v1) {
				case 0:
					return 0;
				case 1:
					var factor = A3($author$project$GameData$Stats$listAtDefault, 0, 1, statValue.s);
					return statValue.aU * A2($elm$core$Basics$pow, factor, level);
				case 2:
					var scale = A3($author$project$GameData$Stats$listAtDefault, 0, 0, statValue.s);
					var base = A3($author$project$GameData$Stats$listAtDefault, 1, statValue.aU, statValue.s);
					return (level * scale) + base;
				case 3:
					var scale = A3($author$project$GameData$Stats$listAtDefault, 0, 0, statValue.s);
					var base = A3($author$project$GameData$Stats$listAtDefault, 1, 0, statValue.s);
					return 1 / ((level * scale) + base);
				case 4:
					var scale = A3($author$project$GameData$Stats$listAtDefault, 0, 0, statValue.s);
					var max = A3($author$project$GameData$Stats$listAtDefault, 2, 1, statValue.s);
					var base = A3($author$project$GameData$Stats$listAtDefault, 1, 0, statValue.s);
					return max * (1 - (1 / ((level * scale) + base)));
				case 5:
					var scale = A3($author$project$GameData$Stats$listAtDefault, 0, 0, statValue.s);
					var max = A3($author$project$GameData$Stats$listAtDefault, 2, 1, statValue.s);
					var base = A3($author$project$GameData$Stats$listAtDefault, 1, 0, statValue.s);
					return 1 + (max * (1 - (1 / ((level * scale) + base))));
				case 6:
					return 0;
				default:
					return 0;
			}
		}
	});
var $author$project$GameData$Stats$calcStats = function (stats) {
	return $elm$core$List$map(
		function (_v0) {
			var stat = _v0.a;
			var level = _v0.b;
			return {
				a0: level,
				eR: stat,
				a: A3($author$project$GameData$Stats$calcStat, stats, stat, level)
			};
		});
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$View$FormatUtil$float = F2(
	function (sigfigs, f) {
		var exp = A2($elm$core$Basics$pow, 10, sigfigs);
		return $elm$core$String$fromFloat(
			$elm$core$Basics$floor(f * exp) / exp);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $author$project$GameData$tooltipPlaceholder = function (node) {
	return A2(
		$elm$core$Maybe$map,
		function (raw) {
			if ($elm$core$List$isEmpty(node.O)) {
				return raw;
			} else {
				var rexp2 = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('\\d+\\.\\d{2}%'));
				var tryp2 = A4(
					$elm$regex$Regex$replaceAtMost,
					$elm$core$List$length(node.O),
					rexp2,
					$elm$core$Basics$always('${VALUE%2}'),
					raw);
				var rexp0 = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('\\d+%'));
				var tryp0 = A4(
					$elm$regex$Regex$replaceAtMost,
					$elm$core$List$length(node.O),
					rexp0,
					$elm$core$Basics$always('${VALUE%0}'),
					raw);
				var rexf2 = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('\\d+\\.\\d\\d'));
				var tryf2 = A4(
					$elm$regex$Regex$replaceAtMost,
					$elm$core$List$length(node.O),
					rexf2,
					$elm$core$Basics$always('${VALUE.2}'),
					raw);
				var rexf0 = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('\\d+'));
				var tryf0 = A4(
					$elm$regex$Regex$replaceAtMost,
					$elm$core$List$length(node.O),
					rexf0,
					$elm$core$Basics$always('${VALUE.0}'),
					raw);
				return (node.bP === 'Ra') ? tryf2 : ((!_Utils_eq(raw, tryp2)) ? tryp2 : ((!_Utils_eq(raw, tryp0)) ? tryp0 : ((!_Utils_eq(raw, tryf2)) ? tryf2 : ((!_Utils_eq(raw, tryf0)) ? tryf0 : raw))));
			}
		},
		$author$project$GameData$tooltip_(node));
};
var $author$project$View$FormatUtil$int = A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $elm$core$Basics$floor);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$View$FormatUtil$pctN = F2(
	function (n, f) {
		return A2($myrho$elm_round$Round$round, n, f * 100) + '%';
	});
var $author$project$GameData$split1 = F2(
	function (glue, str) {
		var _v0 = A2($elm$core$String$split, glue, str);
		if (!_v0.b) {
			return $elm$core$Result$Err(str);
		} else {
			if (!_v0.b.b) {
				var head = _v0.a;
				return $elm$core$Result$Err(str);
			} else {
				var head = _v0.a;
				var tail = _v0.b;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						head,
						A2($elm$core$String$join, glue, tail)));
			}
		}
	});
var $author$project$GameData$tooltipReplace1 = F2(
	function (stat0, tmpl) {
		var stat = function () {
			var _v3 = stat0.eR;
			switch (_v3) {
				case 32:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 35:
					return _Utils_update(
						stat0,
						{a: stat0.a - 6});
				case 33:
					return _Utils_update(
						stat0,
						{a: stat0.a - 5});
				case 36:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 37:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 42:
					return _Utils_update(
						stat0,
						{a: (stat0.a - 60) / 30});
				case 46:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 45:
					return _Utils_update(
						stat0,
						{a: (stat0.a - 60) / 60});
				case 3:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 9:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 38:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 2:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 17:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 14:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 16:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 1:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 23:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 24:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 25:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 26:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 27:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 28:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 29:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 30:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 6:
					return _Utils_update(
						stat0,
						{a: stat0.a - 100});
				case 5:
					return _Utils_update(
						stat0,
						{a: stat0.a - 100});
				case 13:
					return _Utils_update(
						stat0,
						{a: stat0.a - 1});
				case 8:
					return _Utils_update(
						stat0,
						{a: 1 - stat0.a});
				default:
					return stat0;
			}
		}();
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var pred = _v0.a;
					var placeholder = _v0.b;
					var formatter = _v0.c;
					if (pred) {
						var _v1 = A2($author$project$GameData$split1, placeholder, tmpl);
						if (!_v1.$) {
							var _v2 = _v1.a;
							var pre = _v2.a;
							var suf = _v2.b;
							return $elm$core$Maybe$Just(
								_Utils_ap(
									pre,
									_Utils_ap(
										formatter(stat.a),
										suf)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				_List_fromArray(
					[
						_Utils_Tuple3(true, '${VALUE.0}', $author$project$View$FormatUtil$int),
						_Utils_Tuple3(
						true,
						'${VALUE.2}',
						$author$project$View$FormatUtil$float(2)),
						_Utils_Tuple3(
						true,
						'${VALUE%0}',
						$author$project$View$FormatUtil$pctN(0)),
						_Utils_Tuple3(
						true,
						'${VALUE%2}',
						$author$project$View$FormatUtil$pctN(2))
					])));
	});
var $author$project$GameData$tooltipReplace = F2(
	function (stats, tmpl) {
		if (!stats.b) {
			return tmpl;
		} else {
			var stat = stats.a;
			var tail = stats.b;
			var _v1 = A2($author$project$GameData$tooltipReplace1, stat, tmpl);
			if (_v1.$ === 1) {
				return tmpl;
			} else {
				var str = _v1.a;
				return A2($author$project$GameData$tooltipReplace, tail, str);
			}
		}
	});
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$View$DebugTooltip$viewNode = F2(
	function (version, node) {
		var rawTip = A2($author$project$GameData$tooltip, node, '???');
		var placeholderTip = A2(
			$elm$core$Maybe$withDefault,
			'???',
			$author$project$GameData$tooltipPlaceholder(node));
		var nodeStats2 = A2(
			$author$project$GameData$Stats$calcStats,
			version.O,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					$elm$core$Basics$always(2)),
				node.O));
		var replacedTip = A2(
			$author$project$GameData$tooltipReplace,
			nodeStats2,
			A2(
				$elm$core$Maybe$withDefault,
				'???',
				$author$project$GameData$tooltipPlaceholder(node)));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$th,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(node.aA)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(node.bP)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_Utils_eq(rawTip, placeholderTip) ? _List_fromArray(
						[
							$elm$html$Html$text(rawTip)
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(rawTip)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(placeholderTip)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(replacedTip)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (s) {
									return A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$GameData$Stats$statToString(s.eR)),
														$elm$html$Html$text(': ')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('level='),
														$elm$html$Html$text(
														$elm$core$String$fromInt(s.a0))
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('val='),
														$elm$html$Html$text(
														A2($author$project$View$FormatUtil$float, 5, s.a))
													]))
											]));
								},
								nodeStats2))
						]))
				]));
	});
var $author$project$View$DebugTooltip$viewCharacter = F2(
	function (version, _char) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(_char.aA),
					A2(
					$elm$html$Html$table,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$View$DebugTooltip$viewNode(version),
						A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							function (n) {
								return _Utils_Tuple2(
									n.aA,
									A2($author$project$GameData$tooltip, n, '???'));
							},
							A2(
								$elm$core$List$filter,
								function (n) {
									return !$elm$core$List$isEmpty(n.O);
								},
								A2(
									$elm$core$List$filter,
									function (n) {
										return A2($elm$core$Dict$member, n.bP, _char.dF.cd);
									},
									$elm$core$Dict$values(_char.ef))))))
				]));
	});
var $author$project$View$DebugTooltip$view = F2(
	function (model, gameData) {
		var _v0 = $author$project$GameData$latestVersion(gameData);
		if (_v0.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('no gamedata.version')
					]));
		} else {
			var version = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Tooltip text debugging tool'),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$View$DebugTooltip$viewCharacter(version),
							$elm$core$Dict$values(version.bI)))
					]));
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$SaveFile$sourceStatIds = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$indexedMap,
		function (i) {
			return $elm$core$Tuple$pair(
				'Id' + $elm$core$String$fromInt(i));
		},
		_List_fromArray(
			['Gold Received', 'Movement Speed', 'Crit Chance', 'Crit Damage', 'Haste', 'Mana Regen', 'Idle Damage', 'Clickable Gold', 'Click Damage', 'Treasure Chest Chance', 'Monster Gold', 'Item Cost Reduction', 'Total Mana', 'Total Energy', 'Clickable Chance', 'Bonus Gold Chance', 'Treasure Chest Gold', 'Pierce Chance', 'Weapon Damage', 'Helm Damage', 'Chest Damage', 'Ring Damage', 'Pants Damage', 'Gloves Damage', 'Feet Damage', 'Back Damage'])));
var $author$project$SaveFile$sourceStat = function (_v0) {
	var id = _v0.z;
	if (A2($elm$core$String$endsWith, 'ForSkillPoints', id)) {
		return $elm$core$Maybe$Just('SkillPoints');
	} else {
		var _v1 = A2($elm$core$String$split, 'ForTraitLevelsOf', id);
		if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
			var dest = _v1.a;
			var _v2 = _v1.b;
			var src = _v2.a;
			return $elm$core$Maybe$Just(src);
		} else {
			var _v3 = A2($elm$core$String$split, 'ForStatLevelsOf', id);
			if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
				var dest = _v3.a;
				var _v4 = _v3.b;
				var src = _v4.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						src,
						A2($elm$core$Dict$get, src, $author$project$SaveFile$sourceStatIds)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$View$EthItems$viewItem = function (item) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(item.z)
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v0 = item.eN;
						switch (_v0) {
							case 0:
								return 'Weapon';
							case 1:
								return 'Helmet';
							case 2:
								return 'Chest';
							case 3:
								return 'Ring';
							case 4:
								return 'Pants';
							case 5:
								return 'Gloves';
							case 6:
								return 'Feet';
							case 7:
								return 'Back';
							default:
								return $elm$core$String$fromInt(item.eN);
						}
					}())
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(item.eB))
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(item.dY.dD))
				])),
			A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'float', 'right')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = $author$project$SaveFile$sourceStat(item.dY);
					if (_v1.$ === 1) {
						return A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('unknown')
								]));
					} else {
						var src = _v1.a;
						return $elm$html$Html$text(src);
					}
				}()
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('->')
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$elm$core$String$slice,
						0,
						4,
						$elm$core$String$fromFloat(item.dY.c0)))
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($elm$core$String$replace, 'ethereal', '', item.dY.bP))
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromFloat(item.dY.c1))
				])),
			A2(
			$elm$html$Html$td,
			_List_Nil,
			function () {
				var _v2 = item.e7;
				if (_v2.$ === 1) {
					return _List_Nil;
				} else {
					var stat = _v2.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(stat.bP)
						]);
				}
			}())
		]);
};
var $author$project$View$EthItems$view = function (model) {
	var _v0 = model.X;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No ethereal items loaded. Try importing a saved game.')
				]));
	} else {
		var items = _v0.a;
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('item id')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('slot')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('rarity')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('gild')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('stat-src')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('->')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('rate')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('stat-dest')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('total')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('uniqueStat')
								]))
						])),
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$elm$html$Html$tr,
							_List_Nil,
							$author$project$View$EthItems$viewItem(item));
					},
					$elm$core$Dict$values(items))));
	}
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Model$RunecorderInput = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$RunecorderRun = {$: 22};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$View$Runecorder$viewEditor = function (source) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$rows(40),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'margin', '0'),
							A2($elm$html$Html$Attributes$style, 'border', '0'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							$elm$html$Html$Events$onInput($author$project$Model$RunecorderInput),
							$elm$html$Html$Events$onBlur($author$project$Model$RunecorderRun),
							$elm$html$Html$Attributes$value(source)
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Model$RunecorderRun)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Run')
						]))
				]))
		]);
};
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$core$String$lines = _String_lines;
var $author$project$Model$Runecorder$deadEndToSourceLine = F2(
	function (src, deadEnd) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					deadEnd.cv - 1,
					$elm$core$String$lines(src))));
	});
var $author$project$Model$Runecorder$deadEndToString = function (deadEnd) {
	var position = 'row:' + ($elm$core$String$fromInt(deadEnd.cv) + (' col:' + ($elm$core$String$fromInt(deadEnd.c9) + '\n')));
	var _v0 = deadEnd.ez;
	switch (_v0.$) {
		case 0:
			var str = _v0.a;
			return 'Expecting ' + (str + ('at ' + position));
		case 1:
			return 'ExpectingInt at ' + position;
		case 2:
			return 'ExpectingHex at ' + position;
		case 3:
			return 'ExpectingOctal at ' + position;
		case 4:
			return 'ExpectingBinary at ' + position;
		case 5:
			return 'ExpectingFloat at ' + position;
		case 6:
			return 'ExpectingNumber at ' + position;
		case 7:
			return 'ExpectingVariable at ' + position;
		case 8:
			var str = _v0.a;
			return 'ExpectingSymbol ' + (str + (' at ' + position));
		case 9:
			var str = _v0.a;
			return 'ExpectingKeyword ' + (str + ('at ' + position));
		case 10:
			return 'ExpectingEnd at ' + position;
		case 11:
			return 'UnexpectedChar at ' + position;
		case 12:
			var str = _v0.a;
			return str + (' at ' + position);
		default:
			return 'BadRepeat at ' + position;
	}
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Model$Runecorder$isResourceNeutral = function (sim) {
	return (sim.Y >= 0) && ((sim.au >= 0) && A2(
		$elm$core$List$all,
		function (f) {
			return f.i <= 0;
		},
		$elm$core$Dict$values(sim.p)));
};
var $author$project$Model$Runecorder$manaMax = 300;
var $author$project$Model$Runecorder$outOfManaDurationEstimate = function (sim) {
	if (sim.Y >= 0) {
		return $elm$core$Maybe$Nothing;
	} else {
		var cycles = $author$project$Model$Runecorder$manaMax / (-sim.Y);
		return $elm$core$Maybe$Just(
			{
				dg: cycles,
				aY: $elm$core$Basics$ceiling(cycles * sim.aC)
			});
	}
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$View$Runecorder$viewTimestamp = function (time) {
	var s = A2($elm$core$Basics$modBy, 60, (time / 1000) | 0);
	var ms = A2($elm$core$Basics$modBy, 1000, time);
	var m = (time / (1000 * 60)) | 0;
	return function (str) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	}(
		A2(
			$elm$core$String$join,
			':',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var digits = _v0.a;
					var val = _v0.b;
					return A3(
						$elm$core$String$padLeft,
						digits,
						'0',
						$elm$core$String$fromInt(val));
				},
				_List_fromArray(
					[
						_Utils_Tuple2(2, m),
						_Utils_Tuple2(2, s),
						_Utils_Tuple2(4, ms)
					]))));
};
var $author$project$View$Runecorder$viewDuration = $author$project$View$Runecorder$viewTimestamp;
var $elm$html$Html$kbd = _VirtualDom_node('kbd');
var $author$project$View$Runecorder$viewLogEntry = function (_v0) {
	var at = _v0.a.cY;
	var payload = _v0.a.a8;
	var snapshot = _v0.b;
	switch (payload.$) {
		case 0:
			var act = payload.a;
			switch (act.$) {
				case 0:
					var ms = act.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$View$Runecorder$viewTimestamp(at)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Waited '),
									$elm$html$Html$text(
									$elm$core$String$fromFloat(ms / 1000)),
									$elm$html$Html$text(' sec')
								]))
						]);
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$View$Runecorder$viewTimestamp(at)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Clicked')
								]))
						]);
				default:
					var spell = act.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$View$Runecorder$viewTimestamp(at)
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cast '),
									A2(
									$elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(spell.$7)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', 'lightgreen')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$kbd,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												' ',
												A2($elm$core$List$map, $elm$core$String$fromInt, spell.eH)))
										]))
								]))
						]);
			}
		case 1:
			var buff = payload.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'yellow')
						]),
					_List_fromArray(
						[
							$author$project$View$Runecorder$viewTimestamp(at)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', 'yellow')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Expired buff: '),
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(buff.z)
								]))
						]))
				]);
		case 2:
			var buff = payload.a;
			return (buff.z === 'buff:energon') ? _List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$Runecorder$viewTimestamp(at)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Ticked '),
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Energon Cube')
								]))
						]))
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$Runecorder$viewTimestamp(at)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Ticked buff: '),
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(buff.z)
								]))
						]))
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$View$Runecorder$viewResource = F2(
	function (label, n) {
		return (n >= 0) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('+'),
						$elm$html$Html$text(
						$elm$core$String$fromFloat(n)),
						$elm$html$Html$text(label)
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'red')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromFloat(n)),
						$elm$html$Html$text(label)
					]))
			]);
	});
var $author$project$View$Runecorder$viewSimulation = function (sim) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Duration: '),
					$author$project$View$Runecorder$viewTimestamp(sim.bz.aC)
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($author$project$View$Runecorder$viewResource, ' mana', sim.bz.Y)),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($author$project$View$Runecorder$viewResource, ' energy', sim.bz.au)),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (fat) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$author$project$View$Runecorder$viewResource,
							' ' + (fat.dV + ' fatigue'),
							(-1) * A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								0,
								$author$project$Model$Runecorder$fatigueStacks,
								A2($elm$core$Dict$get, fat.dV, sim.bz.p))));
				},
				$author$project$GameData$fatigues)),
			function () {
			if ($author$project$Model$Runecorder$isResourceNeutral(sim.bz)) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'color', 'lightgreen')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('🗹')
								])),
							$elm$html$Html$text(' Resource-neutral, yay! You can safely loop this forever.')
						]));
			} else {
				var _v0 = $author$project$Model$Runecorder$outOfManaDurationEstimate(sim.bz);
				if (!_v0.$) {
					var duration = _v0.a.aY;
					var cycles = _v0.a.dg;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'red')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('🗷'),
								$elm$html$Html$text(' Not resource-neutral! Out of mana in '),
								$author$project$View$Runecorder$viewDuration(duration),
								$elm$html$Html$text(', or about '),
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$elm$core$Basics$floor(cycles))),
								$elm$html$Html$text(' cycles. Try to win before that.')
							]));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', 'red')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('🗷'),
								$elm$html$Html$text(' Not resource-neutral! Be careful looping this for a long time.')
							]));
				}
			}
		}(),
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('runecorder-timeline')
				]),
			A2(
				$elm$core$List$map,
				$elm$html$Html$tr(_List_Nil),
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(_List_Nil),
					A2($elm$core$List$map, $author$project$View$Runecorder$viewLogEntry, sim.cK))))
		]);
};
var $author$project$View$Runecorder$viewSimulationResult = function (_v0) {
	var source = _v0.a;
	var result = _v0.b;
	if (result.$ === 1) {
		if (!result.a.b) {
			return _List_Nil;
		} else {
			var deadEnds = result.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Error')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'list-style-type', 'none')
						]),
					A2(
						$elm$core$List$map,
						function (deadEnd) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$blockquote,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$code,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Model$Runecorder$deadEndToSourceLine, source, deadEnd))
													]))
											])),
										$elm$html$Html$text(
										$author$project$Model$Runecorder$deadEndToString(deadEnd))
									]));
						},
						deadEnds))
				]);
		}
	} else {
		var sim = result.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$View$Runecorder$viewSimulation(sim))
			]);
	}
};
var $author$project$Model$RunecorderAppend = function (a) {
	return {$: 19, a: a};
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$Runecorder$viewSpellEntry = function (s) {
	var lineIf = F2(
		function (b, l) {
			return b ? l : _List_Nil;
		});
	var fats = $author$project$GameData$spellFatigue(s);
	var energy = $elm$core$Basics$round(
		($elm$core$List$length(s.eH) * s.de) * 5);
	var durationSecs = $author$project$Model$Runecorder$duration(s) / 1000;
	var lines = _List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[s.z]),
			A2(
			lineIf,
			durationSecs > 0,
			_List_fromArray(
				[
					'Cast time: ' + ($elm$core$String$fromFloat(durationSecs) + 's')
				])),
			A2(
			lineIf,
			s.b7 > 0,
			_List_fromArray(
				[
					'Mana cost: ' + $elm$core$String$fromInt(s.b7)
				])),
			A2(
			lineIf,
			energy > 0,
			_List_fromArray(
				[
					'Energy cost: ' + $elm$core$String$fromInt(energy)
				])),
			A2(
			lineIf,
			!_Utils_eq(fats, _List_Nil),
			_List_fromArray(
				[
					'Fatigue: ',
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fat = _v0.a;
							var val = _v0.b;
							return $elm$core$String$fromInt(val) + ('× ' + fat.dV);
						},
						fats))
				]))
		]);
	var txt = A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$elm$core$String$join(''),
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(_List_Nil),
				lines)));
	var damage = (A2(
		$elm$core$Basics$pow,
		2,
		$elm$core$List$length(s.eH)) * (25.0 / 4)) * s.dh;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$title(txt),
				$elm$html$Html$Events$onClick(
				$author$project$Model$RunecorderAppend(s.z + ';'))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(s.$7)
			]));
};
var $author$project$View$Runecorder$viewSpellButtons = function (_char) {
	return _List_fromArray(
		[
			$elm$html$Html$text('Insert an action:'),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$RunecorderAppend('click;'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Click')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$RunecorderAppend('wait 3000;'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Wait 3 seconds (3000 millis)')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$RunecorderAppend('loop 3 {\n  // Add some looped actions between the { braces }\n  \n};'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Loop actions 3 times')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$View$Runecorder$viewSpellEntry,
				A2(
					$elm$core$List$filter,
					function (s) {
						return _Utils_eq(
							$elm$core$Set$singleton(7),
							s.cO);
					},
					_char.cD))),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (f) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
							]),
						A2(
							$elm$core$List$map,
							function (b) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[b]));
							},
							A2(
								$elm$core$List$map,
								$author$project$View$Runecorder$viewSpellEntry,
								A2(
									$elm$core$List$filter,
									function (s) {
										return _Utils_eq(
											$elm$core$Set$singleton(f.cj),
											s.cO);
									},
									_char.cD))));
				},
				$author$project$GameData$fatigues)),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$View$Runecorder$viewSpellEntry,
				A2(
					$elm$core$List$filter,
					function (s) {
						return $elm$core$Set$size(s.cO) > 1;
					},
					_char.cD))),
			$elm$html$Html$text('Complete example scripts:'),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Model$RunecorderAppend($author$project$Model$Runecorder$example1))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Resource-neutral Ice1 spam')
						]))
				]))
		]);
};
var $author$project$View$Runecorder$viewBody = F3(
	function (model, _char, spells) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Runecorder planner')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Describe your runecorder plan below. I\'ll output a timeline showing the resources you\'ll spend, what will happen when, and the buttons you\'ll press to record it.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Use the \"insert an action\" buttons below to get started!')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '45%'),
							A2($elm$html$Html$Attributes$style, 'float', 'left'),
							A2($elm$html$Html$Attributes$style, 'padding', '0.5em')
						]),
					_Utils_ap(
						$author$project$View$Runecorder$viewEditor(model.C),
						$author$project$View$Runecorder$viewSpellButtons(_char))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'width', '45%'),
							A2($elm$html$Html$Attributes$style, 'float', 'left'),
							A2($elm$html$Html$Attributes$style, 'padding', '0.5em')
						]),
					$author$project$View$Runecorder$viewSimulationResult(model.bc))
				]));
	});
var $author$project$View$Runecorder$view = F2(
	function (model, gameData) {
		var _v0 = $author$project$GameData$wizardSpells(gameData);
		if (_v0.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('no such hero')
					]));
		} else {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var spells = _v1.b;
			return A3($author$project$View$Runecorder$viewBody, model, _char, spells);
		}
	});
var $author$project$Model$ToggleSidebar = {$: 15};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$View$Spreadsheet$formatCells = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		$elm$core$String$join('\t')),
	$elm$core$String$join('\n'));
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$View$Spreadsheet$formatRows = F2(
	function (model, stats) {
		var counts = A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			function (s) {
				return s.aB.bP;
			},
			stats.aj);
		var rowdata = A2(
			$elm$core$List$concatMap,
			function (node) {
				var _v1 = A2($elm$core$Dict$get, node.bP, counts);
				if (_v1.$ === 1) {
					return _List_fromArray(
						[
							_Utils_Tuple2(node, $elm$core$Maybe$Nothing)
						]);
				} else {
					if (!_v1.a.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(node, $elm$core$Maybe$Nothing)
							]);
					} else {
						var cs = _v1.a;
						return A2(
							$elm$core$List$map,
							function (c) {
								return _Utils_Tuple2(
									node,
									$elm$core$Maybe$Just(c));
							},
							cs);
					}
				}
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.bP;
				},
				$elm$core$Dict$values(stats.bu.ef)));
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var node = _v0.a;
				var statcount = _v0.b;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(node.bP),
							model.av.P ? (node.dx ? $elm$core$Maybe$Just('') : $elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									1,
									function ($) {
										return $.bk;
									},
									statcount)))) : $elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									0,
									function ($) {
										return $.aq;
									},
									statcount))),
							$elm$core$Maybe$Just('\'' + node.aA),
							model.av.P ? (node.dx ? $elm$core$Maybe$Just('FALSE') : $elm$core$Maybe$Just('TRUE')) : $elm$core$Maybe$Nothing
						]));
			},
			rowdata);
	});
var $author$project$View$Spreadsheet$format_ = F3(
	function (url_, model, stats) {
		return $author$project$View$Spreadsheet$formatCells(
			A2(
				$elm$core$List$cons,
				model.av.P ? _List_fromArray(
					['id', 'trnslvl', 'count', 'label', 'is-upgradable', '', 'build planner:', url_]) : _List_fromArray(
					['id', 'count', 'label', '', 'build planner:', url_]),
				A2($author$project$View$Spreadsheet$formatRows, model, stats)));
	});
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $elm_community$list_extra$List$Extra$group = $elm_community$list_extra$List$Extra$groupWhile($elm$core$Basics$eq);
var $author$project$Model$nodeSummary = F2(
	function (m, _v0) {
		var selected = _v0.G;
		var _char = _v0.bu;
		var selectedNodes = A2(
			$elm$core$Dict$map,
			F2(
				function (id, n) {
					return _Utils_Tuple2(
						n.a,
						A2(
							$elm$core$Maybe$withDefault,
							1,
							A2($elm$core$Dict$get, id, m.P)));
				}),
			A2(
				$elm$core$Dict$filter,
				F2(
					function (id, nodeType) {
						return A2($elm$core$Set$member, id, selected.aO);
					}),
				_char.dF.aj));
		return A2(
			$elm$core$List$sortBy,
			function (_v4) {
				var count = _v4.aq;
				var nodeType = _v4.aB;
				return (-1) * (count + function () {
					var _v5 = nodeType.eA;
					switch (_v5) {
						case 2:
							return 1000000;
						case 1:
							return 1000;
						default:
							return 0;
					}
				}());
			},
			A2(
				$elm$core$List$map,
				function (_v2) {
					var _v3 = _v2.a;
					var nodeType = _v3.a;
					var tlvl = _v3.b;
					var tail = _v2.b;
					return {
						aq: $elm$core$List$length(tail) + 1,
						aB: nodeType,
						bk: tlvl
					};
				},
				$elm_community$list_extra$List$Extra$group(
					A2(
						$elm$core$List$sortBy,
						function (_v1) {
							var n = _v1.a;
							var tlvl = _v1.b;
							return _Utils_Tuple2(n.aA, tlvl);
						},
						$elm$core$Dict$values(selectedNodes)))));
	});
var $author$project$GameData$Stats$sumStatLevels = function (stats) {
	var sums = A2(
		$elm$core$Dict$map,
		$elm$core$Basics$always(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($elm$core$Tuple$second),
				$elm$core$List$sum)),
		A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$GameData$Stats$statToString),
			stats));
	return A2(
		$elm$core$List$map,
		function (stat) {
			return _Utils_Tuple2(
				stat,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Dict$get,
						$author$project$GameData$Stats$statToString(stat),
						sums)));
		},
		$author$project$GameData$Stats$statList);
};
var $author$project$GameData$Stats$calcAllStats = function (stats) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$GameData$Stats$sumStatLevels,
		$elm$core$List$map(
			function (_v0) {
				var stat = _v0.a;
				var level = _v0.b;
				return {
					a0: level,
					eR: stat,
					a: A3($author$project$GameData$Stats$calcStat, stats, stat, level)
				};
			}));
};
var $author$project$Model$statsSummary = F2(
	function (m, g) {
		return A2(
			$author$project$GameData$Stats$calcAllStats,
			g.ah.O,
			A2(
				$elm$core$List$concatMap,
				function (s) {
					return A2(
						$elm$core$List$map,
						function (_v0) {
							var stat = _v0.a;
							var level = _v0.b;
							return _Utils_Tuple2(stat, (s.bk * s.aq) * level);
						},
						s.aB.O);
				},
				A2($author$project$Model$nodeSummary, m, g)));
	});
var $author$project$Model$parseStatsSummary = F3(
	function (model, gd, params) {
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				function (m) {
					return {
						bu: m.bu,
						ah: m.ah,
						aj: A2($author$project$Model$nodeSummary, model, m),
						cl: params,
						G: m.G,
						O: A2($author$project$Model$statsSummary, model, m)
					};
				}),
			A2($author$project$Model$Graph$parse, gd, params));
	});
var $author$project$View$Spreadsheet$url = function (params) {
	return 'https://ch2.erosson.org' + $author$project$Route$stringify(
		$author$project$Route$Home(params));
};
var $author$project$View$Spreadsheet$format = F3(
	function (model, gameData, params) {
		var _v0 = A3($author$project$Model$parseStatsSummary, model, gameData, params);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return 'error: ' + err;
		} else {
			var stats = _v0.a;
			return A3(
				$author$project$View$Spreadsheet$format_,
				$author$project$View$Spreadsheet$url(params),
				model,
				stats);
		}
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Route$href = A2($elm$core$Basics$composeR, $author$project$Route$stringify, $elm$html$Html$Attributes$href);
var $author$project$GameData$Stats$statTable = function (stats) {
	var dict = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (s) {
				return _Utils_Tuple2(
					$author$project$GameData$Stats$statToString(s.eR),
					s);
			},
			stats));
	return (!_Utils_eq(
		$elm$core$Dict$size(dict),
		$elm$core$List$length($author$project$GameData$Stats$statList))) ? $elm$core$Basics$always(
		$elm$core$Result$Err(
			'statTable expects a complete list of stats. Expected ' + ($elm$core$String$fromInt(
				$elm$core$List$length($author$project$GameData$Stats$statList)) + (', got ' + $elm$core$String$fromInt(
				$elm$core$Dict$size(dict)))))) : function (stat) {
		return A2(
			$elm$core$Result$fromMaybe,
			'statTable had a complete list of stats, but somehow dict.get missed one',
			A2(
				$elm$core$Dict$get,
				$author$project$GameData$Stats$statToString(stat),
				dict));
	};
};
var $author$project$View$SkillTree$viewError = function (error) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error')
				]),
			function () {
				if (!error.$) {
					var error_ = error.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								switch (error_.$) {
									case 0:
										return 'Search error';
									case 1:
										var err = error_.a;
										return 'Couldn\'t load that saved game: ' + err;
									case 2:
										var err = error_.a;
										return 'Invalid build: ' + err;
									default:
										var err = error_.a;
										return 'Can\'t graph that: ' + err;
								}
							}())
						]);
				} else {
					return _List_Nil;
				}
			}())
		]);
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$feColorMatrix = $elm$svg$Svg$trustedNode('feColorMatrix');
var $elm$svg$Svg$feGaussianBlur = $elm$svg$Svg$trustedNode('feGaussianBlur');
var $elm$svg$Svg$filter = $elm$svg$Svg$trustedNode('filter');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$in_ = _VirtualDom_attribute('in');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Zoom = function (a) {
	return {$: 13, a: a};
};
var $author$project$View$SkillTreeGraph$normalizeMouseZoom = function (deltaY) {
	var speed = 10;
	var normalized = (deltaY < 0) ? (-1) : ((deltaY > 0) ? 1 : 0);
	return $author$project$Model$Zoom(normalized * speed);
};
var $author$project$View$SkillTreeGraph$handleZoom = function () {
	var event = function (dy) {
		return {
			d$: $author$project$View$SkillTreeGraph$normalizeMouseZoom(dy),
			ey: true,
			eU: true
		};
	};
	return A2(
		$elm$virtual_dom$VirtualDom$on,
		'wheel',
		$elm$virtual_dom$VirtualDom$Custom(
			A2(
				$elm$json$Json$Decode$map,
				event,
				A2($elm$json$Json$Decode$field, 'deltaY', $elm$json$Json$Decode$float))));
}();
var $zaboco$elm_draggable$Draggable$alwaysPreventDefaultAndStopPropagation = function (msg) {
	return {d$: msg, ey: true, eU: true};
};
var $zaboco$elm_draggable$Internal$StartDragging = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zaboco$elm_draggable$Draggable$baseDecoder = function (key) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$identity,
			$zaboco$elm_draggable$Internal$StartDragging(key)),
		$zaboco$elm_draggable$Draggable$positionDecoder);
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $zaboco$elm_draggable$Draggable$whenLeftMouseButtonPressed = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			if (!button) {
				return decoder;
			} else {
				return $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
			}
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $zaboco$elm_draggable$Draggable$mouseTrigger = F2(
	function (key, envelope) {
		return A2(
			$elm$html$Html$Events$custom,
			'mousedown',
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $zaboco$elm_draggable$Draggable$alwaysPreventDefaultAndStopPropagation, envelope),
				$zaboco$elm_draggable$Draggable$whenLeftMouseButtonPressed(
					$zaboco$elm_draggable$Draggable$baseDecoder(key))));
	});
var $author$project$View$SkillTreeGraph$inputZoomAndPan = _List_fromArray(
	[
		$author$project$View$SkillTreeGraph$handleZoom,
		A2($zaboco$elm_draggable$Draggable$mouseTrigger, 0, $author$project$Model$DragMsg)
	]);
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$svg$Svg$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$svg$Svg$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $elm$svg$Svg$Attributes$stdDeviation = _VirtualDom_attribute('stdDeviation');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$type_ = _VirtualDom_attribute('type');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $author$project$View$SkillTreeGraph$debug = function (s) {
	return 0;
};
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$View$SkillTreeGraph$isEdgeSelected = F2(
	function (home, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var bSelected = A2($elm$core$Set$member, b.z, home.G.aO);
		var aSelected = A2($elm$core$Set$member, a.z, home.G.aO);
		return aSelected && bSelected;
	});
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$View$SkillTreeGraph$viewEdge = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var startPoint = 'M' + ($elm$core$String$fromInt(a.I) + (' ' + $elm$core$String$fromInt(a.J)));
	var endPoint = 'L' + ($elm$core$String$fromInt(b.I) + (' ' + $elm$core$String$fromInt(b.J)));
	return startPoint + (' ' + endPoint);
};
var $author$project$View$SkillTreeGraph$viewEdges = F2(
	function (selected, home) {
		var _v0 = selected ? _Utils_Tuple2(
			A2(
				$elm$core$List$filter,
				function (e) {
					return A2($author$project$View$SkillTreeGraph$isEdgeSelected, home, e);
				},
				$elm$core$Dict$values(home.bu.dF.at)),
			'edge edge-selected') : _Utils_Tuple2(
			A2(
				$elm_community$list_extra$List$Extra$filterNot,
				function (e) {
					return A2($author$project$View$SkillTreeGraph$isEdgeSelected, home, e);
				},
				$elm$core$Dict$values(home.bu.dF.at)),
			'edge');
		var edges = _v0.a;
		var classes = _v0.b;
		var path = A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $author$project$View$SkillTreeGraph$viewEdge, edges));
		var _v1 = $author$project$View$SkillTreeGraph$debug('redraw edges');
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(classes),
					$elm$svg$Svg$Attributes$d(path)
				]),
			_List_Nil);
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$image = $elm$svg$Svg$trustedNode('image');
var $author$project$View$SkillTreeGraph$appendSearch = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	$elm$core$Basics$append('\n\n'));
var $author$project$View$SkillTreeGraph$nodeSearchText = function (val) {
	return _Utils_ap(
		val.aA,
		_Utils_ap(
			$author$project$View$SkillTreeGraph$appendSearch(
				$elm$core$Maybe$Just(
					A2($author$project$GameData$tooltip, val, ''))),
			$author$project$View$SkillTreeGraph$appendSearch(val.dB)));
};
var $author$project$View$SkillTreeGraph$isNodeHighlighted = F2(
	function (q0, t) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			function (q) {
				return A2(
					$elm$regex$Regex$contains,
					q,
					$author$project$View$SkillTreeGraph$nodeSearchText(t));
			},
			q0);
	});
var $author$project$View$SkillTreeGraph$iconSize = $author$project$Model$nodeIconSize;
var $author$project$View$SkillTreeGraph$nodeBGSize = $author$project$View$SkillTreeGraph$iconSize * 4;
var $author$project$View$Util$nodeBackgroundImage = F2(
	function (node, _v0) {
		var isHighlighted = _v0.dQ;
		var isSelected = _v0.dT;
		var isNeighbor = _v0.dR;
		var suffix = isHighlighted ? 'Highlight' : (isSelected ? ((!node.eA) ? 'SelectedVis' : 'Selected') : (isNeighbor ? 'Next' : ''));
		var quality = function () {
			var _v1 = node.eA;
			switch (_v1) {
				case 2:
					return 'deluxeNode';
				case 1:
					return 'specialNode';
				default:
					return 'generalNode';
			}
		}();
		return './ch2data/node-img/' + (quality + (suffix + '.png?3'));
	});
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $author$project$View$SkillTreeGraph$nodeHighlightGroup = F2(
	function (regex0, t) {
		var find = function (regex) {
			var _v0 = A3(
				$elm$regex$Regex$findAtMost,
				1,
				regex,
				$author$project$View$SkillTreeGraph$nodeSearchText(t));
			if (!_v0.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var submatches = _v0.a.eV;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (_v1) {
									var i = _v1.a;
									var match = _v1.b;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(
											A2($elm$core$Basics$modBy, 6, i)),
										match);
								},
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (a, b) {
											return _Utils_Tuple2(a, b);
										}),
									submatches)))));
			}
		};
		return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Maybe$Nothing, find, regex0);
	});
var $author$project$View$SkillTreeGraph$nodeHighlightClass = F2(
	function (q, t) {
		var _v0 = A2($author$project$View$SkillTreeGraph$nodeHighlightGroup, q, t);
		if (_v0.$ === 1) {
			return 'node-nohighlight';
		} else {
			var i = _v0.a;
			return 'node-highlight node-highlight' + $elm$core$String$fromInt(i);
		}
	});
var $author$project$View$SkillTreeGraph$nodeNeighborClass = F2(
	function (selected, id) {
		return A2($elm$core$Set$member, id, selected) ? 'node-neighbor' : 'node-nonneighbor';
	});
var $author$project$GameData$qualityToString = function (q) {
	switch (q) {
		case 0:
			return 'Plain';
		case 1:
			return 'Notable';
		default:
			return 'Keystone';
	}
};
var $author$project$View$Util$nodeQualityClass = A2(
	$elm$core$Basics$composeR,
	$author$project$GameData$qualityToString,
	$elm$core$Basics$append('node-'));
var $author$project$View$SkillTreeGraph$nodeSelectedClass = F2(
	function (selected, id) {
		return A2($elm$core$Set$member, id, selected.aO) ? 'node-selected' : 'node-noselected';
	});
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$View$SkillTreeGraph$viewNodeBackground = F2(
	function (_v0, _v1) {
		var selected = _v0.G;
		var search = _v0.aM;
		var neighbors = _v0.a4;
		var id = _v1.z;
		var x = _v1.I;
		var y = _v1.J;
		var val = _v1.a;
		return A2(
			$elm$svg$Svg$image,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'node-background',
								A2($author$project$View$SkillTreeGraph$nodeHighlightClass, search, val),
								A2($author$project$View$SkillTreeGraph$nodeSelectedClass, selected, id),
								A2($author$project$View$SkillTreeGraph$nodeNeighborClass, neighbors, id),
								$author$project$View$Util$nodeQualityClass(val.eA)
							]))),
					$elm$svg$Svg$Attributes$xlinkHref(
					A2(
						$author$project$View$Util$nodeBackgroundImage,
						val,
						{
							dQ: A2($author$project$View$SkillTreeGraph$isNodeHighlighted, search, val),
							dR: A2($elm$core$Set$member, id, neighbors),
							dT: A2($elm$core$Set$member, id, selected.aO)
						})),
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromInt(x - (($author$project$View$SkillTreeGraph$nodeBGSize / 2) | 0))),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromInt(y - (($author$project$View$SkillTreeGraph$nodeBGSize / 2) | 0))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt($author$project$View$SkillTreeGraph$nodeBGSize)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt($author$project$View$SkillTreeGraph$nodeBGSize))
				]),
			_List_Nil);
	});
var $author$project$View$SkillTreeGraph$viewNodeBackgrounds = function (home) {
	var _v0 = $author$project$View$SkillTreeGraph$debug('redraw backgrounds');
	return A2(
		$elm$svg$Svg$g,
		_List_Nil,
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$author$project$View$SkillTreeGraph$viewNodeBackground(home),
				$elm$core$Tuple$second),
			$elm$core$Dict$toList(home.bu.dF.aj)));
};
var $author$project$Model$NodeMouseDown = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Model$NodeMouseOut = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$NodeMouseOver = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$NodeMouseUp = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$SkillTreeGraph$ctrlKeyDecoder = A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool);
var $author$project$View$Util$missingIcons = $elm$core$Set$fromList(
	_List_fromArray(
		['', 'autoAttack', 'playIcon', 'pauseIcon', 'MgtEIcon', 'EgtMIcon', 'firstMonsterIcon', 'NMgt90Icon', 'NMlt90Icon']));
var $author$project$View$Util$nodeIconUrl = function (node) {
	var notfound = './ch2data/404.png';
	var _v0 = node.bL;
	if (_v0.$ === 1) {
		return notfound;
	} else {
		var icon = _v0.a;
		return A2($elm$core$Set$member, icon, $author$project$View$Util$missingIcons) ? notfound : ('./ch2data/img/' + (icon + '.png'));
	}
};
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $elm$svg$Svg$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$View$SkillTreeGraph$viewNode = F3(
	function (features, home, _v0) {
		var id = _v0.z;
		var x = _v0.I;
		var y = _v0.J;
		var val = _v0.a;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'node',
								A2($author$project$View$SkillTreeGraph$nodeHighlightClass, home.aM, val),
								A2($author$project$View$SkillTreeGraph$nodeSelectedClass, home.G, id),
								A2($author$project$View$SkillTreeGraph$nodeNeighborClass, home.a4, id),
								$author$project$View$Util$nodeQualityClass(val.eA)
							]))),
					$elm$svg$Svg$Events$onMouseOver(
					$author$project$Model$NodeMouseOver(id)),
					$elm$svg$Svg$Events$onMouseOut(
					$author$project$Model$NodeMouseOut(id)),
					A2(
					$elm$svg$Svg$Events$on,
					'mousedown',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Model$NodeMouseDown(id),
						$author$project$View$SkillTreeGraph$ctrlKeyDecoder)),
					$elm$svg$Svg$Events$onMouseUp(
					$author$project$Model$NodeMouseUp(id)),
					A2(
					$elm$svg$Svg$Events$on,
					'touchStart',
					$elm$json$Json$Decode$succeed(
						A2($author$project$Model$NodeMouseDown, id, false))),
					A2(
					$elm$svg$Svg$Events$on,
					'touchEnd',
					$elm$json$Json$Decode$succeed(
						$author$project$Model$NodeMouseUp(id)))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$elm$svg$Svg$image,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$xlinkHref(
									$author$project$View$Util$nodeIconUrl(val)),
									$elm$svg$Svg$Attributes$x(
									$elm$core$String$fromInt(x - (($author$project$View$SkillTreeGraph$iconSize / 2) | 0))),
									$elm$svg$Svg$Attributes$y(
									$elm$core$String$fromInt(y - (($author$project$View$SkillTreeGraph$iconSize / 2) | 0))),
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromInt($author$project$View$SkillTreeGraph$iconSize)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromInt($author$project$View$SkillTreeGraph$iconSize))
								]),
							_List_Nil)),
						A2(
						$elm$core$Maybe$map,
						function (ord) {
							return A2(
								$elm$svg$Svg$text_,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$class('node-index'),
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromInt(x - (($author$project$View$SkillTreeGraph$iconSize / 2) | 0))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromInt(y - (($author$project$View$SkillTreeGraph$iconSize / 2) | 0)))
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$text(
										$elm$core$String$fromInt(1 + ord))
									]));
						},
						A2($elm$core$Dict$get, id, home.G.dM))
					])));
	});
var $author$project$View$SkillTreeGraph$viewNodes = F2(
	function (features, home) {
		var _v0 = $author$project$View$SkillTreeGraph$debug('redraw nodes');
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					A2($author$project$View$SkillTreeGraph$viewNode, features, home),
					$elm$core$Tuple$second),
				$elm$core$Dict$toList(home.bu.dF.aj)));
	});
var $elm$svg$Svg$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $author$project$View$SkillTreeGraph$viewZoomButton = F3(
	function (_v0, text, msg) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x(
							$elm$core$String$fromInt(x)),
							$elm$svg$Svg$Attributes$y(
							$elm$core$String$fromInt(y)),
							$elm$svg$Svg$Attributes$width('30'),
							$elm$svg$Svg$Attributes$height('30'),
							$elm$svg$Svg$Attributes$rx('5'),
							$elm$svg$Svg$Attributes$ry('5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x(
							$elm$core$String$fromInt(x + 15)),
							$elm$svg$Svg$Attributes$y(
							$elm$core$String$fromInt(y + 15))
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text(text)
						]))
				]));
	});
var $author$project$View$SkillTreeGraph$viewZoomButtons = function (w) {
	return A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('zoom-buttons')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$View$SkillTreeGraph$viewZoomButton,
				_Utils_Tuple2(w.fc - 35, 5),
				'+',
				$author$project$Model$Zoom(-25)),
				A3(
				$author$project$View$SkillTreeGraph$viewZoomButton,
				_Utils_Tuple2(w.fc - 35, 35),
				'-',
				$author$project$Model$Zoom(25))
			]));
};
var $author$project$Model$centerBounds = F2(
	function (w, g) {
		return _Utils_Tuple2(
			A2(
				$elm_explorations$linear_algebra$Math$Vector2$vec2,
				A2(
					$elm$core$Basics$min,
					0,
					($author$project$GameData$graphMinX(g) + (w.fc / 2)) - $author$project$Model$nodeIconSize),
				A2(
					$elm$core$Basics$min,
					0,
					($author$project$GameData$graphMinY(g) + (w.dG / 2)) - $author$project$Model$nodeIconSize)),
			A2(
				$elm_explorations$linear_algebra$Math$Vector2$vec2,
				A2(
					$elm$core$Basics$max,
					0,
					($author$project$GameData$graphMaxX(g) - (w.fc / 2)) + $author$project$Model$nodeIconSize),
				A2(
					$elm$core$Basics$max,
					0,
					($author$project$GameData$graphMaxY(g) - (w.dG / 2)) + $author$project$Model$nodeIconSize)));
	});
var $elm_explorations$linear_algebra$Math$Vector2$getX = _MJS_v2getX;
var $elm_explorations$linear_algebra$Math$Vector2$getY = _MJS_v2getY;
var $author$project$Model$v2Clamp = F3(
	function (minV, maxV, v) {
		return A2(
			$elm_explorations$linear_algebra$Math$Vector2$vec2,
			A3(
				$elm$core$Basics$clamp,
				$elm_explorations$linear_algebra$Math$Vector2$getX(minV),
				$elm_explorations$linear_algebra$Math$Vector2$getX(maxV),
				$elm_explorations$linear_algebra$Math$Vector2$getX(v)),
			A3(
				$elm$core$Basics$clamp,
				$elm_explorations$linear_algebra$Math$Vector2$getY(minV),
				$elm_explorations$linear_algebra$Math$Vector2$getY(maxV),
				$elm_explorations$linear_algebra$Math$Vector2$getY(v)));
	});
var $author$project$Model$zoomedGraphSize = F2(
	function (model, window) {
		return {dG: window.dG / model.K, fc: window.fc / model.K};
	});
var $author$project$Model$clampCenter = F2(
	function (model, _v0) {
		var _char = _v0.bu;
		var _v1 = A2(
			$author$project$Model$centerBounds,
			A2($author$project$Model$zoomedGraphSize, model, model.fd),
			_char.dF);
		var minXY = _v1.a;
		var maxXY = _v1.b;
		return A2($author$project$Model$v2Clamp, minXY, maxXY);
	});
var $author$project$Model$center = F2(
	function (model, home) {
		return A3($author$project$Model$clampCenter, model, home, model.ae);
	});
var $author$project$View$SkillTreeGraph$sidebarWidth = 480;
var $elm_explorations$linear_algebra$Math$Vector2$toRecord = _MJS_v2toRecord;
var $author$project$Model$zoom = F2(
	function (model, _v0) {
		var _char = _v0.bu;
		return A3($author$project$Model$clampZoom, model.fd, _char.dF, model.K);
	});
var $author$project$View$SkillTreeGraph$panOffsets = F2(
	function (model, graph) {
		var _v0 = model.aP ? _Utils_Tuple2(
			{dG: model.fd.dG, fc: model.fd.fc - $author$project$View$SkillTreeGraph$sidebarWidth},
			$author$project$View$SkillTreeGraph$sidebarWidth) : _Utils_Tuple2(model.fd, 0);
		var w = _v0.a;
		var sidebarXOffset = _v0.b;
		var c = $elm_explorations$linear_algebra$Math$Vector2$toRecord(
			A2(
				$author$project$Model$center,
				_Utils_update(
					model,
					{fd: w}),
				graph));
		var zoom = A2(
			$author$project$Model$zoom,
			_Utils_update(
				model,
				{fd: w}),
			graph);
		var _v1 = _Utils_Tuple2(c.I - (((w.fc / 2) + sidebarXOffset) / zoom), c.J - ((w.dG / 2) / zoom));
		var left = _v1.a;
		var top = _v1.b;
		return _Utils_Tuple3(w, -left, -top);
	});
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$View$SkillTreeGraph$zoomAndPan = F2(
	function (model, graph) {
		var _v0 = A2($author$project$View$SkillTreeGraph$panOffsets, model, graph);
		var w = _v0.a;
		var panX = _v0.b;
		var panY = _v0.c;
		var panning = 'translate(' + ($elm$core$String$fromFloat(panX) + (', ' + ($elm$core$String$fromFloat(panY) + ')')));
		var zoom = A2(
			$author$project$Model$zoom,
			_Utils_update(
				model,
				{fd: w}),
			graph);
		var zooming = 'scale(' + ($elm$core$String$fromFloat(zoom) + ')');
		return $elm$svg$Svg$Attributes$transform(zooming + (' ' + panning));
	});
var $author$project$View$SkillTreeGraph$view = F2(
	function (model, graph) {
		return A2(
			$elm$svg$Svg$svg,
			$author$project$View$SkillTreeGraph$inputZoomAndPan,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('edge')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feGaussianBlur,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$in_('SourceGraphic'),
											$elm$svg$Svg$Attributes$stdDeviation('2')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('edgeSelected')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feGaussianBlur,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$in_('SourceGraphic'),
											$elm$svg$Svg$Attributes$stdDeviation('4')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('0')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('180')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('270')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('45')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('225')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$filter,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('highlight5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$feColorMatrix,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$type_('hueRotate'),
											$elm$svg$Svg$Attributes$values('315')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							A2($author$project$View$SkillTreeGraph$zoomAndPan, model, graph)
						]),
					_List_fromArray(
						[
							A3($elm$svg$Svg$Lazy$lazy2, $author$project$View$SkillTreeGraph$viewEdges, false, graph),
							A3($elm$svg$Svg$Lazy$lazy2, $author$project$View$SkillTreeGraph$viewEdges, true, graph),
							A2($elm$svg$Svg$Lazy$lazy, $author$project$View$SkillTreeGraph$viewNodeBackgrounds, graph),
							A3($elm$svg$Svg$Lazy$lazy2, $author$project$View$SkillTreeGraph$viewNodes, model.av, graph)
						])),
					$author$project$View$SkillTreeGraph$viewZoomButtons(model.fd)
				]));
	});
var $author$project$Model$TranscendNodeDowngrade = function (a) {
	return {$: 24, a: a};
};
var $author$project$Model$TranscendNodeUpgrade = function (a) {
	return {$: 23, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$View$SkillTree$viewTooltipTrait = F2(
	function (transcendLevel, _v0) {
		var trait = _v0.a;
		var level0 = _v0.b;
		var name = $author$project$GameData$Stats$statToString(trait);
		var level = level0 * transcendLevel;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name),
					$elm$html$Html$text(': +'),
					$elm$html$Html$text(
					$elm$core$String$fromInt(level))
				]));
	});
var $author$project$View$SkillTree$viewTooltip = F3(
	function (model, graph, node) {
		var transcendLevel = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2($elm$core$Dict$get, node.z, model.P));
		var sidebarOffset = model.aP ? $author$project$View$SkillTreeGraph$sidebarWidth : 0;
		var _v0 = A2($author$project$View$SkillTreeGraph$panOffsets, model, graph);
		var win = _v0.a;
		var panX = _v0.b;
		var panY = _v0.c;
		var zoom = A2(
			$author$project$Model$zoom,
			_Utils_update(
				model,
				{fd: win}),
			graph);
		var _v1 = _Utils_Tuple2((node.I + panX) * zoom, (node.J + panY) * zoom);
		var x = _v1.a;
		var y = _v1.b;
		var _v2 = _Utils_Tuple2(win.fc, win.dG);
		var w = _v2.a;
		var h = _v2.b;
		var style_ = A2(
			$elm$core$List$map,
			function (_v3) {
				var k = _v3.a;
				var v = _v3.b;
				return A2($elm$html$Html$Attributes$style, k, v);
			},
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (n) {
						return $elm$core$String$fromFloat(n) + 'px';
					}),
				_List_fromArray(
					[
						(_Utils_cmp(x, sidebarOffset + (w / 2)) > 0) ? _Utils_Tuple2('right', (sidebarOffset + w) - x) : _Utils_Tuple2('left', x),
						(_Utils_cmp(y, h / 2) > 0) ? _Utils_Tuple2('bottom', h - y) : _Utils_Tuple2('top', y)
					])));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip')
					]),
				style_),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(node.a.aA)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$GameData$tooltip, node.a, ''))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flavor')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', node.a.dB))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flammable')
						]),
					node.a.dx ? _List_fromArray(
						[
							$elm$html$Html$text('Flammable: The effects of this node will be lost when you choose to Ascend or Transcend')
						]) : _List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('node-tooltip-traits')
						]),
					model.av.P ? A2(
						$elm$core$List$map,
						$author$project$View$SkillTree$viewTooltipTrait(transcendLevel),
						node.a.O) : _List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					model.av.P ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							(transcendLevel > 1) ? _List_fromArray(
								[
									$elm$html$Html$text('Level '),
									$elm$html$Html$text(
									$elm$core$String$fromInt(transcendLevel))
								]) : _List_fromArray(
								[
									$elm$html$Html$text('\u00A0')
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							(_Utils_eq(
								model.m,
								$elm$core$Maybe$Just(
									_Utils_Tuple2(node.z, 2))) || _Utils_eq(
								model.m,
								$elm$core$Maybe$Just(
									_Utils_Tuple2(node.z, 3)))) ? (node.a.dx ? _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cannot Upgrade')
										]))
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Model$TranscendNodeUpgrade(node.z))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Upgrade')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Model$TranscendNodeDowngrade(node.z)),
											$elm$html$Html$Attributes$disabled(transcendLevel <= 1)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Downgrade')
										]))
								])) : _List_Nil)
						]) : _List_Nil)
				]));
	});
var $author$project$Model$visibleTooltip = function (_v0) {
	var tooltip = _v0.m;
	_v1$3:
	while (true) {
		if (!tooltip.$) {
			switch (tooltip.a.b) {
				case 0:
					var _v2 = tooltip.a;
					var id = _v2.a;
					var _v3 = _v2.b;
					return $elm$core$Maybe$Just(id);
				case 2:
					var _v4 = tooltip.a;
					var id = _v4.a;
					var _v5 = _v4.b;
					return $elm$core$Maybe$Just(id);
				case 3:
					var _v6 = tooltip.a;
					var id = _v6.a;
					var _v7 = _v6.b;
					return $elm$core$Maybe$Just(id);
				default:
					break _v1$3;
			}
		} else {
			break _v1$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$View$SkillTree$viewGraph = F2(
	function (model, graph) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('svg-container')
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$View$SkillTreeGraph$view, model, graph),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$List$singleton,
						A2($author$project$View$SkillTree$viewTooltip, model, graph)),
					A2(
						$elm$core$Maybe$andThen,
						F2(
							function (b, a) {
								return A2($elm$core$Dict$get, a, b);
							})(graph.bu.dF.aj),
						$author$project$Model$visibleTooltip(model)))));
	});
var $author$project$Model$TextImport = function (a) {
	return {$: 18, a: a};
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$View$SkillTree$viewImportExport = function (params) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('In-game planner import/export:'),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('in-game-import-export'),
									$elm$html$Html$Events$onInput($author$project$Model$TextImport),
									$elm$html$Html$Attributes$value(
									A2($elm$core$Maybe$withDefault, '', params.ap))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('clipboard-button-target'),
									A2($elm$html$Html$Attributes$attribute, 'data-clipboard-target', '#in-game-import-export')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('📋')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('copy this to export, or paste here to import')
								]))
						]))
				]))
		]);
};
var $author$project$Model$SearchHelp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$SearchInput = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$SkillTree$viewSearch = F2(
	function (model, version) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('javascript:void'),
							$elm$html$Html$Events$onClick(
							$author$project$Model$SearchHelp(!model.bd))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search')
						])),
					$elm$html$Html$text(': '),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', model._)),
							$elm$html$Html$Events$onInput($author$project$Model$SearchInput)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					model.bd ? _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Use '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Writing_a_regular_expression_pattern')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('regular expressions')
										])),
									$elm$html$Html$text(' for advanced searches.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('To highlight searches with different colors, (parenthesize) up to 6 groups, separated by |vertical bars|. For example, try a search for:'),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$href('#/g/' + (version + '/helpfulAdventurer?q=(big)|(huge)|(multiclick)|(energize)'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('(big)|(huge)|(multiclick)|(energize)')
														]))
												]))
										]))
								]))
						]) : _List_Nil)
				]));
	});
var $author$project$Model$SaveFileSelected = function (a) {
	return {$: 16, a: a};
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$View$SkillTree$inputSaveSelectId = 'inputSaveSelect';
var $author$project$View$SkillTree$viewSelectSave = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Import build from game save : '),
			A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('file'),
					$elm$html$Html$Attributes$id($author$project$View$SkillTree$inputSaveSelectId),
					A2(
					$elm$html$Html$Events$on,
					'change',
					$elm$json$Json$Decode$succeed(
						$author$project$Model$SaveFileSelected($author$project$View$SkillTree$inputSaveSelectId)))
				]),
			_List_Nil),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('saveSelectHint')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Hint: your save files are probably located in'),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text('C:\\Users\\$USERNAME\\AppData\\Roaming\\ClickerHeroes2\\Local Store\\saves')
				]))
		]));
var $author$project$View$Stats$entryInt = function (stat) {
	return $elm$core$Maybe$Just(
		$author$project$View$FormatUtil$int(stat.a));
};
var $author$project$View$FormatUtil$pct = $author$project$View$FormatUtil$pctN(0);
var $author$project$View$Stats$entryPct = function (stat) {
	return $elm$core$Maybe$Just(
		$author$project$View$FormatUtil$pct(stat.a));
};
var $author$project$View$Stats$entrySecAdd = function (stat) {
	return $elm$core$Maybe$Just(
		$author$project$View$FormatUtil$int(stat.a) + 'sec');
};
var $author$project$View$FormatUtil$sec = F2(
	function (sigfigs, f) {
		return A2($author$project$View$FormatUtil$float, sigfigs, f) + 's';
	});
var $author$project$View$Stats$entrySecDiv = F2(
	function (base, stat) {
		return $elm$core$Maybe$Just(
			A2($author$project$View$FormatUtil$sec, 1, (base / 1000) / stat.a));
	});
var $author$project$View$Stats$cidStatEntrySpecs = _List_fromArray(
	[
		_Utils_Tuple2(
		'Stats',
		_List_fromArray(
			[
				_Utils_Tuple3('Click Damage', 9, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Auto Attack Damage', 32, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Critical Chance', 4, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Critical Damage Multiplier', 3, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Haste', 1, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Gold Received', 2, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Monster Gold', 17, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Bonus Gold Chance (×10)', 7, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Clickable Chance', 19, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Clickable Gold', 14, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Treasure Chest Chance', 15, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Treasure Chest Gold', 16, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Item Cost Reduction', 8, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Total Energy', 5, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('Total Mana', 6, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('Mana Regeneration', 13, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Weapon Damage', 23, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Helmet Damage', 24, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Breastplate Damage', 25, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ring Damage', 26, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Pants Damage', 27, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Gloves Damage', 28, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Boots Damage', 29, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Cape Damage', 30, $author$project$View$Stats$entryPct)
			])),
		_Utils_Tuple2(
		'Traits',
		_List_fromArray(
			[
				_Utils_Tuple3('Increased MultiClicks', 33, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('More Big Clicks', 35, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('Bigger Big Clicks', 36, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Improved Energize', 42, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Huger Huge Click', 37, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Sustained Powersurge', 45, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Mana Crit Damage', 38, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Improved Powersurge', 46, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Reload Energy and Mana', 47, $author$project$View$Stats$entryInt)
			])),
		_Utils_Tuple2(
		'Misc',
		_List_fromArray(
			[
				_Utils_Tuple3(
				'Attack Delay',
				1,
				$author$project$View$Stats$entrySecDiv(600)),
				_Utils_Tuple3(
				'Global Cooldown Time',
				1,
				$author$project$View$Stats$entrySecDiv(2000)),
				_Utils_Tuple3('Automator Speed', 31, $author$project$View$Stats$entryPct)
			]))
	]);
var $author$project$View$Stats$cursorStatEntrySpecs = _List_fromArray(
	[
		_Utils_Tuple2(
		'Ice',
		_List_fromArray(
			[
				_Utils_Tuple3('Ice Spell Cost Reduction', 80, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Damage from Crits', 50, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Damage', 51, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Cool Crits Chance of Critical Hit', 64, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Shatter Damage', 78, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Monsters Effected by Shatter', 79, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('Ice Chance of Crit', 49, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Cool Criticals Duration', 65, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Ice Corrosion Damage', 62, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Chain Chance', 59, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Cold Front Duration', 91, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Cold Front Damage', 90, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Cold Front Chance Per Rank', 89, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Fire Symbiosis Damage', 94, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Lightning Symbiosis Damage', 92, $author$project$View$Stats$entryPct)
			])),
		_Utils_Tuple2(
		'Fire',
		_List_fromArray(
			[
				_Utils_Tuple3('Fire Spell Cost Reduction', 82, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Fire Damage from Crits', 63, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Fire Damage', 57, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Chance of Combustion', 72, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Combustion Duration', 73, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Explosion Damage', 76, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Explosion Damage Dealt to Next Monster', 76, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Fire Additional Damage from Corrosion', 55, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Fire Zap Percent Damage', 60, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Fire Burn Damage', 56, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Heat Burst Duration', 88, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Heat Burst Damage', 87, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Heat Burst Chance Per Rank', 86, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Fire Symbiosis Damage', 94, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Fire Symbiosis Damage', 93, $author$project$View$Stats$entryPct)
			])),
		_Utils_Tuple2(
		'Lightning',
		_List_fromArray(
			[
				_Utils_Tuple3('Lightning Spell Cost Reduction', 81, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Chance of Crit', 58, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Damage', 54, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Flash % Chance of Striking Adtl. Times', 68, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Flash Spell Count', 69, $author$project$View$Stats$entryInt),
				_Utils_Tuple3('Lightning Circuit Damage', 77, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Chain Chance', 53, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Zap Percent Damage', 52, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Burn Damage', 61, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Thunderstorm Duration ', 85, $author$project$View$Stats$entrySecAdd),
				_Utils_Tuple3('Thunderstorm Damage', 84, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Thunderstorm Chance Per Rank', 83, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Ice Lightning Symbiosis Damage', 92, $author$project$View$Stats$entryPct),
				_Utils_Tuple3('Lightning Fire Symbiosis Damage', 93, $author$project$View$Stats$entryPct)
			]))
	]);
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$Stats$statLevelTier = function (level) {
	return (level > 7) ? 'high' : ((level > 3) ? 'mid' : 'low');
};
var $author$project$View$Stats$viewStatEntry = function (_v0) {
	var label = _v0.dV;
	var level = _v0.a0;
	var value = _v0.cP;
	return A2(
		$elm$core$Maybe$map,
		function (val) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						'level-' + $author$project$View$Stats$statLevelTier(level))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label + ': ')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stat-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(val)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stat-level')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' ('),
								$elm$html$Html$text(
								$elm$core$String$fromInt(level)),
								$elm$html$Html$text(')')
							]))
					]));
		},
		value);
};
var $author$project$View$Stats$viewStatsSummary = F2(
	function (_char, getStat) {
		var toEntry = function (_v2) {
			var label = _v2.a;
			var statId = _v2.b;
			var format = _v2.c;
			return A2(
				$elm$core$Result$map,
				function (stat) {
					return {
						dV: label,
						a0: stat.a0,
						cP: format(stat)
					};
				},
				getStat(statId));
		};
		var stats = function () {
			var _v1 = $elm$core$String$toLower(_char.aA);
			if (_v1 === 'wizard') {
				return $author$project$View$Stats$cursorStatEntrySpecs;
			} else {
				return $author$project$View$Stats$cidStatEntrySpecs;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var label = _v0.a;
					var group = _v0.b;
					return A2(
						$elm$html$Html$details,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'open', 'open')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$summary,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats-summary')
									]),
								A2(
									$elm$core$List$filterMap,
									$author$project$View$Stats$viewStatEntry,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Result$toMaybe,
										A2($elm$core$List$map, toEntry, group))))
							]));
				},
				stats));
	});
var $author$project$View$SkillTree$ver = {ay: $author$project$Route$liveVersion, aI: ''};
var $author$project$View$SkillTree$viewVersionNav = F2(
	function (g, q) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Your game version: ' + (g.fa + '. ')),
					_Utils_eq(g.fa, $author$project$View$SkillTree$ver.ay) ? (($author$project$View$SkillTree$ver.aI !== '') ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$Home(
								_Utils_update(
									q,
									{e9: $author$project$View$SkillTree$ver.aI})))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Use PTR: ' + $author$project$View$SkillTree$ver.aI)
						])) : $elm$html$Html$text('')) : A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$Home(
								_Utils_update(
									q,
									{e9: $author$project$View$SkillTree$ver.ay})))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Use live: ' + $author$project$View$SkillTree$ver.ay)
						]))
				]));
	});
var $author$project$View$SkillTree$view = F5(
	function (header, model, gameData, graph, params) {
		var ethItemCount = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $elm$core$Dict$size, model.X);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('skill-tree-main')
				]),
			_List_fromArray(
				[
					A2($author$project$View$SkillTree$viewGraph, model, graph),
					model.aP ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidebar')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidebar-hide'),
										$elm$html$Html$Attributes$title('hide'),
										$elm$html$Html$Events$onClick($author$project$Model$ToggleSidebar)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('<<')
									]))
							]),
						_Utils_ap(
							header,
							_Utils_ap(
								_List_fromArray(
									[$author$project$View$SkillTree$viewSelectSave]),
								_Utils_ap(
									$author$project$View$SkillTree$viewImportExport(params),
									_Utils_ap(
										$author$project$View$SkillTree$viewError(model.L),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(graph.bu.dA + (', ' + graph.bu.dz))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(graph.bu.dy)
													])),
												A2($author$project$View$SkillTree$viewVersionNav, graph.ah, params),
												A2($author$project$View$SkillTree$viewSearch, model, params.e9),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href($author$project$Route$EthItems)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(ethItemCount)),
																$elm$html$Html$text(' ethereal items')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												model.av.P ? _List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$Transcend(params))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Transcension Perks')
															]))
													]) : _List_Nil),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$Stats(params))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Statistics:')
															]))
													])),
												A2(
												$author$project$View$Stats$viewStatsSummary,
												graph.bu,
												$author$project$GameData$Stats$statTable(
													A2($author$project$Model$statsSummary, model, graph))),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$Stats(params))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$elm$core$Set$size(graph.G.aO)) + ' skill points')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$StatsTSV(params))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Spreadsheet format ')
															])),
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('clipboard-button-text'),
																A2(
																$elm$html$Html$Attributes$attribute,
																'data-clipboard-text',
																A3($author$project$View$Spreadsheet$format, model, gameData, params))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('📋')
															]))
													]))
											]))))))) : A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidebar-show'),
							$elm$html$Html$Attributes$title('show'),
							$elm$html$Html$Events$onClick($author$project$Model$ToggleSidebar)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('>>')
						]))
				]));
	});
var $author$project$View$Spreadsheet$formatTranscendNodes = F2(
	function (url_, model) {
		var _v0 = model.dF;
		if (_v0.$ === 1) {
			return $elm$core$Result$Err('no graph');
		} else {
			var _char = _v0.a.bu;
			var selected = _v0.a.G;
			return $elm$core$Result$Ok(
				$author$project$View$Spreadsheet$formatCells(
					A2(
						$elm$core$List$cons,
						_List_fromArray(
							['node-id', 'level', 'is-selected', 'node-type', 'label', '', 'build planner:', url_]),
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(_List_Nil),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var id = _v1.a;
									var level = _v1.b;
									if (level <= 1) {
										return _List_Nil;
									} else {
										var isSelected = A2($elm$core$Set$member, id, selected.aO) ? 'TRUE' : 'FALSE';
										var _v2 = A2($elm$core$Dict$get, id, _char.dF.aj);
										if (_v2.$ === 1) {
											return _List_fromArray(
												[
													$elm$core$String$fromInt(id),
													$elm$core$String$fromInt(level),
													isSelected
												]);
										} else {
											var node = _v2.a;
											return _List_fromArray(
												[
													$elm$core$String$fromInt(id),
													$elm$core$String$fromInt(level),
													isSelected,
													node.a.bP,
													'\'' + node.a.aA
												]);
										}
									}
								},
								$elm$core$Dict$toList(model.P))))));
		}
	});
var $author$project$View$Spreadsheet$view = F3(
	function (model, gameData, params) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spreadsheet')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('help')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Copy the text below ('),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('clipboard-button-target'),
										A2($elm$html$Html$Attributes$attribute, 'data-clipboard-target', '#spreadsheet-export')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('📋 Copy')
									])),
								$elm$html$Html$text(' or click the text box, ctrl+a, ctrl+c), and paste it into your favorite spreadsheet-based Clicker Heroes 2 calculator (ctrl+v).')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('help')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$href('https://docs.google.com/spreadsheets/d/16oUAO0uxAChI0P9rUGNTxCIvlX9wM97ljOcUGf8DXCA')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Writing your own spreadsheet? Here\'s an example showing how to use this.')
									]))
							])),
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('spreadsheet-export'),
								$elm$html$Html$Attributes$class('tsv')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$View$Spreadsheet$format, model, gameData, params))
							]))
					]),
				model.av.P ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Transcended node levels:'),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('clipboard-button-target'),
										A2($elm$html$Html$Attributes$attribute, 'data-clipboard-target', '#spreadsheet-node-level-export')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('📋')
									]))
							])),
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tsv'),
								$elm$html$Html$Attributes$id('spreadsheet-node-level-export')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								function () {
									var _v0 = A2(
										$author$project$View$Spreadsheet$formatTranscendNodes,
										$author$project$View$Spreadsheet$url(params),
										model);
									if (_v0.$ === 1) {
										var err = _v0.a;
										return 'error: ' + err;
									} else {
										var transNodes = _v0.a;
										return transNodes;
									}
								}())
							]))
					]) : _List_Nil));
	});
var $author$project$View$Stats$skillBlacklist = $elm$core$Set$fromList(
	_List_fromArray(
		['Clickdrizzle', 'EnergizeExtend', 'EnergizeRush']));
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$View$Stats$viewNodeSummaryLine = F2(
	function (showTooltips, _v0) {
		var nodeType = _v0.aB;
		var count = _v0.aq;
		var transcendLevel = _v0.bk;
		var tooltip = showTooltips ? $elm$core$Maybe$Just(
			A2($author$project$GameData$tooltip, nodeType, '')) : $elm$core$Maybe$Nothing;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$View$Util$nodeQualityClass(nodeType.eA))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('icon-background'),
									$elm$html$Html$Attributes$src(
									A2(
										$author$project$View$Util$nodeBackgroundImage,
										nodeType,
										{dQ: false, dR: false, dT: false}))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('icon-main'),
									$elm$html$Html$Attributes$src(
									$author$project$View$Util$nodeIconUrl(nodeType))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							' ' + ((count !== 1) ? ($elm$core$String$fromInt(count) + '× ') : '')),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(nodeType.aA)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										$elm$core$Basics$append(': '),
										tooltip))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('clear')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Stats$viewNodeSummary = F2(
	function (showTooltips, ns) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('node-summary')
				]),
			(!$elm$core$List$length(ns)) ? _List_Nil : A2(
				$elm$core$List$map,
				$author$project$View$Stats$viewNodeSummaryLine(showTooltips),
				ns));
	});
var $author$project$Model$Skill$skillVal = F3(
	function (getStat, skill, name) {
		var sname = skill.z + ('_' + name);
		return A2(
			$elm$core$Result$map,
			function ($) {
				return $.a;
			},
			A2(
				$elm$core$Result$andThen,
				getStat,
				A2(
					$elm$core$Result$fromMaybe,
					'no such skill-stat: ' + sname,
					$author$project$GameData$Stats$getStat(sname))));
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Model$Skill$skillValOr = F3(
	function (getStat, skill, _default) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Model$Skill$skillVal, getStat, skill),
			$elm$core$Result$withDefault(_default));
	});
var $author$project$Model$Skill$cooldown = F2(
	function (g, s) {
		var haste = function () {
			var _v0 = g(1);
			if (_v0.$ === 1) {
				return 1;
			} else {
				var h = _v0.a;
				return h.a;
			}
		}();
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$toFloat,
				$elm$core$Basics$mul(
					(A4($author$project$Model$Skill$skillValOr, g, s, 1, 'cooldown') / 1000) / haste)),
			A2($elm$core$Result$fromMaybe, 'no cooldown', s.dc));
	});
var $author$project$Model$Skill$damage = F2(
	function (g, s) {
		return A3($author$project$Model$Skill$skillVal, g, s, 'damage');
	});
var $author$project$Model$Skill$duration = F3(
	function (rules, g, s) {
		var haste = function () {
			if (rules.a$) {
				var _v0 = g(1);
				if (!_v0.$) {
					var h = _v0.a;
					return h.a;
				} else {
					return 1;
				}
			} else {
				return 1;
			}
		}();
		return A2(
			$elm$core$Result$map,
			$elm$core$Basics$mul((1 / 1000) / haste),
			A3($author$project$Model$Skill$skillVal, g, s, 'duration'));
	});
var $author$project$Model$Skill$effect = F2(
	function (g, s) {
		return A3($author$project$Model$Skill$skillVal, g, s, 'effect');
	});
var $author$project$Model$Skill$energyCost = F2(
	function (g, s) {
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$toFloat,
				$elm$core$Basics$add(
					A4($author$project$Model$Skill$skillValOr, g, s, 0, 'energyCost'))),
			A2($elm$core$Result$fromMaybe, 'no energycost', s.dr));
	});
var $author$project$Model$Skill$manaCost = F2(
	function (g, s) {
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$toFloat,
				$elm$core$Basics$mul(
					A4($author$project$Model$Skill$skillValOr, g, s, 1, 'manaCost'))),
			A2($elm$core$Result$fromMaybe, 'no manacost', s.b7));
	});
var $author$project$Model$Skill$stacks = F2(
	function (g, s) {
		return A3($author$project$Model$Skill$skillVal, g, s, 'stacks');
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Model$Skill$uptime = F3(
	function (rules, g, s) {
		return A2(
			$elm$core$Result$map,
			A2($elm$core$Basics$clamp, 0, 1),
			A3(
				$elm$core$Result$map2,
				$elm$core$Basics$fdiv,
				A3($author$project$Model$Skill$duration, rules, g, s),
				A2($author$project$Model$Skill$cooldown, g, s)));
	});
var $author$project$View$Stats$viewSkillSummary = F3(
	function (rules, getStat, skill) {
		var lines = A2(
			$elm$core$List$map,
			function (_v0) {
				var label = _v0.a;
				var tooltip = _v0.b;
				var value = _v0.c;
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stat-line'),
							$elm$html$Html$Attributes$title(tooltip)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stat-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label + ': ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stat-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]));
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Result$toMaybe,
				_List_fromArray(
					[
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$int,
							function (c) {
								return _Utils_Tuple3('Energy Cost', '', c);
							}),
						A2($author$project$Model$Skill$energyCost, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$int,
							function (c) {
								return _Utils_Tuple3('Mana Cost', '', c);
							}),
						A2($author$project$Model$Skill$manaCost, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$sec(1),
							function (c) {
								return _Utils_Tuple3('Cooldown', '', c);
							}),
						A2($author$project$Model$Skill$cooldown, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$sec(1),
							function (c) {
								return _Utils_Tuple3('Duration', '', c);
							}),
						A3($author$project$Model$Skill$duration, rules, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$pct,
							function (c) {
								return _Utils_Tuple3('Uptime', 'Duration / cooldown. The amount of time this buff can be active. 100% means it\'s always active, if you can pay its mana cost.', c);
							}),
						A3($author$project$Model$Skill$uptime, rules, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$pct,
							function (c) {
								return _Utils_Tuple3('Damage', '', c);
							}),
						A2($author$project$Model$Skill$damage, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$int,
							function (c) {
								return _Utils_Tuple3('Stacks', '', c);
							}),
						A2($author$project$Model$Skill$stacks, getStat, skill)),
						A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$View$FormatUtil$pct,
							function (c) {
								return _Utils_Tuple3('Effect', '', c);
							}),
						A2($author$project$Model$Skill$effect, getStat, skill))
					])));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('skill-icon'),
							$elm$html$Html$Attributes$src(
							'./ch2data/img/skills/' + ($elm$core$String$fromInt(skill.dI) + '.png'))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(skill.aA)
						])),
					A2($elm$html$Html$ul, _List_Nil, lines)
				]));
	});
var $author$project$View$Stats$viewSpellSummary = function (s) {
	var lineIf = F2(
		function (b, l) {
			return b ? l : _List_Nil;
		});
	var fats = $author$project$GameData$spellFatigue(s);
	var energy = $elm$core$Basics$round(
		($elm$core$List$length(s.eH) * s.de) * 5);
	var durationSecs = (($elm$core$List$length(s.eH) - 1) * s.d4) / 1000;
	var damage = (A2(
		$elm$core$Basics$pow,
		2,
		$elm$core$List$length(s.eH)) * (25.0 / 4)) * s.dh;
	var lines = _List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[
				$elm$html$Html$text('Runes: '),
				A2(
				$elm$html$Html$kbd,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromInt, s.eH)))
					]))
			]),
			A2(
			lineIf,
			s.dh > 0,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Damage: ×' + $elm$core$String$fromFloat(damage))
				])),
			A2(
			lineIf,
			durationSecs > 0,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Cast time: ' + ($elm$core$String$fromFloat(durationSecs) + 's'))
				])),
			A2(
			lineIf,
			s.b7 > 0,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Mana cost: ' + $elm$core$String$fromInt(s.b7))
				])),
			A2(
			lineIf,
			energy > 0,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Energy cost: ' + $elm$core$String$fromInt(energy))
				])),
			A2(
			lineIf,
			!_Utils_eq(fats, _List_Nil),
			_List_fromArray(
				[
					$elm$html$Html$text('Fatigue: '),
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function (_v0) {
								var fat = _v0.a;
								var val = _v0.b;
								return $elm$core$String$fromInt(val) + ('× ' + fat.dV);
							},
							fats)))
				]))
		]);
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(s.$7)
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$elm$html$Html$li(_List_Nil),
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(_List_Nil),
						lines)))
			]));
};
var $author$project$View$Stats$view = F3(
	function (model, gameData, params) {
		var _v0 = A3($author$project$Model$parseStatsSummary, model, gameData, params);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('error: ' + err)
					]));
		} else {
			var summary = _v0.a;
			var game = summary.ah;
			var _char = summary.bu;
			var selected = summary.G;
			var stats = summary.O;
			var nodes = summary.aj;
			var getStat = $author$project$GameData$Stats$statTable(stats);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$Home(params))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View Skill Tree')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$title('I haven\'t seen an official name for those blue nodes in CH2, so I stole Path of Exile\'s name for nodes like that.')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('⚠ Warning: most of the blue '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('node-Keystone')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Keystone Nodes')
									])),
								$elm$html$Html$text(' have no effect on these stat calculations yet. Work is in progress. Please be patient. (All other nodes should work.)')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats-flex')
							]),
						_List_fromArray(
							[
								_Utils_eq(_char.cD, _List_Nil) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats-box skills-summary')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Skills:')
											])),
										A2(
										$elm$html$Html$ul,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$View$Stats$viewSkillSummary, game.O.eG, getStat),
											A2(
												$elm$core$List$filter,
												function (s) {
													return !A2($elm$core$Set$member, s.z, $author$project$View$Stats$skillBlacklist);
												},
												$elm$core$Dict$values(_char.eM))))
									])) : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats-box spells-summary')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Spells:')
											])),
										A2(
										$elm$html$Html$ul,
										_List_Nil,
										A2($elm$core$List$map, $author$project$View$Stats$viewSpellSummary, _char.cD))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats-box')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Statistics:')
											])),
										A2($author$project$View$Stats$viewStatsSummary, _char, getStat)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats-box')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														$author$project$Route$Home(params))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$elm$core$Set$size(selected.aO)) + ' skill points:')
													])),
												$elm$html$Html$text(' ('),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														$author$project$Route$StatsTSV(params))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('spreadsheet format')
													])),
												$elm$html$Html$text(')')
											])),
										A2($author$project$View$Stats$viewNodeSummary, true, nodes)
									]))
							]))
					]));
		}
	});
var $author$project$View$Transcend$perkLevel = function (perk) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.aR;
		},
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$get(perk.bP),
			$elm$core$Maybe$withDefault(0)));
};
var $author$project$View$Transcend$nextLevelCost = F2(
	function (perk, level) {
		var levelf = level;
		var _v0 = perk.dd;
		_v0$3:
		while (true) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					switch (_v0.a) {
						case 7:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							var cost = _v2.a;
							return (!level) ? $elm$core$Maybe$Just(
								$elm$core$Basics$ceiling(cost)) : $elm$core$Maybe$Nothing;
						case 1:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							var pow = _v4.a;
							return $elm$core$Maybe$Just(
								$elm$core$Basics$ceiling(
									A2($elm$core$Basics$pow, pow, levelf)));
						default:
							break _v0$3;
					}
				} else {
					if (((_v0.a === 6) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						var start = _v6.a;
						var _v7 = _v6.b;
						var scale = _v7.a;
						var _v8 = _v7.b;
						var base = _v8.a;
						return $elm$core$Maybe$Just(
							$elm$core$Basics$ceiling(
								(start + (levelf * scale)) * A2($elm$core$Basics$pow, base, levelf)));
					} else {
						break _v0$3;
					}
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$View$Transcend$totalLevelCost = F2(
	function (perk, level) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$filterMap,
				$author$project$View$Transcend$nextLevelCost(perk),
				A2($elm$core$List$range, 0, level - 1)));
	});
var $erosson$number_suffix$NumberSuffix$roundTo = F3(
	function (rounder, roundExp, val) {
		var roundConst = A2($elm$core$Basics$pow, 10, roundExp);
		return rounder(val * roundConst) / roundConst;
	});
var $erosson$number_suffix$NumberSuffix$countDigits = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$abs,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$logBase(10),
		A2(
			$elm$core$Basics$composeR,
			A2($erosson$number_suffix$NumberSuffix$roundTo, $elm$core$Basics$round, 9),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$floor,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$add(1),
					$elm$core$Basics$max(1))))));
var $erosson$number_suffix$NumberSuffix$dropIntDecimals = function (val) {
	var _v0 = A2($elm$core$String$split, '.', val);
	if (_v0.b && _v0.b.b) {
		var head = _v0.a;
		var _v1 = _v0.b;
		var tail = _v1.a;
		return _Utils_eq(
			tail,
			A2(
				$elm$core$String$repeat,
				$elm$core$String$length(tail),
				'0')) ? head : val;
	} else {
		return val;
	}
};
var $cuducos$elm_format_number$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {dk: decimals, bN: integers, ck: original, a9: prefix, bh: suffix};
	});
var $cuducos$elm_format_number$Parser$Negative = 2;
var $cuducos$elm_format_number$Parser$Positive = 0;
var $cuducos$elm_format_number$Parser$Zero = 1;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $cuducos$elm_format_number$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.bN,
				$elm$core$List$singleton(formatted.dk))));
	return onlyZeros ? 1 : ((formatted.ck < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$Parser$parse = F2(
	function (locale, original) {
		var parts = A2(
			$elm$core$String$split,
			'.',
			A2($myrho$elm_round$Round$round, locale.dk, original));
		var integers = $cuducos$elm_format_number$Parser$splitThousands(
			A2(
				$elm$core$String$filter,
				$elm$core$Char$isDigit,
				A2(
					$elm$core$Maybe$withDefault,
					'0',
					$elm$core$List$head(parts))));
		var decimals = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, parts)));
		var partial = A5($cuducos$elm_format_number$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{a9: locale.d7, bh: locale.d8});
			case 0:
				return _Utils_update(
					partial,
					{a9: locale.ev, bh: locale.ew});
			default:
				return partial;
		}
	});
var $cuducos$elm_format_number$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.dj, decimals);
	});
var $cuducos$elm_format_number$Stringfy$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$Stringfy$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$Stringfy$humanizeDecimals = F3(
	function (locale, strategy, decimals) {
		if ((decimals === '') || _Utils_eq(
			A2($elm$core$String$repeat, locale.dk, '0'),
			decimals)) {
			return '';
		} else {
			if (!strategy) {
				return _Utils_ap(locale.dj, decimals);
			} else {
				return A2(
					$cuducos$elm_format_number$Stringfy$formatDecimals,
					locale,
					$cuducos$elm_format_number$Stringfy$removeZeros(decimals));
			}
		}
	});
var $cuducos$elm_format_number$Stringfy$stringfy = F3(
	function (locale, strategy, formatted) {
		var stringfyDecimals = function () {
			if (!strategy.$) {
				var strategy_ = strategy.a;
				return A2($cuducos$elm_format_number$Stringfy$humanizeDecimals, locale, strategy_);
			} else {
				return $cuducos$elm_format_number$Stringfy$formatDecimals(locale);
			}
		}();
		var integers = A2($elm$core$String$join, locale.e_, formatted.bN);
		var decimals = stringfyDecimals(formatted.dk);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.a9, integers, decimals, formatted.bh]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A3(
			$cuducos$elm_format_number$Stringfy$stringfy,
			locale,
			$elm$core$Maybe$Nothing,
			A2($cuducos$elm_format_number$Parser$parse, locale, number_));
	});
var $erosson$number_suffix$NumberSuffix$formatLocaleSigfigs = F3(
	function (locale, sigfigs, val) {
		var decimals = A2(
			$elm$core$Basics$max,
			0,
			sigfigs - $erosson$number_suffix$NumberSuffix$countDigits(val));
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				locale,
				{dk: decimals}),
			A3($erosson$number_suffix$NumberSuffix$roundTo, $elm$core$Basics$truncate, decimals, val));
	});
var $erosson$number_suffix$NumberSuffix$formatSigExp = F3(
	function (_v0, sig0, exp) {
		var getSuffix = _v0.aw;
		var sigfigs = _v0.bf;
		var locale = _v0.a1;
		var suffixDivisor = _v0.aQ;
		var minSuffix = _v0.a3;
		var sig = sig0 * A2(
			$elm$core$Basics$pow,
			10,
			$elm$core$Basics$abs(exp) % suffixDivisor);
		var n = sig0 * A2($elm$core$Basics$pow, 10, exp);
		var formatLocale = A2($erosson$number_suffix$NumberSuffix$formatLocaleSigfigs, locale, sigfigs);
		return (_Utils_cmp(
			$elm$core$Basics$abs(n),
			minSuffix) < 0) ? $erosson$number_suffix$NumberSuffix$dropIntDecimals(
			formatLocale(n)) : _Utils_ap(
			formatLocale(sig),
			getSuffix(exp));
	});
var $erosson$number_suffix$NumberSuffix$format = F2(
	function (config, n) {
		var exp = $erosson$number_suffix$NumberSuffix$countDigits(n) - 1;
		var sig = n / A2($elm$core$Basics$pow, 10, exp);
		return A3($erosson$number_suffix$NumberSuffix$formatSigExp, config, sig, exp);
	});
var $erosson$number_suffix$NumberSuffix$formatInt = function (config) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$toFloat,
		$erosson$number_suffix$NumberSuffix$format(config));
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $erosson$number_suffix$NumberSuffix$suffixEngineering = function (digits) {
	return (digits <= 3) ? '' : ('E' + $elm$core$String$fromInt(((digits / 3) | 0) * 3));
};
var $erosson$number_suffix$NumberSuffix$getListSuffix = F2(
	function (suffixes, digits) {
		var _v0 = A2($elm$core$Array$get, (digits / 3) | 0, suffixes);
		if (!_v0.$) {
			var s = _v0.a;
			return s;
		} else {
			return $erosson$number_suffix$NumberSuffix$suffixEngineering(digits);
		}
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{k: nodeList, g: nodeListSize, j: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $erosson$number_suffix$NumberSuffixData$standard = $elm$core$Array$fromList(
	_List_fromArray(
		['', ' thousand', ' million', ' billion', ' trillion', ' quadrillion', ' quintillion', ' sextillion', ' septillion', ' octillion', ' nonillion', ' decillion', ' undecillion', ' duodecillion', ' tredecillion', ' quattuordecillion', ' quinquadecillion', ' sedecillion', ' septendecillion', ' octodecillion', ' novendecillion', ' vigintillion', ' unvigintillion', ' duovigintillion', ' tresvigintillion', ' quattuorvigintillion', ' quinquavigintillion', ' sesvigintillion', ' septemvigintillion', ' octovigintillion', ' novemvigintillion', ' trigintillion', ' untrigintillion', ' duotrigintillion', ' trestrigintillion', ' quattuortrigintillion', ' quinquatrigintillion', ' sestrigintillion', ' septentrigintillion', ' octotrigintillion', ' noventrigintillion', ' quadragintillion', ' unquadragintillion', ' duoquadragintillion', ' tresquadragintillion', ' quattuorquadragintillion', ' quinquaquadragintillion', ' sesquadragintillion', ' septenquadragintillion', ' octoquadragintillion', ' novenquadragintillion', ' quinquagintillion', ' unquinquagintillion', ' duoquinquagintillion', ' tresquinquagintillion', ' quattuorquinquagintillion', ' quinquaquinquagintillion', ' sesquinquagintillion', ' septenquinquagintillion', ' octoquinquagintillion', ' novenquinquagintillion', ' sexagintillion', ' unsexagintillion', ' duosexagintillion', ' tresexagintillion', ' quattuorsexagintillion', ' quinquasexagintillion', ' sesexagintillion', ' septensexagintillion', ' octosexagintillion', ' novensexagintillion', ' septuagintillion', ' unseptuagintillion', ' duoseptuagintillion', ' treseptuagintillion', ' quattuorseptuagintillion', ' quinquaseptuagintillion', ' seseptuagintillion', ' septenseptuagintillion', ' octoseptuagintillion', ' novenseptuagintillion', ' octogintillion', ' unoctogintillion', ' duooctogintillion']));
var $erosson$number_suffix$NumberSuffix$suffixStandard = $erosson$number_suffix$NumberSuffix$getListSuffix($erosson$number_suffix$NumberSuffixData$standard);
var $cuducos$elm_format_number$FormatNumber$Locales$Locale = F7(
	function (decimals, thousandSeparator, decimalSeparator, negativePrefix, negativeSuffix, positivePrefix, positiveSuffix) {
		return {dj: decimalSeparator, dk: decimals, d7: negativePrefix, d8: negativeSuffix, ev: positivePrefix, ew: positiveSuffix, e_: thousandSeparator};
	});
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = A7($cuducos$elm_format_number$FormatNumber$Locales$Locale, 2, ',', '.', '−', '', '', '');
var $erosson$number_suffix$NumberSuffix$standardConfig = {
	aw: $erosson$number_suffix$NumberSuffix$suffixStandard,
	a1: _Utils_update(
		$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
		{d7: '-'}),
	a3: 100000,
	bf: 3,
	aQ: 3
};
var $author$project$View$Transcend$formatInt = $erosson$number_suffix$NumberSuffix$formatInt($erosson$number_suffix$NumberSuffix$standardConfig);
var $author$project$View$Transcend$viewInt = A2($elm$core$Basics$composeL, $elm$html$Html$text, $author$project$View$Transcend$formatInt);
var $author$project$View$Transcend$viewHeader = F4(
	function (header, params, _v0, perks) {
		var game = _v0.ah;
		var _char = _v0.bu;
		var totalCost = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var p = _v1.a;
					var lvl = _v1.b;
					return A2($author$project$View$Transcend$totalLevelCost, p.O, lvl);
				},
				perks));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('transcend-perks-header')
				]),
			_List_fromArray(
				[
					header,
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									$author$project$Route$Home(params))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Skill Tree')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$View$Transcend$viewInt(totalCost),
							$elm$html$Html$text(' hero souls spent')
						]))
				]));
	});
var $author$project$Model$TranscendPerkInput = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$GameData$Stats$growthToString = function (g) {
	switch (g) {
		case 0:
			return 'Noop';
		case 1:
			return 'ExponentialMultiplier';
		case 2:
			return 'Linear';
		case 3:
			return 'LinearReciprocal';
		case 4:
			return 'LinearReciprocalComplement';
		case 5:
			return 'OnePlusLinearReciprocalComplement';
		case 6:
			return 'LinearExponential';
		default:
			return 'Constant';
	}
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$View$Transcend$viewPerk = F3(
	function (params, _v0, _v1) {
		var game = _v0.ah;
		var _char = _v0.bu;
		var perk = _v1.a;
		var level = _v1.b;
		var _v2 = perk.O.dd;
		var g = _v2.a;
		var ga = _v2.b;
		var debugText = A2(
			$elm$core$String$join,
			'\n',
			_Utils_ap(
				_List_fromArray(
					[
						'cost: ' + ($author$project$GameData$Stats$growthToString(g) + ('(' + (A2(
						$elm$core$String$join,
						', ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, ga)) + ')')))
					]),
				function () {
					var _v3 = perk.O.e5;
					if (_v3.$ === 1) {
						return _List_Nil;
					} else {
						var t = _v3.a;
						return _List_fromArray(
							['trait: ' + t]);
					}
				}()));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('transcend-perk-level')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('number'),
									$elm$html$Html$Attributes$min('0'),
									$elm$html$Html$Attributes$max('6666'),
									$elm$html$Html$Events$onInput(
									$author$project$Model$TranscendPerkInput(perk.bP)),
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(level))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('transcend-perk-body'),
							$elm$html$Html$Attributes$title(debugText)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(perk.ar.aA)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(perk.ar.by)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cost')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$join,
										'; ',
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$map,
													function (c) {
														return $author$project$View$Transcend$formatInt(c) + ' souls for next level';
													},
													A2($author$project$View$Transcend$nextLevelCost, perk.O, level)),
													function () {
													var c = A2($author$project$View$Transcend$totalLevelCost, perk.O, level);
													return (c <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
														$author$project$View$Transcend$formatInt(c) + ' souls spent');
												}()
												]))))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'clear', 'left')
						]),
					_List_Nil)
				]));
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$View$Transcend$zipPerks = F3(
	function (_char, params, game) {
		var _v0 = A2($elm$core$Dict$get, params.bH, game.O.c6);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err('no char stats');
		} else {
			var charStats = _v0.a;
			return $elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var data = _v1.b;
						var _v2 = A2($elm$core$Dict$get, key, charStats.e6);
						if (_v2.$ === 1) {
							return $elm$core$Result$Err(
								'no such perk: ' + $elm$core$String$fromInt(key));
						} else {
							var s = _v2.a;
							return $elm$core$Result$Ok(
								{ar: data, bP: key, O: s});
						}
					},
					$elm$core$Dict$toList(_char.e6)));
		}
	});
var $author$project$View$Transcend$view = F4(
	function (header, model, gameData, params) {
		var _v0 = _Utils_Tuple2(model.dF, model.L);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var err = _v0.b.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('???no graph???')
						]));
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('???no graph???')
						]));
			}
		} else {
			var graph = _v0.a.a;
			var _v4 = A3($author$project$View$Transcend$zipPerks, graph.bu, params, graph.ah);
			if (_v4.$ === 1) {
				var err = _v4.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(err)
						]));
			} else {
				var perks = _v4.a;
				var perkLevels = A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_Tuple2(
							p,
							A2($author$project$View$Transcend$perkLevel, p, model));
					},
					perks);
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$View$Transcend$viewHeader, header, params, graph, perkLevels),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('transcend-perks')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$View$Transcend$viewPerk, params, graph),
								perkLevels))
						]));
			}
		}
	});
var $author$project$Route$defaultParams = function (version) {
	return {ap: $elm$core$Maybe$Nothing, bH: $author$project$Route$defaultHero, aM: $elm$core$Maybe$Nothing, e9: version};
};
var $author$project$View$viewNavEntry = F2(
	function (txt, route) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(route)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]));
	});
var $author$project$View$viewCharacterNavEntry = F3(
	function (version, key, _char) {
		var q = $author$project$Route$defaultParams(version);
		return A2(
			$author$project$View$viewNavEntry,
			_char.dz,
			$author$project$Route$Home(
				_Utils_update(
					q,
					{bH: key})));
	});
var $author$project$View$viewCharacterNav = function (g) {
	return A2(
		$elm$core$List$map,
		F2(
			function (f, _v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2(f, a, b);
			})(
			$author$project$View$viewCharacterNavEntry(g.fa)),
		$elm$core$Dict$toList(g.bI));
};
var $author$project$View$viewBody = function (model) {
	var _v0 = model.dC;
	if (_v0.$ === 1) {
		var err = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('error parsing gameData: '),
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$json$Json$Decode$errorToString(err))
						]))
				]));
	} else {
		var gameData = _v0.a;
		var header = _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Clicker Heroes 2 Skill Tree Planner')
					])),
				A2(
				$elm$html$Html$nav,
				_List_Nil,
				_Utils_ap(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						$author$project$View$viewCharacterNav,
						A2($author$project$View$gameVersion, model, gameData)),
					_List_fromArray(
						[
							A2($author$project$View$viewNavEntry, 'Changelog', $author$project$Route$Changelog),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://github.com/erosson/ch2plan'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Source code')
								]))
						])))
			]);
		var _v1 = model.Z;
		if (_v1.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_Utils_ap(
					header,
					_List_fromArray(
						[
							$elm$html$Html$text('404')
						])));
		} else {
			var route = _v1.a;
			switch (route.$) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('loading...')
							]));
				case 1:
					var home = route.a;
					var _v3 = model.dF;
					if (_v3.$ === 1) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_Utils_ap(
								header,
								_List_fromArray(
									[
										$elm$html$Html$text('404')
									])));
					} else {
						var graph = _v3.a;
						return A5($author$project$View$SkillTree$view, header, model, gameData, graph, home);
					}
				case 2:
					var params = route.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									A3($author$project$View$Stats$view, model, gameData, params)
								])));
				case 3:
					var params = route.a;
					return A3($author$project$View$Spreadsheet$view, model, gameData, params);
				case 4:
					var params = route.a;
					return A4(
						$author$project$View$Transcend$view,
						A2($elm$html$Html$div, _List_Nil, header),
						model,
						gameData,
						params);
				case 5:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									$author$project$View$EthItems$view(model)
								])));
				case 6:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									$author$project$View$Changelog$view(model.c5)
								])));
				case 7:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									A2($author$project$View$Runecorder$view, model, gameData)
								])));
				case 8:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									A2($author$project$View$Debug$view, model, gameData)
								])));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							header,
							_List_fromArray(
								[
									A2($author$project$View$DebugTooltip$view, model, gameData)
								])));
			}
		}
	}
};
var $author$project$View$view = function (model) {
	return {
		cZ: _List_fromArray(
			[
				$author$project$View$viewBody(model)
			]),
		e3: 'Clicker Heroes 2 Skill Tree Planner'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{dN: $author$project$Model$init, en: $author$project$Model$NavLocation, eo: $author$project$Model$NavRequest, eW: $author$project$Model$subscriptions, e8: $author$project$Model$update, fb: $author$project$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (windowSize) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (gameData) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (changelog) {
							return $elm$json$Json$Decode$succeed(
								{c5: changelog, dC: gameData, fd: windowSize});
						},
						A2($elm$json$Json$Decode$field, 'changelog', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'gameData', $elm$json$Json$Decode$value));
		},
		A2(
			$elm$json$Json$Decode$field,
			'windowSize',
			A2(
				$elm$json$Json$Decode$andThen,
				function (width) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (height) {
							return $elm$json$Json$Decode$succeed(
								{dG: height, fc: width});
						},
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)))))(0)}});}(this));